import { fields } from "@/components";

const en_resource = {
  navbar: {
    home: "Home",
    dashboard: "Dashboard",
    quotes: "Quotes",
    document: "Document",
    user: "User",
    login: "Login",
    logout: "Logout",
  },
  dashboard: {
    name: "Dashboard",
    title: "Your Apps",
    subtitle: "Install or add more apps to your library",
  },
  quotes: {
    name: "Quotes",
    title: "This is the quotes dashboard",
    quote_page: "This is Quotes page",
  },
  user: {
    name: "Users",
    title: "This is USER module",
    user: {
      title: "Users",
      add_new_user: "New User",
      edit_user: "Edit User",
      view_user: "View User",
      change_password: "Change Password",
      add_access: "Add Access",
      resend_invite_email: "Resend Invite Mail",
      clone_user: "Clone User",
      deactivate: "Deactivate",
      activate: "Activate",
      account: "Account",
      heading: "No Users Added",
      subheading: "Start by adding your first user for smoother team collaboration.",
      msg: {
        endtime_msg: "End Time must be later than Start Time when Start Date and End Date are the same.",
        schedule_msg: "Implement scheduled login restrictions to enhance ERP security by controlling user access hours for improved data protection",
        login_restriction_msg: "Enable daily login restrictions and set time limits for when user access the system.",
        help_msg: "You can help",
        reset_password_msg: "reset their password by emailing instructions to",
        account_access_error_msg: "This account will no longer have access to any module. You can restore access at any time.",
        account_access_success_msg: "This account will have access to all modules. You can revoke access at any time.",
        remove_user_msg: "Are you sure you want to remove user",
        no_resources_msg: "No resources available",
        delete_success_msg: "User deleted successfully",
        grant_access_msg: "Grant access to enable this user to retrieve data from multiple branches."
      },
      fields: {
        login_restriction_label: "Time Based Login Restriction",
        start_time_label: "Start Time",
        end_time_label: "End Time",
        access_type_label: "Repeat",
        access_type_placeholder: "Select Access Type",
        select_days_label: "Select Days",
        interval_days_label: "Repeat every",
        interval_days_placeholder: "Interval Days",
        frequency_label: "On The",
        frequency_placeholder: "Frequency",
        repeat_days_placeholder: "Select Weekday",
        of_label: "of",
        repeat_month_placeholder: "Select Month",
        end_date_label: "End Date",
        never_end_label: "Never End",
        name_label: "Name",
        email_label: "Email",
        phone_no_label: "Phone No",
        role_label: "Role",
        country_label: "Country",
        branch_label: "Branch",
        location_label: "Location",
        company_label: "Company",
        repeat_label: "Repeat",
        module_placeholder: "Select Module",
        submodule_placeholder: "Sub Module",
        resources_label: "Resources",
        comment_title: "Write comments",
        comment_placeholder: "Type a reply / Comment"
      },
      accessControl: {
        title: "Access Control",
        access_type_label: "Access Type",
        access_type_placeholder: "Select Type",
        access_label: "Access",
        action_label: "Action",
        add_access_label: "Add Access",
        add_policy_label: "Add policy",
        add_access_type_label: "Add Access Type",
        added_access_label: "Added Access"
      },
      table: {
        id_header: "ID",
        first_name_header: "First Name",
        last_name_header: "Last Name",
        email_header: "Email",
        phone_header: "Phone",
        access_type_label: "Access Type",
        access_label: "Access",
        resource_id_label: "Resource Id",
        resource_code_label: "Resource Code",
        created_by_label: "Created By"
      },
      buttons: {
        reset_password: "Reset Password",
        email_instuctions: "Email Instructions",
        manage_user_account: "Manage User Account"
      },
      tabs: {
        general_details: "General Details",
        permissions: "Permissions",
        access: "Access"
      }
    },
    role: {
      title: "Roles",
      new_role: "New Role",
      edit_role: "Edit Role",
      duplicate_role: "Duplicate Role",
      delete_role: "Delete Role",
      heading: "No Roles Added",
      subheading: "Start by adding your first role for smoother team collaboration.",
      fields: {
        role_label: "Role",
        role_placeholder: "Role",
        role_type_label: "Role Type",
        role_type_placeholder: "Select Role Type",
        modules_label: "Modules",
        modules_placeholder: "Add Modules",
        submodules_label: "Sub Modules",
        submodules_placeholder: "Add Sub-Modules",
        search_modules_placeholder: "Search Modules",
        resource_placeholder: "Search Resources",
        delete_resource_label: "Delete Resource",
        discard_changes_label: "Discard unsaved changes",
        continue_editing_label: "Continue editing",
        created_on_label: "Created on",
        name_label: "Name"
      },
      msg: {
        delete_resource_msg: "Are you sure you want to delete this resource ?",
        removed_msg: "has been removed",
        discard_changes_msg: "If you discard changes, you’ll delete any edits you made since you last saved",
        no_resources_msg: "No resources available",
        no_submodule_msg: "No sub-modules have choosen"
      },
      policyModal: {
        edit_policy: "Edit Policy",
        add_policy: "Add Policy",
        resource_label: "Resource",
        attributes_label: "Attributes",
        not_allowed_attributes_label: "Not Allowed Attributes",
        not_allowed_attributes_placeholder: "Not Allowed Attributes",
        filters_label: "Filters",
        not_allowed_filters_label: "Not Allowed Filters",
        not_allowed_filters_placeholder: "Not Allowed Filters",
        search_resource_placeholder: "Search Resources",
        added_resources_label: "Added Resources"
      },
      table: {
        role_header: "Role",
        role_type_header: "Role Type",
        date_created_header: "Date Created",
        resource_id_label: "Resource Id",
        resource_code_label: "Resource Code",
        created_by_label: "Created By",
        policy_label: "Policy"
      }
    },
    language: {
      name: "Language",
      title: "Languages",
      add_label: "Add New Language",
      edit_label: "Edit Language",
      msg: {
        languageApproved: "Languages has been approved successfully.",
        languageRejected: "Languages has been rejected successfully.",
        languageSubmitted: "Languages has been submitted for approval.",
        exportError: "Something went wrong while exporting the translations",
        importError: "Something went wrong while importing the translations",
        importSuccess: "File imported successfully"
      },
      fields: {
        id_label: "ID",
        id_placeholder: "ID",
        name_label: "Name",
        name_placeholder: "Enter name",
        code_label: "Code",
        code_placeholder: "Enter code",
        isocode_label: "ISO Code",
        isocode_placeholder: "Enter ISO Code",
        direction_label: "Direction",
        direction_placeholder: "Select Direction",
        isactive_label: "Is Active",
      },
      translationModal: {
        language_label: 'Language',
        language_placeholder: 'Select Language',
        module_label: 'Module',
        module_placeholder: 'Select Module',
        submodule_label: 'Submodule',
        submodule_placeholder: 'Select Submodule'
      },
      buttons: {
        import_button: "Import Translations",
        export_button: "Export Translations"
      },
      table: {
        id_header: "ID",
        name_header: "Name",
        code_header: "Code",
        iso_code_header: "ISO Code",
        direction_header: "Direction",
        is_active_header: "Is Active"
      }
    },
  },
  document: {
    name: "Drive",
    title: "This is DOCUMENT module",
  },
  pages: {
    msg: {
      delete: "Page deleted successfully.",
      save: "Page saved successfully."
    }
  },
  accounting: {
    name: "Accounting",
    title: "This is ACCOUNT module",
    dashboard: {
      title: "Dashboard",
      all_time_label: "All Time",
      total_orders_label: "Total Orders",
      manufacturing_orders_label: "Manufacturing Orders",
      planning_label: "Planning",
      editing_dashboard_mode_label: "Editing Dashboard Mode",
      edit_layout_mode_label: "Edit Layout",
      more_icon_label: "more icon",
      msg: {
        dashboard_error: "Something went wrong.",
        discard_message: "Are you sure you want to discard these changes? Your unsaved edits will be lost.",
      },
      table: {
        account_receivable_heading: "Accounts Receivable (AR) Aging",
        donut_chart_heading: "Total Account Receivable",
        barchart_heading: "Aging Bucket",
        table_heading: "Top 5 Debters",
        account_payable_heading: "Accounts Payable (AP) Aging",
        donutchart_payable_heading: "Total Account Payable",
        barchart_payable_heading: "Aging Bucket",
        table_debtor_heading: "Top 5 Debters",
        table_vendor_performance_heading: "Vendor Performance",
        table_vendor_heading: "Top 5 Vendors",
        table_customer_performance_heading: "Vendor Performance",
        table_customer_heading: "Top 5 Customers",
        cash_flow_heading: "Cash Flow",
        dynamic_reorder_heading: "Top 5 Products Dynamic Reorder Points Table",
        discard_heading: "Discard changes?",
        save_changes_heading: "Save Changes",
        save_as_page_heading: "Save as page",
        active_user: "Active User",
        in_active_user: "In-Active User",
        items_label: "items",
        total_transaction_label: "Total Transaction",
        total_value_label: "Total Value",
        average_value_label: "Average Value",
        financial_summary_label: "Financial Summary",
        total_revenue: "Total Revenue",
        total_expenses: "Total Expenses",
        gross_margin: "Gross Margin",
        net_profit_loss: "Net Profit/Loss",
        add_records_label: "Add Records",
        all_time_label: "All Time",
        inflows_label: "Inflows",
        outflows_label: "Outflows",
        net_cash_flow_label: "Net Cash Flow",
        balance_label: "Balance",
      },
      sections: {
        vendor_performance: "vendorPerformance",
        customer_performance: "customerPerformance",
        financial_summary: "financialSummary",
      }
    },
    journal_entry: {
      title: "Journal Entry",
      add_journal_entry_label: "Add Journal entry",
      delete_journal_entry_label: "Delete Journal Entry",
      view_ledger_label: "View Ledger",
      mark_as_void_label: "Mark as Void",
      new_journal_entry_label: "New Journal Entry",
      more_icon_label: "more icon",
      msg: {
        journal_entry_error: "Something went wrong.",
        request_submitted: "Journal entry submitted for approval.",
        noData: "No Journal entry added",
        delete_journal_entry: "Are you sure you want to delete Journal Entry: :series_number ?",
        credit_debit_err: "You cannot credit and debit same account at the same time",
        add_accounting_err: "Please add accounting entries",
        credit_debit_same: "Please ensure that the Debits and Credits are equal",
        delete_journal_item: "Are you sure you want to delete Journal item ?",
        remove_journal_item: "Are you sure you want to remove the added journal items ?",
        submit_document: "Submit this document to confirm",
        approve_reject: "Are you sure you want to :approvalToAcceptOrReject Journal Entry: :series_number ?",
      },
      table: {
        posting_date_label: "Posting Date",
        series_number_label: "Series Number",
        status_label: "Status",
        amount_label: "Amount",
        created_by_label: "Created By",
      },
      fields: {
        draft_label: "Draft",
        total_debit_label: "Total Debit",
        total_credit_label: "Total Credit",
        difference_label: "Difference (Dr - Cr)",
        make_difference_label: "Make Difference Entry",
        total_summary_label: "Total Summary",
        delete_journal_item_label: "Delete Journal Item",
        remove_existing_label: "Remove Existing Journal Items",
        created_on: "Created on",
        add_item_label: "Add Item",
        account_label: "Account",
        party_label: "Party",
        outstanding_balance_label: "Outstanding balance",
        amount_label: "Amount",
        debit_amount_label: "Debit Amount",
        credit_amount_label: "Credit Amount",
        debit_account_currency_label: "Debit in Account Currency",
        credit_account_currency_label: "Credit in Account Currency",
        debit_company_currency_label: "Debit (Base)",
        credit_company_currency_label: "Credit (base)",
        reference_label: "Reference",
        reference_type_label: "Reference Type",
        is_advance_label: "Is Advance",
        reference_date_label: "Reference Date",
        narration_label: "Narration",
        reversal_date_label: "Reversal Date",
        reversal_journal_label: "Reversal Journal",
        add_reversal_entry_label: "Add Reversal Entry",
        request_header: "Request",
      }
    },
    journalType: {
      title: "Journal Type",
      heading: "No Journal Type",
      subHeading: "No Journal Type added",
      add: "Add Journal Type",
      edit: "Edit Journal Type",
      view: "View Journal Type",
      form: {
        name_label: "Name",
        name_placeholder: "Enter journal type name",
        is_payment_label: "Is Payment",
        is_payment_title: "Is Payment",
        status_label: "Status",
        status_title: "Status",
      },
      fields: {
        name: "Name",
        is_payment: "Is Payment",
        created_at: "Created At",
        updated_at: "Updated At",
        created_by: "Created By",
      },
      msg: {
        name_msg_1: "Name is required",
        name_msg_2: "Name cannot exceed 100 characters",
        delete: "Delete Journal Type",
        delete_msg: "Are you sure you want to delete this journal type?",
        success: "Journal type saved successfully",
      },
      table: {
        id_header: "ID",
        name_header: "Name",
        is_payment_header: "Is Payment",
        status_header: "Status",
        created_at_header: "Created At",
        updated_at_header: "Updated At",
      },
    },
    payment: {
      title: "Payment",
      add_journal_entry_label: "Add Journal entry",
      delete_journal_entry_label: "Delete Journal Entry",
      view_ledger_label: "View Ledger",
      mark_as_void_label: "Mark as Void",
      more_icon_label: "more icon",
      subHeading: "Efficiently document your expenses and keep your financial records in order.",
      create_payment_entry_label: "Create Payment Entry",
      new_payment_entry_label: "New Payment Entry",
      edit_payment_entry_label: "Edit Payment Entry",
      msg: {
        payment_error: "Something went wrong.",
        request_submitted: "Payment entry submitted for approval.",
        noData: "No Journal entry added",
        create_first_payment_entry: "Create your first Payment Entry",
        delete_payment_entry: "Permanently Delete :id ?",
        status_change: "Payment entry Status Change successfully.",
        submit_document: "Submit this document to confirm",
        delete_payment_entry_message: "Are you sure you want to delete Payment Entry: :id ?",
        approve_reject: "Are you sure you want to :approvalToAcceptOrReject Payment Entry: :id ?",
        bill_required: "Bills is required",
        amount_error: "Total amount is different from the total payment amount in Bills and Credit notes.",
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        journal_header: "Journal",
        payment_method_header: "Payment Method",
        vendor_header: "Vendor",
        total_amount_header: "Total Amount",
        approval_status_header: "Approval Status",
        status_header: "Status",
        party_type_header: "Party Type",
        is_advance_header: "is Advance",
        bank_account_header: "Bank Account",
        account_header: "Account",
        currency_header: "Currency",
        exchange_rate_header: "Exchange Rate",
        company_header: "Company",
        reference_number_header: "Reference Number",
        posting_date_label: "Posting Date",
        series_number_label: "Series Number",
        amount_label: "Amount",
        created_by_label: "Created By",
      },
      fields: {
        delete_confirmation_label: "Delete Confirmation",
        true_label: "True",
        false_label: "False",
        total_invoice_amount: "Total Invoice Amount",
        total_payment_amount: "Total Payment amount",
        outstanding_balance_label: "Outstanding Balance",
        delete_entry_label: "Delete Payment Entry",
        request_header: "Request",
        download_report_label: "Download Report",
        credit_note_detail: "Credit Note Detail",
        amount_label: "Amount",
        unapplied_amount_label: "Unapplied Amount",
        payment_amount_label: "Payment amount",
        unknown_table_label: "Unknown table",
        accounts_label: "Accounts",
        invoice_detail_label: "Invoice Detail",
        invoice_number_label: "Invoice Number",
        invoice_amount_label: "Invoice Amount",
        amount_paid_label: "Amount paid",
        amount_due_label: "Amount Due",
        invoice_discount_amount_label: "Invoice Discount Amount",
        discount_label: "Discount",
        actual_amount_paid_label: "Actual Amount Paid",
      }
    },
    collection: {
      title: "Collection",
      add_journal_entry_label: "Add Journal entry",
      delete_journal_entry_label: "Delete Journal Entry",
      view_ledger_label: "View Ledger",
      mark_as_void_label: "Mark as Void",
      more_icon_label: "more icon",
      subHeading: "Efficiently document your expenses and keep your financial records in order.",
      create_first_collection_label: "Create your first Collection",
      create_collection_label: "Create Collection",
      new_collection_entry_label: "New Collection Entry",
      edit_collection_entry_label: "Edit Collection Entry",
      msg: {
        collection_error: "Something went wrong.",
        request_submitted: "Payment entry submitted for approval.",
        noData: "No Journal entry added",
        create_first_payment_entry: "Create your first Payment Entry",
        delete_payment_entry: "Permanently Delete :id ?",
        submit_document: "Submit this document to confirm",
        delete_payment_entry_message: "Are you sure you want to delete Payment Entry: :id ?",
        approve_reject: "Are you sure you want to :approvalToAcceptOrReject Payment Entry: :id ?",
        invoice_required: 'Invoice is required',
        amount_error: "Total amount is different from the total payment amount in Invoice and Debit notes.",
        collection_entry_approval: "Collection entry submitted for approval.",
        status_change: "Payment entry Status Change successfully.",
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        journal_header: "Journal",
        payment_method_header: "Payment Method",
        customer_header: "Customer",
        vendor_header: "Vendor",
        total_amount_header: "Total Amount",
        approval_status_header: "Approval Status",
        status_header: "Status",
        party_type_header: "Party Type",
        is_advance_header: "is Advance",
        bank_account_header: "Bank Account",
        account_header: "Account",
        currency_header: "Currency",
        exchange_rate_header: "Exchange Rate",
        company_header: "Company",
        reference_number_header: "Reference Number",
        posting_date_label: "Posting Date",
        series_number_label: "Series Number",
        amount_label: "Amount",
        created_by_label: "Created By",
      },
      fields: {
        delete_confirmation_label: "Delete Confirmation",
        true_label: "True",
        false_label: "False",
        total_invoice_amount: "Total Invoice Amount",
        total_payment_amount: "Total Payment amount",
        outstanding_balance_label: "Outstanding Balance",
        delete_entry_label: "Delete Payment Entry",
        request_header: "Request",
        download_report_label: "Download Report",
        credit_note_detail: "Credit Note Detail",
        amount_label: "Amount",
        unapplied_amount_label: "Unapplied Amount",
        payment_amount_label: "Payment amount",
        unknown_table_label: "Unknown table",
        accounts_label: "Accounts",
        invoice_detail_label: "Invoice Detail",
        invoice_number_label: "Invoice Number",
        invoice_amount_label: "Invoice Amount",
        amount_paid_label: "Amount paid",
        amount_due_label: "Amount Due",
        invoice_discount_amount_label: "Invoice Discount Amount",
        discount_label: "Discount",
        discount_amount_label: "Discount Amount",
        actual_amount_paid_label: "Actual Amount Paid",
        debit_note_detail_label: "Debit Note Detail",
        payment_amount_text: "Payment Amount",
      }
    },
    request: {
      title: "Payment Request",
      add_journal_entry_label: "Add Journal entry",
      delete_journal_entry_label: "Delete Journal Entry",
      view_ledger_label: "View Ledger",
      mark_as_void_label: "Mark as Void",
      more_icon_label: "more icon",
      subHeading: "Efficiently document your expenses and keep your financial records in order.",
      create_first_collection_label: "Create your first Collection",
      create_collection_label: "Create Collection",
      new_collection_entry_label: "New Collection Entry",
      edit_collection_entry_label: "Edit Collection Entry",
      send_payment_request_label: "Send Payment Request",
      msg: {
        request_error: "Something went wrong.",
        request_submitted: "Payment entry submitted for approval.",
        noData: "No Invoices available",
        valid_email_err: "Please Enter Valid Email.",
        required_email_err: "Please add at least one valid email address.",
        required_body_err: "Body is required.",
        create_first_payment_entry: "Create your first Payment Entry",
        delete_payment_entry: "Permanently Delete :id ?",
        submit_document: "Submit this document to confirm",
        delete_payment_entry_message: "Are you sure you want to delete Payment Entry: :id ?",
        approve_reject: "Are you sure you want to :approvalToAcceptOrReject Payment Entry: :id ?",
        invoice_required: 'Invoice is required',
        amount_error: "Total amount is different from the total payment amount in Invoice and Debit notes.",
        collection_entry_approval: "Collection entry submitted for approval.",
        status_change: "Payment entry Status Change successfully.",
        no_payment_request_history: "No Payment Request History Found",
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        journal_header: "Journal",
        payment_method_header: "Payment Method",
        customer_header: "Customer",
        vendor_header: "Vendor",
        total_amount_header: "Total Amount",
        approval_status_header: "Approval Status",
        payment_status_header: "Payment Status",
        status_header: "Status",
        total_invoice_value_header: "Total Invoice Value",
        due_date_header: "Due Date",
        party_type_header: "Party Type",
        is_advance_header: "is Advance",
        bank_account_header: "Bank Account",
        account_header: "Account",
        currency_header: "Currency",
        exchange_rate_header: "Exchange Rate",
        incoterm_header: "Incoterm",
        additional_discount_on_header: "Additional Discount On",
        additional_discount_percentage_header: "Additional Discount Percentage",
        additional_discount_amount_header: "Additional Discount Amount",
        round_off_header: "Round Off",
        company_header: "Company",
        reference_number_header: "Reference Number",
        posting_date_label: "Posting Date",
        series_number_label: "Series Number",
        amount_label: "Amount",
        created_by_label: "Created By",
      },
      fields: {
        payment_request_details_label: "Payment Request Details",
        receiver_email: "Receiver Email",
        mail_subject: "Mail Subject",
        mail_body: "Mail Body",
        attachment_label: "Attachment",
        created_on: "Created on",
        send_payment_request_label: "Send Payment Request",
        from_label: "From",
        to_label: "To",
        cc_label: "CC",
        bcc_label: "BCC",
        subject_label: "Subject",
        body_label: "Body",
        attached_file_label: "Attached file",
        delete_confirmation_label: "Delete Confirmation",
        true_label: "True",
        false_label: "False",
        total_invoice_amount: "Total Invoice Amount",
        total_payment_amount: "Total Payment amount",
        outstanding_balance_label: "Outstanding Balance",
        delete_entry_label: "Delete Payment Entry",
        request_header: "Request",
        download_report_label: "Download Report",
        credit_note_detail: "Credit Note Detail",
        amount_label: "Amount",
        unapplied_amount_label: "Unapplied Amount",
        payment_amount_label: "Payment amount",
        unknown_table_label: "Unknown table",
        accounts_label: "Accounts",
        invoice_detail_label: "Invoice Detail",
        invoice_number_label: "Invoice Number",
        invoice_amount_label: "Invoice Amount",
        amount_paid_label: "Amount paid",
        amount_due_label: "Amount Due",
        invoice_discount_amount_label: "Invoice Discount Amount",
        discount_label: "Discount",
        discount_amount_label: "Discount Amount",
        actual_amount_paid_label: "Actual Amount Paid",
        debit_note_detail_label: "Debit Note Detail",
        payment_amount_text: "Payment Amount",
      }
    },
    bills: {
      title: "Bill",
      mark_recurring_label: "Mark this recurring",
      add_chart_label: "Add Chart Of Accounts",
      delete_journal_entry_label: "Delete Journal Entry",
      view_ledger_label: "View Ledger",
      mark_as_void_label: "Mark as Void",
      more_icon_label: "more icon",
      subHeading: "Efficiently document your expenses and keep your financial records in order.",
      create_first_bill_label: "Create your first Bill",
      create_bill_label: "Create Bill",
      new_bill_label: "New Bill",
      edit_collection_entry_label: "Edit Collection Entry",
      send_payment_request_label: "Send Payment Request",
      msg: {
        bills_error: "Something went wrong.",
        item_error: "Please add atleast one item entry",
        currency_error: "The selected currency doesn't match with selected account currency",
        total_due_err: "The total due amount exceeds the credit limit for :svn",
        action_remaining: "Action is remaining",
        bill_approval: "Bill has been submitted for approval.",
        request_submitted: "Payment entry submitted for approval.",
        noData: "No Invoices available",
        valid_email_err: "Please Enter Valid Email.",
        required_email_err: "Please add at least one valid email address.",
        required_body_err: "Body is required.",
        create_first_payment_entry: "Create your first Payment Entry",
        delete_payment_entry: "Permanently Delete :id ?",
        submit_document: "Submit this document to confirm",
        delete_bill_message: "Are you sure you want to delete Bill: :id ?",
        approve_reject: "Are you sure you want to :approvalToAcceptOrReject Bill: :id ?",
        invoice_required: 'Invoice is required',
        amount_error: "Total amount is different from the total payment amount in Invoice and Debit notes.",
        collection_entry_approval: "Collection entry submitted for approval.",
        status_change: "Payment entry Status Change successfully.",
        no_payment_request_history: "No Payment Request History Found",
        delete_entry_confirm: "Are you sure you want to delete Item Entry ?",
        delete_expanse_confirm: "Are you sure you want to delete Expense Entry ?",
        advance_payments_applied: "Advance Payments Applied Successfully",
        bill_status_change: "Bill Status Change successfully.",
        mark_recurring_confirm: "Are you sure you want to mark as recurring this Bill: :id ?",
        stop_recurring_confirm: "Are you sure you want to stop recurring for Bill: :id ?",
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        supplier_header: "Supplier",
        journal_header: "Journal",
        payment_status_header: "Payment Status",
        customer_header: "Customer",
        vendor_header: "Vendor",
        total_amount_header: "Total Amount",
        approval_status_header: "Approval Status",
        status_header: "Status",
        total_invoice_value_header: "Total Invoice Value",
        invoice_date_header: "Invoice Date",
        due_date_header: "Due Date",
        payment_amount_header: "Payment Amount",
        party_type_header: "Party Type",
        is_advance_header: "is Advance",
        bank_account_header: "Bank Account",
        account_header: "Account",
        currency_header: "Currency",
        exchange_rate_header: "Exchange Rate",
        incoterm_header: "Incoterm",
        additional_discount_on_header: "Additional Discount On",
        additional_discount_percentage_header: "Additional Discount Percentage",
        additional_discount_amount_header: "Additional Discount Amount",
        round_off_header: "Round Off",
        company_header: "Company",
        reference_number_header: "Reference Number",
        posting_date_label: "Posting Date",
        series_number_label: "Series Number",
        amount_label: "Amount",
        created_by_label: "Created By",
      },
      fields: {
        draft_label: "Draft",
        payment_entry_label: 'Payment Entry',
        day_label: "Day",
        weekly_label: "Weekly",
        monthly_label: "Monthly",
        yearly_label: "Yearly",
        stop_label: "Stop",
        view_notes_label: "View Notes",
        add_debit_note_label: "Add Debit Note",
        view_accounting_ledger_label: "View Accounting Ledger",
        stop_recurring_label: "Stop Recurring",
        mark_as_recurring_label: "Mark as recurring",
        apply_payment_label: "Apply Payment",
        advance_bill_label: "Advance Bill",
        create_landed_cost_label: "Create Landed Cost",
        advance_payment_label: "Advance Payment",
        advance_payment_placeholder: "Select Advance Payment",
        item_discount_label: "Item Discount",
        additional_discount_label: "Additional Discount",
        total_discount_label: "Total Discount",
        items_label: "Items",
        total_quantity_label: "Total Quantity",
        total_label: "Total",
        subtotal_label: "Subtotal",
        grandtotal_label: "Grand Total",
        add_item_label: "Add Item",
        item_label: "Item",
        item_placeholder: "Select Items",
        uom_header: "UOM",
        uom_placeholder: "Select UOM",
        quantity_header: "Quantity",
        rate_header: "Rate",
        rate_placeholder: "Enter Rate",
        gross_amount_header: "Gross Amount",
        actual_amount_label: "Actual Amount",
        round_off_difference_label: "Round Off Difference",
        subtotal_excluding_taxes_label: "Subtotal Excluding Taxes",
        subtotal_excluding_discount_label: "Subtotal Excluding discount",
        taxes_and_charges_label: "Taxes and Charges",
        taxes_and_charges_added_label: "Taxes and Charges Added",
        taxes_and_charges_deducted_label: "Taxes and Charges deducted",
        total_taxes_and_charges_added_label: "Total Taxes and Charges Added",
        add_currency_label: "Add Currency",
        tax_code_label: "Tax Code",
        tax_rate_label: "Tax Rate",
        add_expense_label: "Add Expense",
        account_label: "Account",
        account_placeholder: "Select Account",
        rate_label: "Rate",
        discount_item_label: "Discount Item",
        discount_item_placeholder: "Select Discount Items",
        discount_rate_percentage_label: "Discount Rate (%)",
        tax_amount_label: "Tax Amount",
        net_amount_label: "Net Amount",
        total_amount_label: "Total Amount",
        tax_label: "Tax",
        tax_template_label: "Tax Template",
        tax_template_placeholder: "Select Tax Template",
        classification_label: "Classification",
        location_label: "Location",
        location_placeholder: "Select Location",
        department_label: "Department",
        department_placeholder: "Select Department",
        narration_label: "Narration",
        narration_placeholder: "Write Narration",
        enter_narration_placeholder: "Enter Narration",
        delete_item_label: "Delete Item Entry",
        delete_expense_label: "Delete Expense Entry",
        payment_request_details_label: "Payment Request Details",
        receiver_email: "Receiver Email",
        mail_subject: "Mail Subject",
        mail_body: "Mail Body",
        attachment_label: "Attachment",
        created_on: "Created on",
        send_payment_request_label: "Send Payment Request",
        from_label: "From",
        to_label: "To",
        cc_label: "CC",
        bcc_label: "BCC",
        subject_label: "Subject",
        body_label: "Body",
        attached_file_label: "Attached file",
        delete_bill_label: "Delete Bill",
        true_label: "True",
        false_label: "False",
        total_invoice_amount: "Total Invoice Amount",
        total_payment_amount: "Total Payment amount",
        outstanding_balance_label: "Outstanding Balance",
        delete_entry_label: "Delete Payment Entry",
        request_header: "Request",
        download_report_label: "Download Report",
        credit_note_detail: "Credit Note Detail",
        amount_label: "Amount",
        unapplied_amount_label: "Unapplied Amount",
        payment_amount_label: "Payment amount",
        unknown_table_label: "Unknown table",
        accounts_label: "Accounts",
        invoice_detail_label: "Invoice Detail",
        invoice_number_label: "Invoice Number",
        invoice_amount_label: "Invoice Amount",
        amount_paid_label: "Amount paid",
        amount_due_label: "Amount Due",
        invoice_discount_amount_label: "Invoice Discount Amount",
        discounts_label: "Discounts",
        discount_amount_label: "Discount Amount",
        actual_amount_paid_label: "Actual Amount Paid",
        debit_note_detail_label: "Debit Note Detail",
        payment_amount_text: "Payment Amount",
        add_payment_term_label: "Add Payment Term",
        abcd_label: "ABCD",
      }
    },
    invoice: {
      title: "Invoice",
      mark_recurring_label: "Mark this recurring",
      add_chart_label: "Add Chart Of Accounts",
      delete_invoice_label: "Delete Invoice",
      view_ledger_label: "View Ledger",
      mark_as_void_label: "Mark as Void",
      more_icon_label: "more icon",
      subHeading: "Initiate your sales process by creating your inaugural invoice",
      create_first_invoice_label: "Create your first invoice",
      create_invoice_label: "Create Invoice",
      new_invoice_label: "New Invoice",
      edit_collection_entry_label: "Edit Collection Entry",
      send_payment_request_label: "Send Payment Request",
      msg: {
        invoice_error: "Something went wrong.",
        item_error: "Please add atleast one item entry",
        currency_error: "The selected currency doesn't match with selected account currency",
        total_due_err: "The total due amount exceeds the credit limit for :svn",
        action_remaining: "Action is remaining",
        invoice_approval: "Invoice has been submitted for approval.",
        request_submitted: "Payment entry submitted for approval.",
        noData: "No Invoices available",
        valid_email_err: "Please Enter Valid Email.",
        required_email_err: "Please add at least one valid email address.",
        required_body_err: "Body is required.",
        create_first_payment_entry: "Create your first Payment Entry",
        delete_payment_entry: "Permanently Delete :id ?",
        submit_document: "Submit this document to confirm",
        delete_invoice_message: "Are you sure you want to delete Invoice: :id ?",
        approve_reject: "Are you sure you want to :approvalToAcceptOrReject Invoice: :id ?",
        invoice_required: 'Invoice is required',
        amount_error: "Total amount is different from the total payment amount in Invoice and Debit notes.",
        collection_entry_approval: "Collection entry submitted for approval.",
        status_change: "Payment entry Status Change successfully.",
        no_payment_request_history: "No Payment Request History Found",
        delete_entry_confirm: "Are you sure you want to delete Item Entry ?",
        delete_expanse_confirm: "Are you sure you want to delete Expense Entry ?",
        advance_payments_applied: "Advance Payments Applied Successfully",
        invoice_status_change: "Invoice Status Change successfully.",
        mark_recurring_confirm: "Are you sure you want to mark as recurring this Invoice: :id ?",
        stop_recurring_confirm: "Are you sure you want to stop recurring for Invoice: :id ?",
        promotion_delete: "Something went wrong on promotion delete",
        delete_promotion: "Are you sure you want to delete promotion ?",
        promotion_err: "Something went wrong on promotion apply",
        coupon_code_err: "Coupon code must be alphanumeric.",
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        supplier_header: "Supplier",
        journal_header: "Journal",
        payment_status_header: "Payment Status",
        customer_header: "Customer",
        vendor_header: "Vendor",
        total_amount_header: "Total Amount",
        approval_status_header: "Approval Status",
        status_header: "Status",
        total_invoice_value_header: "Total Invoice Value",
        invoice_date_header: "Invoice Date",
        due_date_header: "Due Date",
        payment_amount_header: "Payment Amount",
        party_type_header: "Party Type",
        is_advance_header: "is Advance",
        bank_account_header: "Bank Account",
        account_header: "Account",
        currency_header: "Currency",
        exchange_rate_header: "Exchange Rate",
        incoterm_header: "Incoterm",
        additional_discount_on_header: "Additional Discount On",
        additional_discount_percentage_header: "Additional Discount Percentage",
        additional_discount_amount_header: "Additional Discount Amount",
        round_off_header: "Round Off",
        company_header: "Company",
        reference_number_header: "Reference Number",
        posting_date_label: "Posting Date",
        series_number_label: "Series Number",
        amount_label: "Amount",
        created_by_label: "Created By",
        coupon_code_header: "Coupon Code",
        description_header: "Description",
        type_header: "Type",
        promotion_amount_header: "Promotion Amount / %",
      },
      fields: {
        payment_request_label: "Payment Request",
        collection_entry_label: "Collection Entry",
        delete_promotion_label: "Delete Promotion",
        apply_promotion_label: "Apply Promotions",
        apply_promotion_text: "Apply Promotion",
        draft_label: "Draft",
        payment_entry_label: 'Payment Entry',
        day_label: "Day",
        weekly_label: "Weekly",
        monthly_label: "Monthly",
        yearly_label: "Yearly",
        stop_label: "Stop",
        view_notes_label: "View Notes",
        add_debit_note_label: "Add Debit Note",
        view_accounting_ledger_label: "View Accounting Ledger",
        stop_recurring_label: "Stop Recurring",
        mark_as_recurring_label: "Mark as recurring",
        apply_payment_label: "Apply Payment",
        advance_bill_label: "Advance Bill",
        create_landed_cost_label: "Create Landed Cost",
        advance_payment_label: "Advance Payment",
        advance_payment_placeholder: "Select Advance Payment",
        item_discount_label: "Item Discount",
        additional_discount_label: "Additional Discount",
        total_discount_label: "Total Discount",
        items_label: "Items",
        total_quantity_label: "Total Quantity",
        total_label: "Total",
        subtotal_label: "Subtotal",
        grandtotal_label: "Grand Total",
        add_item_label: "Add Item",
        item_label: "Item",
        item_placeholder: "Select Items",
        uom_header: "UOM",
        uom_placeholder: "Select UOM",
        quantity_header: "Quantity",
        rate_header: "Rate",
        rate_placeholder: "Enter Rate",
        gross_amount_header: "Gross Amount",
        actual_amount_label: "Actual Amount",
        round_off_difference_label: "Round Off Difference",
        subtotal_excluding_taxes_label: "Subtotal Excluding Taxes",
        subtotal_excluding_discount_label: "Subtotal Excluding discount",
        taxes_and_charges_label: "Taxes and Charges",
        taxes_and_charges_added_label: "Taxes and Charges Added",
        taxes_and_charges_deducted_label: "Taxes and Charges deducted",
        total_taxes_and_charges_added_label: "Total Taxes and Charges Added",
        shipping_amount_label: "Shipping Amount",
        handling_amount_label: "Handling Amount",
        add_currency_label: "Add Currency",
        tax_code_label: "Tax Code",
        tax_rate_label: "Tax Rate",
        add_expense_label: "Add Expense",
        account_label: "Account",
        account_placeholder: "Select Account",
        rate_label: "Rate",
        discount_item_label: "Discount Item",
        discount_item_placeholder: "Select Discount Items",
        discount_rate_percentage_label: "Discount Rate (%)",
        tax_amount_label: "Tax Amount",
        net_amount_label: "Net Amount",
        total_amount_label: "Total Amount",
        tax_label: "Tax",
        tax_template_label: "Tax Template",
        tax_template_placeholder: "Select Tax Template",
        classification_label: "Classification",
        location_label: "Location",
        location_placeholder: "Select Location",
        department_label: "Department",
        department_placeholder: "Select Department",
        narration_label: "Narration",
        narration_placeholder: "Write Narration",
        enter_narration_placeholder: "Enter Narration",
        delete_item_label: "Delete Item Entry",
        delete_expense_label: "Delete Expense Entry",
        payment_request_details_label: "Payment Request Details",
        receiver_email: "Receiver Email",
        mail_subject: "Mail Subject",
        mail_body: "Mail Body",
        attachment_label: "Attachment",
        created_on: "Created on",
        send_payment_request_label: "Send Payment Request",
        from_label: "From",
        to_label: "To",
        cc_label: "CC",
        bcc_label: "BCC",
        subject_label: "Subject",
        body_label: "Body",
        attached_file_label: "Attached file",
        delete_bill_label: "Delete Bill",
        true_label: "True",
        false_label: "False",
        total_invoice_amount: "Total Invoice Amount",
        total_payment_amount: "Total Payment amount",
        outstanding_balance_label: "Outstanding Balance",
        delete_entry_label: "Delete Payment Entry",
        request_header: "Request",
        download_report_label: "Download Report",
        credit_note_detail: "Credit Note Detail",
        amount_label: "Amount",
        unapplied_amount_label: "Unapplied Amount",
        payment_amount_label: "Payment amount",
        unknown_table_label: "Unknown table",
        accounts_label: "Accounts",
        invoice_detail_label: "Invoice Detail",
        invoice_number_label: "Invoice Number",
        invoice_amount_label: "Invoice Amount",
        amount_paid_label: "Amount paid",
        amount_due_label: "Amount Due",
        invoice_discount_amount_label: "Invoice Discount Amount",
        discounts_label: "Discounts",
        discount_amount_label: "Discount Amount",
        actual_amount_paid_label: "Actual Amount Paid",
        debit_note_detail_label: "Debit Note Detail",
        payment_amount_text: "Payment Amount",
        add_payment_term_label: "Add Payment Term",
        abcd_label: "ABCD",
        add_credit_note_label: 'Add Credit Note',
      }
    },
    expenses: {
      title: "Cash Expense",
      mark_recurring_label: "Mark this recurring",
      add_chart_label: "Add Chart Of Accounts",
      delete_expense_label: "Delete Cash Expense",
      view_ledger_label: "View Ledger",
      mark_as_void_label: "Mark as Void",
      more_icon_label: "more icon",
      subHeading: "Efficiently document your expenses and keep your financial records in order",
      create_first_expense_label: "Create your first cash expense",
      create_expense_label: "Create Cash Expense",
      new_expense_label: "New Cash Expense",
      edit_collection_entry_label: "Edit Collection Entry",
      send_payment_request_label: "Send Payment Request",
      msg: {
        expenses_error: "Something went wrong.",
        item_error: "Please add atleast one item entry",
        currency_error: "The selected currency doesn't match with selected account currency",
        total_due_err: "The total due amount exceeds the credit limit for :svn",
        action_remaining: "Action is remaining",
        expense_approval: "Cash expense has been submitted for approval.",
        request_submitted: "Payment entry submitted for approval.",
        noData: "No Invoices available",
        valid_email_err: "Please Enter Valid Email.",
        required_email_err: "Please add at least one valid email address.",
        required_body_err: "Body is required.",
        create_first_payment_entry: "Create your first Payment Entry",
        delete_payment_entry: "Permanently Delete :id ?",
        submit_document: "Submit this document to confirm",
        delete_expense_message: "Are you sure you want to delete Cash Expense: :id ?",
        approve_reject: "Are you sure you want to :approvalToAcceptOrReject Cash Expense: :id ?",
        invoice_required: 'Invoice is required',
        amount_error: "Total amount is different from the total payment amount in Invoice and Debit notes.",
        collection_entry_approval: "Collection entry submitted for approval.",
        status_change: "Payment entry Status Change successfully.",
        no_payment_request_history: "No Payment Request History Found",
        delete_entry_confirm: "Are you sure you want to delete Item Entry ?",
        delete_expanse_confirm: "Are you sure you want to delete Cash Expense ?",
        advance_payments_applied: "Advance Payments Applied Successfully",
        expense_status_change: "Expense Status Change successfully.",
        mark_recurring_confirm: "Are you sure you want to mark as recurring this Cash Expense: :id ?",
        stop_recurring_confirm: "Are you sure you want to stop recurring for Cash Expense: :id ?",
        promotion_delete: "Something went wrong on promotion delete",
        delete_promotion: "Are you sure you want to delete promotion ?",
        promotion_err: "Something went wrong on promotion apply",
        coupon_code_err: "Coupon code must be alphanumeric.",
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        supplier_header: "Supplier",
        journal_header: "Journal",
        payment_status_header: "Payment Status",
        customer_header: "Customer",
        vendor_header: "Vendor",
        total_amount_header: "Total Amount",
        approval_status_header: "Approval Status",
        status_header: "Status",
        total_invoice_value_header: "Total Invoice Value",
        invoice_date_header: "Invoice Date",
        due_date_header: "Due Date",
        payment_amount_header: "Payment Amount",
        party_type_header: "Party Type",
        is_advance_header: "is Advance",
        bank_account_header: "Bank Account",
        account_header: "Account",
        currency_header: "Currency",
        exchange_rate_header: "Exchange Rate",
        incoterm_header: "Incoterm",
        additional_discount_on_header: "Additional Discount On",
        additional_discount_percentage_header: "Additional Discount Percentage",
        additional_discount_amount_header: "Additional Discount Amount",
        round_off_header: "Round Off",
        company_header: "Company",
        reference_number_header: "Reference Number",
        posting_date_label: "Posting Date",
        series_number_label: "Series Number",
        amount_label: "Amount",
        created_by_label: "Created By",
        coupon_code_header: "Coupon Code",
        description_header: "Description",
        type_header: "Type",
        promotion_amount_header: "Promotion Amount / %",
      },
      fields: {
        payment_request_label: "Payment Request",
        collection_entry_label: "Collection Entry",
        delete_promotion_label: "Delete Promotion",
        apply_promotion_label: "Apply Promotions",
        apply_promotion_text: "Apply Promotion",
        draft_label: "Draft",
        payment_entry_label: 'Payment Entry',
        day_label: "Day",
        weekly_label: "Weekly",
        monthly_label: "Monthly",
        yearly_label: "Yearly",
        stop_label: "Stop",
        view_notes_label: "View Notes",
        add_debit_note_label: "Add Debit Note",
        view_accounting_ledger_label: "View Accounting Ledger",
        stop_recurring_label: "Stop Recurring",
        mark_as_recurring_label: "Mark as recurring",
        apply_payment_label: "Apply Payment",
        advance_bill_label: "Advance Bill",
        create_landed_cost_label: "Create Landed Cost",
        advance_payment_label: "Advance Payment",
        advance_payment_placeholder: "Select Advance Payment",
        item_discount_label: "Item Discount",
        additional_discount_label: "Additional Discount",
        total_discount_label: "Total Discount",
        items_label: "Items",
        total_quantity_label: "Total Quantity",
        total_label: "Total",
        subtotal_label: "Subtotal",
        grandtotal_label: "Grand Total",
        add_item_label: "Add Item",
        item_label: "Item",
        item_placeholder: "Select Items",
        uom_header: "UOM",
        uom_placeholder: "Select UOM",
        quantity_header: "Quantity",
        rate_header: "Rate",
        rate_placeholder: "Enter Rate",
        gross_amount_header: "Gross Amount",
        actual_amount_label: "Actual Amount",
        round_off_difference_label: "Round Off Difference",
        subtotal_excluding_taxes_label: "Subtotal Excluding Taxes",
        subtotal_excluding_discount_label: "Subtotal Excluding discount",
        taxes_and_charges_label: "Taxes and Charges",
        taxes_and_charges_added_label: "Taxes and Charges Added",
        taxes_and_charges_deducted_label: "Taxes and Charges deducted",
        total_taxes_and_charges_added_label: "Total Taxes and Charges Added",
        shipping_amount_label: "Shipping Amount",
        handling_amount_label: "Handling Amount",
        add_currency_label: "Add Currency",
        tax_code_label: "Tax Code",
        tax_rate_label: "Tax Rate",
        add_expense_label: "Add Expense",
        account_label: "Account",
        account_placeholder: "Select Account",
        rate_label: "Rate",
        discount_item_label: "Discount Item",
        discount_item_placeholder: "Select Discount Items",
        discount_rate_percentage_label: "Discount Rate (%)",
        tax_amount_label: "Tax Amount",
        net_amount_label: "Net Amount",
        total_amount_label: "Total Amount",
        tax_label: "Tax",
        tax_template_label: "Tax Template",
        tax_template_placeholder: "Select Tax Template",
        classification_label: "Classification",
        location_label: "Location",
        location_placeholder: "Select Location",
        department_label: "Department",
        department_placeholder: "Select Department",
        narration_label: "Narration",
        narration_placeholder: "Write Narration",
        enter_narration_placeholder: "Enter Narration",
        delete_item_label: "Delete Item Entry",
        delete_expense_label: "Delete Expense Entry",
        payment_request_details_label: "Payment Request Details",
        receiver_email: "Receiver Email",
        mail_subject: "Mail Subject",
        mail_body: "Mail Body",
        attachment_label: "Attachment",
        created_on: "Created on",
        send_payment_request_label: "Send Payment Request",
        from_label: "From",
        to_label: "To",
        cc_label: "CC",
        bcc_label: "BCC",
        subject_label: "Subject",
        body_label: "Body",
        attached_file_label: "Attached file",
        delete_bill_label: "Delete Bill",
        true_label: "True",
        false_label: "False",
        total_invoice_amount: "Total Invoice Amount",
        total_payment_amount: "Total Payment amount",
        outstanding_balance_label: "Outstanding Balance",
        delete_entry_label: "Delete Payment Entry",
        request_header: "Request",
        download_report_label: "Download Report",
        credit_note_detail: "Credit Note Detail",
        amount_label: "Amount",
        unapplied_amount_label: "Unapplied Amount",
        payment_amount_label: "Payment amount",
        unknown_table_label: "Unknown table",
        accounts_label: "Accounts",
        invoice_detail_label: "Invoice Detail",
        invoice_number_label: "Invoice Number",
        invoice_amount_label: "Invoice Amount",
        amount_paid_label: "Amount paid",
        amount_due_label: "Amount Due",
        invoice_discount_amount_label: "Invoice Discount Amount",
        discounts_label: "Discounts",
        discount_amount_label: "Discount Amount",
        actual_amount_paid_label: "Actual Amount Paid",
        debit_note_detail_label: "Debit Note Detail",
        payment_amount_text: "Payment Amount",
        add_payment_term_label: "Add Payment Term",
        abcd_label: "ABCD",
        add_credit_note_label: 'Add Credit Note',
      }
    },
    commission_plan: {
      title: "Commission Plan",
      add_label: "New Commission Plan",
      edit_label: "Edit Commission Plan",
      view_label: "Commission Plan Details",
      msg: {
        save: "Commission plan saved successfully.",
        delete: "Commission plan deleted successfully.",
        error: "An error occurred while processing the commission plan.",
        saveDraftError: "Please fill atleast one field",
        tiers_error: "Something went wrong in tiers",
        tier_configuration: "Please delete added tiers in order to change configuration"
      },
      table: {
        id_header: "ID",
        title_header: "Commission Title",
        type_header: "Commission Type",
        company_header: "Company",
        apply_on_header: "Apply On",
        eligibility_type_header: "Eligibility Type",
        status_header: "Status",
      },
      sections: {
        basic_details: "Basic Details",
        eligibility_criteria: "Eligibility Criteria",
        commission_rate: "Commission Rate",
        tier: "Tier",
        attachments: "Attachments",
        classification: "Classification",
        accounts: "Accounts",
      },
      fields: {
        title_label: "Commission Title",
        title_placeholder: "Enter Commission Title",
        type_label: "Commission Type",
        type_placeholder: "Select Commission Type",
        company_label: "Company",
        company_placeholder: "Select Company",
        description_label: "Description",
        description_placeholder: "Write Description",
        item_label: "Item",
        item_placeholder: "Select Item",
        apply_on_label: "Apply on",
        eligibilty_type_label: "Eligibilty Type",
        eligibilty_type_placeholder: "Select Eligibilty Type",
        status_label: "Status",
        target_amount_label: "Target Amount",
        commission_target_label: "Give Commission when Target is achieved",
        commission_amount_label: "Commission amount",
        commission_amount_placeholder: "Enter Commission Amount",
        commission_percentage_label: "Commission Percentage",
        commission_percentage_placeholder: "Enter Commission Percentage",
        location_label: "Location",
        location_placeholder: "Select Location",
        department_label: "Department",
        department_placeholder: "Select Department",
        series_id_label: "Series ID",
        view_attachments_label: "View Attached Files",
        summary_commission_amount_label: "Commission Amount",
        summary_subordinate_amount_label: "Subordinate Amount",
        summary_sales_amount_label: "Sales Amount",
      },
      tier_table: {
        tier_name_header: "Tier",
        tier_type_header: "Tier Type",
        tier_amount_header: "Tier Amount",
        tier_quantity_header: "Tier Quantity",
        commission_amount_header: "Commission Amount",
        commission_percentage_header: "Commission Percentage",
        commission_rate_header: "Commission Rate",
        commissioned_amount_header: "Commissioned Amount",
      },
    },
    commission_target: {
      title: "Target",
      add_label: "New Target",
      edit_label: "Edit Target",
      view_label: "Target Details",
      msg: {
        save: "Commission target saved successfully.",
        delete: "Commission target deleted successfully.",
        error: "An error occurred while processing the commission target.",
        saveDraftError: "Please fill atleast one field",
      },
      table: {
        id_header: "ID",
        salesperson_header: "Sales Person",
        type_header: "Target Type",
        start_date_header: "Start Date",
        end_date_header: "End Date",
        target_amount_header: "Target Amount",
        achieved_value_header: "Achieved Value",
        pending_to_reach_target_header: "Pending to Reach Target",
      },
      sections: {
        basic_details: "Basic Details",
        classification: "Classification",
      },
      fields: {
        id_label: "ID",
        id_placeholder: "Enter Target ID",
        salesperson_label: "Sales Person",
        salesperson_placeholder: "Select Sales Person",
        target_type_label: "Type",
        target_type_placeholder: "Select Type",
        start_date_label: "Start Date",
        start_date_placeholder: "Enter Date",
        end_date_label: "End Date",
        end_date_placeholder: "Enter Date",
        company_label: "Company",
        company_placeholder: "Select Company",
        target_label: "Target",
        target_amount_label: "Target Amount",
        target_amount_placeholder: "Enter Target Amount",
        target_quantity_label: "Target Quantity",
        target_quantity_placeholder: "Enter Target Quantity",
        location_label: "Location",
        location_placeholder: "Select Location",
        department_label: "Department",
        department_placeholder: "Select Department",
        series_id_label: "Series ID",
        commission_plan_label: "Commission Plan",
        target_weight_label: "Target Weight",
        target_weight_uom_label: "Target Weight UOM",
      },
    },
    commission_assignment: {
      title: "Commission Assignment",
      add_label: "New Commission Assignment",
      edit_label: "Edit Commission Assignment",
      view_label: "Assignment Details",
      msg: {
        save: "Commission assignment saved successfully.",
        delete: "Commission assignment deleted successfully.",
        error: "An error occurred while processing the commission assignment.",
        saveDraftError: "Please fill atleast one field",
        assignment_error: "Something went wrong in assignment",
        salesperson_error: "Please add atleast one salesperson",
        confirm_delete: "Are you sure you want to delete the assignment ?"
      },
      table: {
        id_header: "ID",
        title_header: "Commission Title",
        description_header: "Description",
      },
      sections: {
        basic_details: "Basic Details",
        salesperson: "Salesperson",
      },
      fields: {
        series_id_label: "Series ID",
        title_label: "Commission Title",
        title_placeholder: "Enter Commission Assignment title",
        description_label: "Description",
        description_placeholder: "Write Description",
      },
      salesperson_table: {
        sl_no_header: "Sl No.",
        salesperson_name_header: "Salesperson Name",
        commission_plan_header: "Commission Plan",
        target_header: "Target",
        start_date_header: "Start Date",
        end_date_header: "End Date",
        subordinate_commission_header: "Allow Subordinate commission",
      },
    },
    authorize_commission: {
      title: "Authorize Commission",
      edit_label: "Edit Authorize Commission",
      view_label: "View Authorize Commission",
      msg: {
        save: "Authorize commission saved successfully.",
        delete: "Authorize commission deleted successfully.",
        error: "An error occurred while processing the authorize commission.",
        transation_error: "Please select at least one transaction to submit",
        saveDraftError: "Please fill atleast one field",
      },
      table: {
        id_header: "ID",
        salesperson_header: "Sales Person",
        calculated_commission_header: "Calculated Commission Amount",
        paid_commission_header: "Paid",
        commission_amount_header: "Commission Amount",
        value_error: "Commission value must be less than"
      },
      sections: {
        basic_details: "Basic Details",
        transaction: "Transaction",
        previously_authorized_commissions: "Previously Authorized Commissions",
        accounts: "Accounts",
      },
      fields: {
        id_label: "ID",
        salesperson_label: "Sales Person",
        manager_label: "Manager",
        account_payable_label: "Account Payable",
        account_payable_placeholder: "Select account payable",
        company_label: "Company",
        company_placeholder: "Select company",
        summary_commission_amount_label: "Commission Amount",
        summary_subordinate_amount_label: "Subordinate Amount",
        summary_sales_amount_label: "Sales Amount",
      },
      transaction_table: {
        date_header: "Date",
        transactions_header: "Transactions",
        commission_plan_header: "Commission Plan",
        transaction_type_header: "Transaction Type",
        transaction_amount_header: "Transaction Amount",
        collected_amount_header: "Collected Amount",
        calculated_amount_header: "Calculated Amount",
        previously_authorized_amount_header: "Previously Authorized",
        commission_amount_header: "Commission Amount",
      },
      previously_authorized_table: {
        id_header: "ID",
        date_header: "Transaction Date",
        amount_header: "Amount",
      },
    },
    commission: {
      title: "Commission",
      edit_label: "Edit Commission",
      view_label: "Commission Details",
      msg: {
        save: "Commission saved successfully.",
        delete: "Commission deleted successfully.",
        error: "An error occurred while processing the commission.",
        transation_error: "Please select at least one transaction to submit",
      },
      table: {
        id_header: "ID",
        salesperson_header: "Sales Person",
        manager_header: "Manager",
        company_header: "Company",
        commission_amount_header: "Commission Amount",
      },
      sections: {
        basic_details: "Basic Details",
        transaction: "Transaction",
        accounts: "Accounts",
      },
      fields: {
        id_label: "ID",
        salesperson_label: "Sales Person",
        manager_label: "Manager",
        company_label: "Company",
        account_payable_label: "Account Payable",
        account_payable_placeholder: "Select account payable",
        expense_account_label: "Expense Account",
        expense_account_placeholder: "Select expense account",
        summary_commission_amount_label: "Commission Amount",
      },
      transaction_table: {
        date_header: "Date",
        transactions_header: "Transactions",
        commission_plan_header: "Commission Plan",
        transaction_type_header: "Transaction Type",
        transaction_amount_header: "Transaction Amount",
        collected_amount_header: "Collected Amount",
        calculated_amount_header: "Calculated Amount",
        commission_amount_header: "Commission Amount",
      },
    },
    month_wise_commission: {
      title: "Month Wise Commission",
      add_label: "New Month Wise Commission",
      edit_label: "Edit Month Wise Commission",
      view_label: "Month Wise Commission Details",
      msg: {
        save: "Month wise commission saved successfully.",
        delete: "Month wise commission deleted successfully.",
        error: "An error occurred while processing the month wise commission.",
        saveDraftError: "Please fill atleast one field",
        calculated: "Commission calculated successfully.",
        noCommissionData: "No commission data found for the selected criteria.",
        emptyEntriesError: "Please calculate commission so the commission entries table is not empty.",
        somethingWentWrong: "Something went wrong.",
        calculateFailed: "Failed to calculate commission.",
      },
      table: {
        id_header: "ID",
        cms_id_header: "CMS ID",
        start_date_header: "Start Date",
        end_date_header: "End Date",
        month_header: "Month",
        year_header: "Year",
        salesperson_header: "Sales Person",
        company_header: "Company",
        target_amount_header: "Target Amount",
        achieved_amount_header: "Achieved Amount",
        commission_amount_header: "Commission Amount",
        commission_percentage_header: "Commission Percentage",
        status_header: "Status",
        department_header: "Department",
      },
      sections: {
        basic_details: "Basic Details",
        monthly_target: "Monthly Target",
        commission_calculation: "Commission Calculation",
        accounts: "Accounts",
        commission_entries: "Commission Entries",
        date_time_details: "Date & Time Details",
      },
      fields: {
        id_label: "ID",
        cms_id_label: "CMS ID",
        date_label: "Date",
        date_placeholder: "Select Date",
        month_label: "Month",
        month_placeholder: "Select Month",
        year_label: "Year",
        year_placeholder: "Select Year",
        entity_label: "Entity",
        entity_placeholder: "Select Entity",
        department_label: "Department",
        department_placeholder: "Select Department",
        salesperson_label: "Sales Person",
        salesperson_placeholder: "Select Sales Person",
        company_label: "Company",
        company_placeholder: "Select Company",
        target_amount_label: "Target Amount",
        target_amount_placeholder: "Enter Target Amount",
        achieved_amount_label: "Achieved Amount",
        achieved_amount_placeholder: "Enter Achieved Amount",
        commission_percentage_label: "Commission Percentage",
        commission_percentage_placeholder: "Enter Commission Percentage",
        commission_amount_label: "Commission Amount",
        commission_amount_placeholder: "Enter Commission Amount",
        start_date_label: "Start Date",
        start_date_placeholder: "Enter Start Date",
        end_date_label: "End Date",
        end_date_placeholder: "Enter End Date",
        account_payable_label: "Account Payable",
        account_payable_placeholder: "Select account payable",
        expense_account_label: "Expense Account",
        expense_account_placeholder: "Select expense account",
        summary_target_amount_label: "Target Amount",
        summary_achieved_amount_label: "Achieved Amount",
        summary_commission_amount_label: "Commission Amount",
        status_label: "Status",
        status_placeholder: "Select Status",
        status_draft: "Draft",
        status_submitted: "Submitted",
        created_by_label: "Created By",
        created_at_label: "Created At",
      },
      entries_table: {
        sl_header: "SL No",
        salesperson_header: "Sales Person",
        target_header: "Target",
        achieved_header: "Achieved",
        percentage_header: "Percentage of Achievement",
        weight_header: "Total Weight",
        uom_header: "UOM",
        amount_header: "Amount",
      },
      actions: {
        calculate: "Calculate Commission",
        add_entry: "Add Entry",
      },
    },
    asset_management: {
      title: "Asset Management",
      add_asset: "New Asset Management",
      heading: "Create your first Asset Management",
      subheading: "Efficiently document your expenses and keep your financial records in order",
      fields: {
        communication_method_label: "Computation Method",
        depriciation_method_label: "Depreciation Method",
        not_depreciable_value_label: "Not depreciable value",
        duration_label: "Duration",
        current_asset_value_label: "Current asset value after depreciation",
        insurance_amount_label: "Insurance amount",
        delete_insurance_label: "Delete Insurance Item",
        delete_depreciation_label: "Delete Depreciation Item",
        delete_label: "Delete Confirmation",
        delete_asset_label: "Delete Asset Entry",
        asset_name_label: "Asset Name",
        asset_type_label: "Asset Type",
        net_asset_value_label: "Net Asset Value",
        asset_life_label: "Asset Life",
        depreciation_label: "Depreciation",
        gross_asset_value_label: "Gross Asset Value"
      },
      msg: {
        delete_msg: "Are you sure you want to delete",
        delete_insurance_msg: "Are you sure you want to delete insurance item ?",
        delete_depreciation_msg: "Are you sure you want to delete depreciation item ?",
        delete_asset_msg: "Are you sure you want to delete Asset Entry"
      },
      insuranceModal: {
        title: "Add Item",
        company_label: "Company",
        company_placeholder: "Enter Compnay Name",
        insurance_date_label: "Insurance Date",
        insurance_due_date_label: "Insurance Due Date",
        insurance_amount_label: "Insurance Amount",
        account_label: "Account",
        account_placeholder: "Select Account"
      },
      modifyDisposeModal: {
        title: "Modify Dispose",
        dispose_date_label: "Date of Dispose",
        loss_account_label: "Loss Account",
        loss_account_placeholder: "Select loss account",
        description_label: "Description",
        description_placeholder: "Write description",
        reevaluate_date_label: "Re-evaluate Date",
        duration_label: "Duration",
        duration_placeholder: "Enter duration",
        gross_increase_account_label: "Gross Increase Account",
        gross_increase_account_placeholder: "Select gross increase account",
        depreciable_amount_label: "Depreciable amount",
        depreciable_amount_placeholder: "Enter depreciable amount",
        depreciable_account_label: "Depreciable Account",
        depreciable_account_placeholder: "Select depreciable account",
        non_depreciable_amount_label: "Non depreciable amount",
        non_depreciable_amount_placeholder: "Enter non depreciable amount",
        expense_account_label: "Expense Account",
        expense_account_placeholder: "Select expense account",
        customer_label: "Customer",
        customer_placeholder: "Select customer",
        amount_label: "Amount",
        amount_placeholder: "Enter amount",
        date_of_sale_label: "Date of sale",
        item_label: "Item",
        item_placeholder: "Select item",
      },
      table: {
        id_header: "ID",
        asset_type_header: "Asset Type",
        asset_name_header: "Asset Name",
        asset_value_header: "Asset Value",
        depreciable_value_header: "Depreciable Value",
        net_asset_value_header: "Net Asset Value",
        depreciation_method_header: "Depreciation Method",
        status_header: "Status"
      }
    },
    asset_transfer: {
      title: "Asset Transfer",
      add_asset_transfer: "New Asset Transfer",
      heading: "Create your first Asset Transfer",
      subheading: "Efficiently document your expenses and keep your financial records in order",
      fields: {
        communication_method_label: "Computation Method",
        depriciation_method_label: "Depreciation Method",
        not_depreciable_value_label: "Not depreciable value",
        duration_label: "Duration",
        current_asset_value_label: "Current asset value after depreciation",
        insurance_amount_label: "Insurance amount",
        transfer_name_label: "Transfer Name",
        transfer_date_label: "Transfer Date",
        item_name_label: "Item Name",
        delete_label: "Delete Asset Transfer Entry",
        delete_asset_transfer_label: "Delete Asset Entry",
      },
      msg: {
        status_msg: "Asset Transfer Status Changed successfully",
        request_submitted: "Asset transfer has been submitted for approval",
        delete_msg: "Are you sure you want to delete",
        delete_asset_transfer_msg: "Are you sure you want to delete Asset Transfer Entry"
      },
      table: {
        id_header: "ID",
        transfer_name_header: "Transfer Name",
        asset_name_header: "Asset Name",
        destination_location_header: "Destination Location",
        approval_status_header: "Approval Status"
      }
    },
    debit_note: {
      title: 'Debit Note',
      new_debit_note: 'New Debit Note',
      add_debit_note: 'Add Debit Note',
      confirm_delete: "Delete Confirmation",
      confirm_void: "Void Confirmation",
      confirm_reject: "Rejection Confirmation",
      heading: "Create your first Debit Note",
      subheading: "Efficiently document your expenses and keep your financial records in order.",
      fields: {
        party_label: "Party",
        party_name_label: "Party Name",
        total_label: "Total",
        amount_label: "Amount",
        tax_label: "Tax",
        classification_label: "Tax",
        delete_item_label: "Delete Item Entry",
        delete_expense_label: "Delete Expense Entry"
      },
      item_table: {
        add_item_label: "Add Item",
        item_header: "Item",
        item_placeholder: "Select Item",
        uom_header: "UoM",
        uom_placeholder: "Select UoM",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        rate_header: "Rate",
        rate_placeholder: "Enter Rate",
        discountItem_header: "Discount Item",
        discountItem_placeholder: "Select Discount Item",
        discountRate_header: "Discount Rate (%)",
        discountRate_placeholder: "Discount Rate",
        grossAmount_header: "Gross Amount",
        grossAmount_placeholder: "Gross Amount",
        taxRate_header: "Tax Rate",
        taxRate_placeholder: "Tax Rate",
        taxAmount_header: "Tax Amount",
        taxAmount_placeholder: "Tax Amount",
        discountAmount_header: "Discount Amount",
        discountAmount_placeholder: "Discount Amount",
        netAmount_header: "Net Amount",
        netAmount_placeholder: "Net Amount",
        totalAmount_header: "Total Amount",
        totalAmount_placeholder: "Total Amount",
        taxTemplate_header: "Tax Template",
        taxTemplate_placeholder: "Select Tax Template",
        location_header: "Location",
        location_placeholder: "Select Location",
        department_header: "Department",
        department_placeholder: "Select Department",
        narration_header: "Narration",
        narration_placeholder: "Enter Narration",
        tax_code_label: "Tax Code",
        tax_rate_label: "Tax Rate",
      },
      expense_table: {
        title: "Expense Detail",
        account_header: "Account",
        account_placeholder: "Select Account",
        rate_header: "Rate",
        rate_placeholder: "Enter Rate",
        discountItem_header: "Discount Item",
        discountItem_placeholder: "Select Discount Item",
        discountRate_header: "Discount Rate (%)",
        discountRate_placeholder: "Discount Rate",
        grossAmount_header: "Gross Amount",
        grossAmount_placeholder: "Gross Amount",
        taxRate_header: "Tax Rate",
        taxRate_placeholder: "Tax Rate",
        taxAmount_header: "Tax Amount",
        taxAmount_placeholder: "Tax Amount",
        discountAmount_header: "Discount Amount",
        discountAmount_placeholder: "Discount Amount",
        netAmount_header: "Net Amount",
        netAmount_placeholder: "Net Amount",
        totalAmount_header: "Total Amount",
        totalAmount_placeholder: "Total Amount",
        taxTemplate_header: "Tax Template",
        taxTemplate_placeholder: "Select Tax Template",
        taxCode_header: "Tax Code",
        taxCode_placeholder: "Select Tax Code",
        location_header: "Location",
        location_placeholder: "Select Location",
        department_header: "Department",
        department_placeholder: "Select Department",
        narration_header: "Narration",
        narration_placeholder: "Enter Narration",
        tax_code_label: "Tax Code",
        tax_rate_label: "Tax Rate",
      },
      msg: {
        request_approved: "Debit note has been approved successfully.",
        request_rejected: "Debit note has been rejected successfully.",
        request_submitted: "Debit note has been submitted for approval",
        void_message: "Debit note voided",
        applied_success: "Applied successfully",
        status_update: "Debit note status updated",
        item_error: "Please add atleast one item entry",
        item_expense_error: "Please add atleast one item/expense entry",
        confirm_delete: "Are you sure you want to delete this note?",
        confirm_void: "Are you sure you want to void this note?",
        confirm_reject: "Are you sure you want to reject this debit note?",
        confirm_delete_item: "Are you sure you want to delete Item Entry?",
        confirm_delete_expense: "Are you sure you want to delete Expense Entry?"
      },
      buttons: {
        void: "Void"
      },
      table: {
        id_header: "ID",
        party_header: "Party",
        party_name_header: "Party Name",
        debit_note_header: "Debit Note Date",
        amount_header: "Amount",
        status_header: "Status",
        invoice_header: "Invoice"
      }
    },
    credit_note: {
      title: 'Credit Note',
      new_debit_note: 'New Credit Note',
      add_debit_note: 'Add Credit Note',
      confirm_delete: "Delete Confirmation",
      confirm_void: "Void Confirmation",
      confirm_reject: "Rejection Confirmation",
      heading: "Create your first Credit Note",
      subheading: "Efficiently document your expenses and keep your financial records in order.",
      fields: {
        party_label: "Party",
        party_name_label: "Party Name",
        total_label: "Total",
        amount_label: "Amount",
        tax_label: "Tax",
        classification_label: "Tax",
        delete_item_label: "Delete Item Entry",
        delete_expense_label: "Delete Expense Entry"
      },
      item_table: {
        add_item_label: "Add Item",
        item_header: "Item",
        item_placeholder: "Select Item",
        uom_header: "UoM",
        uom_placeholder: "Select UoM",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        rate_header: "Rate",
        rate_placeholder: "Enter Rate",
        discountItem_header: "Discount Item",
        discountItem_placeholder: "Select Discount Item",
        discountRate_header: "Discount Rate (%)",
        discountRate_placeholder: "Discount Rate",
        grossAmount_header: "Gross Amount",
        grossAmount_placeholder: "Gross Amount",
        taxRate_header: "Tax Rate",
        taxRate_placeholder: "Tax Rate",
        taxAmount_header: "Tax Amount",
        taxAmount_placeholder: "Tax Amount",
        discountAmount_header: "Discount Amount",
        discountAmount_placeholder: "Discount Amount",
        netAmount_header: "Net Amount",
        netAmount_placeholder: "Net Amount",
        totalAmount_header: "Total Amount",
        totalAmount_placeholder: "Total Amount",
        taxTemplate_header: "Tax Template",
        taxTemplate_placeholder: "Select Tax Template",
        location_header: "Location",
        location_placeholder: "Select Location",
        department_header: "Department",
        department_placeholder: "Select Department",
        narration_header: "Narration",
        narration_placeholder: "Enter Narration",
        tax_code_label: "Tax Code",
        tax_rate_label: "Tax Rate",
      },
      msg: {
        request_approved: "Credit note has been approved successfully.",
        request_rejected: "Credit note has been rejected successfully.",
        request_submitted: "Credit note has been submitted for approval",
        void_message: "Credit note voided",
        applied_success: "Applied successfully",
        status_update: "Credit note status updated",
        item_error: "Please add atleast one item entry",
        confirm_delete: "Are you sure you want to delete this note?",
        confirm_void: "Are you sure you want to void this note?",
        confirm_reject: "Are you sure you want to reject this debit note?",
        confirm_delete_item: "Are you sure you want to delete Item Entry?",
      },
      buttons: {
        void: "Void"
      },
      table: {
        id_header: "ID",
        party_header: "Party",
        party_name_header: "Party Name",
        credit_note_header: "Credit Note Date",
        amount_header: "Amount",
        status_header: "Status",
      }
    },
    expense_reimbursement: {
      title: 'Expense Reimbursement',
      new_label: 'New Expense Reimbursement',
      edit_label: 'Edit Expense Reimbursement',
      add_payment_entry: 'Payment Entry',
      view_payment_entry: 'View Payment Entry',
      heading: "Create your first Expense Reimbursement",
      subheading: "Efficiently document your expenses and keep your financial records in order",
      create_label: "Create Expense Reimbursement",
      fields: {
        party_label: "Party",
        party_name_label: "Party Name",
        total_label: "Total Amount",
        total_summary: "Total Summary",
        amount_label: "Amount",
        tax_label: "Tax",
        classification_label: "Tax",
        delete_item_label: "Delete Item Entry",
        delete_expense_label: "Delete Expense Entry"
      },
      item_table: {
        add_expense_label: "Add Expense",
        add_item_label: "Add Item",
        item_header: "Item",
        item_placeholder: "Select Item",
        uom_header: "UoM",
        uom_placeholder: "Select UoM",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        rate_header: "Rate",
        rate_placeholder: "Enter Rate",
        discountItem_header: "Discount Item",
        discountItem_placeholder: "Select Discount Item",
        discountRate_header: "Discount Rate (%)",
        discountRate_placeholder: "Discount Rate",
        grossAmount_header: "Gross Amount",
        grossAmount_placeholder: "Gross Amount",
        taxAmount_header: "Tax Amount",
        taxAmount_placeholder: "Tax Amount",
        discountAmount_header: "Discount Amount",
        discountAmount_placeholder: "Discount Amount",
        netAmount_header: "Net Amount",
        netAmount_placeholder: "Net Amount",
        totalAmount_header: "Total Amount",
        classification_header: "Classification",
        totalAmount_placeholder: "Total Amount",
        taxTemplate_header: "Tax Template",
        taxTemplate_placeholder: "Select Tax Template",
        amount: "Amount",
        location_header: "Location",
        location_placeholder: "Select Location",
        department_header: "Department",
        department_placeholder: "Select Department",
        narration_header: "Narration",
        narration_placeholder: "Enter Narration",
        tax_code_label: "Tax Code",
        tax_rate_label: "Tax Rate",
        category_label: "Category",
        ref_no_label: "Reference No",
        tax_label: "Tax",
        attachment_header: "Attachment",
      },
      msg: {
        item_error: "Please add atleast one item entry",
        delete_expense_label: "Delete Expense Item",
        confirm_delete_item: "Are you sure you want to delete Expense item ?",
        request_submitted: 'Expense Reimbursement submitted for approval.',
        delete_conformation: 'Delete Conformation',
        delete_expense_reimbursement: "Delete Expense Reimbursement",
        delete_expense_reimbursement_msg: "Are you sure you want to delete Expense Reimbursement ?",
        payment_entry_submitted: "Payment entry submitted for approval."
      },
      table: {
        expense_date_header: "Expense Date",
        reference_number_header: "Refrence Number",
        paid_by_header: "Paid By",
        total_amount_header: "Total Amount",
        description_header: "Description",
        status_header: "Status"
      }
    },
    expense_report: {
      title: 'Expense Report',
      request_submitted: 'Exppense Reimbursement submitted for approval.',
      heading: 'Create your First Expense Reimbursement',
      table: {
        expense_date_header: "Expense Date",
        reference_number_header: "Refrence Number",
        paid_by_header: "Paid By",
        total_amount_header: "Total Amount",
        description_header: "Description",
        status_header: "Status"
      }
    },
    budget: {
      title: "Budget",
      new_budget: "New Budget",
      delete_budget: "Delete Budget",
      heading: "No Budget",
      subheading: "No budget added",
      fields: {
        account_label: "Account",
        total_profitloss: "Total for profit and loss"
      },
      msg: {
        delete_budget_msg: "Are you sure you want to delete Budget",
        request_approved: "Purchase Order has been approved successfully.",
        request_rejected: "Purchase Order has been rejected successfully.",
        request_submitted: "Budget submitted for approval",
        no_accounts_msg: "No Accounts available",
        no_data_msg: "No data available",
      },
      buttons: {
        select_account_button: "Select Account",
        add_remove_account_button: "Add or Remove Accounts",
        add_account_button: "Add Accounts",
        create_chart: "Create Chart",
        compare: "Compare"
      },
      addAccountsModal: {
        title: "Add Accounts",
        account_label: "Account"
      },
      table: {
        id_header: "ID",
        budget_name_header: "Budget Name",
        budget_type_header: "Budget Type",
        financial_year_header: "Financial Year",
        total_amount_header: "Total Amount",
        total_remaining_header: "Total Remaining",
        status_header: "Status"
      }
    },
    customer_management: {
      title: "Customer Management",
      add_customer: "Add new Customer",
      new_customer: "New Customer",
      edit_customer: "Edit Customer",
      delete_customer: "Delete Customer",
      heading: "Create your first Customer",
      subheading: "Efficiently document your expenses and keep your financial records in order.",
      msg: {
        address_msg: "Please add at least one address",
        contact_msg: "Please add at least one contact",
        delete_address_msg: "Are you sure you want to delete this address ?",
        delete_contact_msg: "Are you sure you want to delete this contact ?",
        default_shipping_address_msg: "Another address is already marked as the default shipping address. Please uncheck that before selecting this one",
        default_billing_address_msg: "Another address is already marked as the default billing address. Please uncheck that before selecting this one",
        delete_customer_msg: "Are you sure you want to delete Customer ID"
      },
      fields: {
        customer_label: "Customer",
        customer_name_label: "Customer Name",
        phone_number_label: "Phone No.",
        email_label: "Email",
        default_billing_address_label: "Default billing address",
        default_shipping_address_label: "Default shipping address",
        delete_address_label: "Delete Address",
        delete_contact_label: "Delete Contact",
        balance_label: "Balance",
        overdue_balance_label: "Over Due Balance",
        days_overdue_label: "Days Over Due",
        ageing_30_lable: "Ageing 30",
        ageing_60_lable: "Ageing 60",
        ageing_90_lable: "Ageing 90",
        details_label: "Detail",
        accounting_label: "Accounting"
      },
      addressModal: {
        title: "Address Detail",
        address_type_label: "Address Type",
        address_type_placeholder: "Select Address Type",
        contact_name_label: "Contact Name",
        contact_name_placeholder: "Enter Contact Name",
        mobile_label: "Mobile",
        address1_label: "Address 1",
        address1_placeholder: "Enter Street",
        address2_label: "Address 2",
        address2_placeholder: "Enter Street",
        address3_label: "Address 3",
        address3_placeholder: "Enter Street",
        zip_code_label: "Zip Code",
        zip_code_placeholder: "Enter Zip Code",
        country_label: "Country",
        country_placeholder: "Select country",
        state_label: "State",
        state_placeholder: "Select state",
        city_label: "City",
        city_placeholder: "Enter city",
        summary_label: "Summary",
        summary_placeholder: "Pre populated after filling address",
        default_shipping_address_label: "Default shipping address",
        default_billing_address_label: "Default billing address"
      },
      contactModal: {
        title: "Contact",
        name_label: "Name",
        name_placeholder: "Enter Name",
        email_label: "Email",
        email_placeholder: "Enter Email",
        contact_no_label: "Contact No"
      },
      table: {
        id_header: "ID",
        name_header: "Name",
        phone_number_header: "Phone Number",
        emails_header: "Emails",
        salesperson_header: "Salesperson",
        status_header: "Status"
      }
    },
    vendor_management: {
      title: "Vendor Management",
      add_vendor: "Add new Vendor",
      new_vendor: "New Vendor",
      edit_vendor: "Edit Vendor",
      delete_vendor: "Delete Vendor",
      heading: "Create your first Vendor",
      subheading: "Efficiently document your expenses and keep your financial records in order.",
      msg: {
        address_msg: "Please add at least one address",
        contact_msg: "Please add at least one contact",
        delete_address_msg: "Are you sure you want to delete this address ?",
        delete_contact_msg: "Are you sure you want to delete this contact ?",
        default_shipping_address_msg: "Another address is already marked as the default shipping address. Please uncheck that before selecting this one",
        default_billing_address_msg: "Another address is already marked as the default billing address. Please uncheck that before selecting this one",
        delete_vendor_msg: "Are you sure you want to delete Vendor ID"
      },
      fields: {
        vendor_label: "Vendor",
        vendor_name_label: "Vendor Name",
        phone_number_label: "Phone No.",
        email_label: "Email",
        default_billing_address_label: "Default billing address",
        default_shipping_address_label: "Default shipping address",
        delete_address_label: "Delete Address",
        delete_contact_label: "Delete Contact",
        balance_label: "Balance",
        overdue_balance_label: "Over Due Balance",
        days_overdue_label: "Days Over Due",
        ageing_30_lable: "Ageing 30",
        ageing_60_lable: "Ageing 60",
        ageing_90_lable: "Ageing 90",
        details_label: "Detail",
        accounting_label: "Accounting"
      },
      addressModal: {
        title: "Address Detail",
        address_type_label: "Address Type",
        address_type_placeholder: "Select Address Type",
        contact_name_label: "Contact Name",
        contact_name_placeholder: "Enter Contact Name",
        mobile_label: "Mobile",
        address1_label: "Address 1",
        address1_placeholder: "Enter Street",
        address2_label: "Address 2",
        address2_placeholder: "Enter Street",
        address3_label: "Address 3",
        address3_placeholder: "Enter Street",
        zip_code_label: "Zip Code",
        zip_code_placeholder: "Enter Zip Code",
        country_label: "Country",
        country_placeholder: "Select country",
        state_label: "State",
        state_placeholder: "Select state",
        city_label: "City",
        city_placeholder: "Enter city",
        summary_label: "Summary",
        summary_placeholder: "Pre populated after filling address",
        default_shipping_address_label: "Default shipping address",
        default_billing_address_label: "Default billing address"
      },
      contactModal: {
        title: "Contact",
        name_label: "Name",
        name_placeholder: "Enter Name",
        email_label: "Email",
        email_placeholder: "Enter Email",
        contact_no_label: "Contact No"
      },
      table: {
        id_header: "ID",
        name_header: "Name",
        phone_number_header: "Phone Number",
        emails_header: "Emails",
        status_header: "Status"
      }
    },
    coa: {
      title: 'Chart of Accounts',
      heading: 'No chart of account',
      subHeading: 'No chart of account added',
      msg: {
        delete: 'Delete Chart of Account',
        delete_msg: 'Are you sure you want to delete Chart of Account ID:',
      },
      table: {
        id_header: "ID",
        account_name_header: "Account Name",
        status_header: "Status",
        account_code_header: "Account Code",
        account_type_header: "Account Type",
      }
    },
    currency: {
      title: 'Currency',
      heading: 'No Currency',
      subHeading: 'No Currency added',
      edit: 'Edit Currency',
      add: 'Add Currency',
      msg: {
        delete: 'Delete Currency',
        delete_msg: 'Are you sure you want to delete Currency ID:',
      },
      table: {
        id_header: "ID",
        currency_name_header: "Currency",
        status_header: "Status",
        fraction_header: "Fraction",
        fraction_unit_header: "Fraction Units",
      }

    },
    currencyExchange: {
      title: 'Currency Exchange',
      heading: 'No Currency Exchange',
      subHeading: 'No Currency Exchange Added',
      edit: 'Edit Currency',
      msg: {
        delete: 'Delete Currentcy Exchange',
        delete_msg: 'Are you sure you want to delete Currency Exchange ID:',
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        from_currency_header: "From Currency",
        to_currency_header: "To Currency",
        exchange_rate_header: "Exchange Rate",
      }

    },
    taxCategory: {
      title: 'Tax Category',
      heading: 'No Tax Category',
      subHeading: 'No tax category added',
      edit: 'Edit Tax Category',
      add: 'Add Tax Category',
      msg: {
        delete: 'Delete Tax Category',
        delete_msg: 'Are you sure you want to delete Tax Category ID:',
        success: "Tax category saved successfully"
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        name_header: "Name",
        sales_account_header: "Sales Account",
        purchase_account_header: "Purchase Account",
      }

    },
    taxCode: {
      title: 'Tax Code',
      heading: 'No tax code added',
      subHeading: 'Add Tax code',
      edit: 'Edit Tax Category',
      add: 'Add Tax Category',
      msg: {
        delete: 'Delete Tax Code',
        delete_msg: 'Are you sure you want to delete Tax Code ID:',
        success: "Tax category saved successfully"
      },
      table: {
        id_header: "ID",
        name_header: "Name",
        rate_header: "Rate",
        effective_start_date_header: "Effective Start Date",
        effective_end_date_header: "Effective End Date",
        tax_category_header: "Tax Category",
        applies_to_header: "Applied To",
        reverse_charge_code_header: "Reverse Charge Code",
        description_header: "Description",
      }

    },
    taxTemplate: {
      title: 'Tax Template',
      heading: 'No Tax Template',
      subHeading: 'No tax template added',
      edit: 'Edit Tax Template',
      add: 'Add Tax Template',
      msg: {
        delete: 'Delete Tax Template',
        delete_msg: 'Are you sure you want to delete Tax Template ID:',
        success: "Tax category saved successfully"
      },
      table: {
        id_header: "ID",
        name_header: "Name",
        tax_code_header: "Tax Code"
      }

    },
    bank: {
      title: 'Bank',
      heading: 'No bank added',
      subHeading: 'Add bank',
      edit: 'Edit Tax Template',
      add: 'Add Tax Template',
      msg: {
        delete: 'Delete Bank ',
        delete_msg: 'Are you sure you want to delete Bank ID:',
        success: "Tax category saved successfully"
      },
      table: {
        id_header: "ID",
        bank_name_header: "Bank Name",
        swift_number_header: "Swift Number",
      }

    },
    bankAccount: {
      title: 'Bank Account',
      heading: 'No Bank Account',
      subHeading: 'Add Bank Account',
      edit: 'Edit Bank Account',
      add: 'Add Bank Account',
      msg: {
        delete: 'Delete Bank Account',
        delete_msg: 'Are you sure you want to delete Bank Account ID:',
        success: "Tax category saved successfully"
      },
      table: {
        id_header: "ID",
        account_number_header: "Account No.",
        bank_name_header: "Bank Name",
        name_header: "Name",
        account_type_header: "Account Type"
      }

    },
    reconciliation: {
      title: 'Reconciliation',
      heading: 'No Reconcilition',
      subHeading: 'No Reconcilition Added',
      edit: 'Edit Bank Account',
      add: 'Add Bank Account',
      upload: 'Upload Bank Statement',
      view: 'View Unreconciled Transactions',
      editBankAccount: 'Edit Bank Account',
      transaction_label: 'Transactions',
      notFound: 'Data Not Found',
      fields: {
        bank_label: 'Bank Name',
        account_number_label: 'Account Number',
        account_name_label: 'Account Name',
        status: 'Status',
        transaction_label: 'Reconciled Transaction',
        unreconciled_label: 'Unreconciled Transaction',
      },
      msg: {
        delete: 'Delete Bank Account',
        delete_msg: 'Are you sure you want to delete Bank Account ID:',
        success: "Transaction Added successfully.",
        rejected: 'Data not Reconciliation',
        paymentError: 'Total amount of selected entries does not match the Amount value.'
      },
      table: {
        transaction_date_header: "Date Of Transactions",
        transaction_type_header: "Transaction Type",
        amount_header: "Amount Of Transaction",
        partner_header: "Partner"
      }

    },
    fiscalYear: {
      title: 'Fiscal Year',
      heading: 'No fiscal year added',
      subHeading: 'Add fiscal year',
      edit: 'Edit Bank Account',
      add: 'Add Bank Account',
      msg: {
        delete: 'Delete Fiscal Year',
        delete_msg: 'Are you sure you want to delete Fiscal Year ID:',
        success: "Tax category saved successfully"
      },
      table: {
        id_header: "ID",
        year_name_header: "Year Name",
        year_start_date_header: "Year Start Date",
        year_end_date_header: "Year End Date",
      }

    },
    paymentTerm: {
      title: 'Payment Term',
      heading: 'No Payment Term',
      subHeading: 'No Payment Term added',
      edit: 'Edit Payment Term',
      add: 'Add Payment Term',
      msg: {
        delete: 'Delete PAyment Term',
        delete_msg: 'Are you sure you want to delete Payment term ID:',
        success: "Tax category saved successfully"
      },
      table: {
        id_header: "ID",
        name_header: "Name",
        due_date_based_on_header: "Due Date Based On",
        credit_days_header: "Credit Days",
        mode_of_payment_header: "Mode of Payment",
      }

    },
    logo_settings: {
      title: "Logo Settings",
      current_logo: "Current Report Logo",
      no_logo: "No logo uploaded",
      change_logo: "Change Logo",
      crop_title: "Crop Logo",
      crop_apply: "Crop & Apply",
      zoom: "Zoom",
      file_format_error: "Only PNG, JPG, JPEG, and WebP files are allowed",
      file_size_error: "File size must be less than 2MB",
      upload_success: "Logo updated successfully"
    },
  },
  inventory: {
    name: "Inventory",
    title: "This is INVENTORY module",
    item: {
      items_label: "Items",
      add_inventory_item: "Add Inventory Item",
      add_assembly_item: "Add Assembly Item",
      edit_inventory_item: "Edit Inventory Item",
      add_non_inventory_item: "Add Non Inventory Item",
      edit_non_inventory_item: "Edit Non Inventory Item",
      add_service_item: "Add Service Item",
      edit_service_item: "Edit Service Item",
      add_package_item: "Add Package Item",
      edit_package_item: "Edit Package Item",
      add_new_attribute_label: "Add New Attribute",
      add_attribute_label: "Add Attribute",
      item_label: "Item",
      adjust_stock_label: "Adjust Stock",
      rentalPriceModal: {
        title: "Rental Price",
        period_label: 'Period',
        period_placeholder: 'Select Period',
        price_label: 'Price',
        price_placeholder: 'Enter Price'
      },
      attributeModal: {
        name_label: "Name",
        name_placeholder: "Name",
        field_type_label: "Field Type",
        field_type_placeholder: "Field Type",
        variants_label: "Variation Creation mode",
        value_placeholder: "Enter value",
      },
      brandModal: {
        title: "Add Brand",
        brand_name_label: "Brand Name",
        brand_name_placeholder: "Enter Brand Name",
      },
      categoryModal: {
        title: "Add Category",
        category_name_label: "Category Name",
        category_name_placeholder: "Category Name",
      },
      locationModal: {
        title: "Add Location",
        location_name_label: "Name",
        location_name_placeholder: "Enter Name",
        location_code_label: "Short Code",
        location_code_placeholder: "Enter Short Code",
        location_company_label: "Company",
        location_company_placeholder: "Select Company",
      },
      componentModal: {
        title: "Add Component",
        component_name_label: "Component",
        component_name_placeholder: "Select Component",
        component_quantity_label: "Quantity",
        component_uom_label: "UOM",
        component_uom_placeholder: "Select UOM",
        component_price_label: "Unit Price",
      },
      itemSpecificationModal: {
        title: "Item Specification",
        pricelist_label: "Price List Name",
        pricelist_placeholder: "Add price list",
        minqty_label: "Minimum Quantity",
        unitprice_label: "Unit Price",
        startdate_label: "Start Date",
        enddate_label: "End Date",
        company_label: "Company",
        company_placeholder: "Select company",
      },
      priceRuleModal: {
        title: "Price Rules",
        pricelist_label: "Price List Name",
        pricelist_placeholder: "Enter Price List Name",
        minqty_label: "Minimum Quantity",
        unitprice_label: "Unit Price",
        startdate_label: "Start Date",
        enddate_label: "End Date",
        company_label: "Company",
        company_placeholder: "Select company",
      },
      rulesModal: {
        title: "Add Rules",
        location_label: "Location",
        location_placeholder: "Select Location",
        minqty_label: "Add Minimum Quantity",
        minqty_placeholder: "Add Minimum Quantity",
        maxqty_label: "Add Maximum Quantity",
        maxqty_placeholder: "Add Maximum Quantity",
      },
      vendorInformationModal: {
        title: "Add Vendor Information",
        vendor_label: "Vendor",
        vendor_placeholder: "Select Vendor",
        item_name_label: "Item Name",
        item_name_placeholder: "Enter Item Name",
        item_code_label: "Item Code",
        item_code_placeholder: "Enter Item Code",
        lead_time_label: "Lead Time",
        lead_time_placeholder: "Enter Lead Time (In Days)",
        price_label: "Price",
        price_placeholder: "Enter Price",
        currency_label: "Currency",
        currency_placeholder: "Select Currency",
      },
      msg: {
        attributes_error: "Please add attributes",
        confirm_delete: "Are you sure you want to delete",
        bom_success: "Default BOM has set successfully.",
        bom_error: "Something went wron on default BOM set",
        location_error: "Location Id is already Available"
      },
      fields: {
        summary_label: "Summary",
        activity_label: "Activity",
        items_label: "Items",
        item_name_label: "Item Name",
        sales_price_label: "Sales price",
        purchase_price_label: "Purchase price",

        no_item_label: "No Item Added",
        add_item_label: "Add Item"
      },
      table: {
        sku_header: "SKU",
        name_header: "Name",
        reorder_level_header: "Reorder Level",
        status_header: "Status"
      }
    },
    itemCategory: {
      title: "Item Category",
      add_category: "Add Category",
      delete_category: "Delete Category",
      attributeModal: {
        title: "Attribute",
        add_attribute: "Add Attribute",
        add_new_attribute: "Add New Attribute",
        search_attribute: "Search Attribute",
        name_label: "Name",
        name_placeholder: "Name",
        field_type_label: "Field Type",
        field_type_placeholder: "Field Type",
        variants_label: "Variation Creation mode",
        value_label: "Value",
        value_placeholder: "Enter value",
        no_attributes_label: "No attributes available"
      },
      msg: {
        confirm_delete: "Are you sure you want to delete Category",
      },
      table: {
        category_header: "Category Name",
        parent_header: "Parent",
        status_header: "Status",
        level_header: "Level",
        sub_categories_header: "Sub Categories"
      }
    },
    discountedItem: {
      title: "Discounted Item",
      add_item: "Add Discounted Item",
      edit_item: "Edit Discounted Item",
      delete_item: "Delete Discounted Item",
      discount_label: "Discount",
      msg: {
        confirm_delete: "Are you sure you want to delete discounted item",
      },
      table: {
        sku_header: "SKU",
        discounted_item_header: "Discounted Type",
        name_header: "Name",
        account_header: "Account",
        tax_account_header: "Tax Account",
        discount_rate_header: "Discount Rate",
        status_header: "Status"
      }
    },
    attribute: {
      title: "Attributes",
      add_attribute: "Add Attribute",
      new_attribute: "New Attribute",
      edit_attribute: "Edit Attribute",
      delete_attribute: "Delete Attribute",
      options_label: "Options",
      values_label: "Values",
      values_placeholder: "Enter value",
      basic_details: "Basic Details",
      msg: {
        confirm_delete: "Are you sure you want to delete attribute",
      },
      table: {
        attribute_header: "Attribute",
        variants_creation_mode_header: "Variants Creation Mode",
        status_header: "Status"
      }
    },
    bin: {
      title: "Bins",
      add_bin: "Add Bin",
      new_bin: "New Bin",
      edit_bin: "Edit Bin",
      delete_bin: "Delete Bin",
      basic_details: "Basic Details",
      msg: {
        confirm_delete: "Are you sure you want to delete bin",
      },
      table: {
        name_header: "Name",
        location_header: "Location",
        bin_type_header: "Bin Type",
        company_header: "Company",
        status_header: "Status"
      }
    },
    location: {
      title: "Location",
      add_location: "Add Location",
      new_location: "New Location",
      edit_location: "Edit Location",
      delete_location: "Delete Location",
      basic_details: "Basic Details",
      msg: {
        confirm_delete: "Are you sure you want to delete location",
      },
      table: {
        name_header: "Name",
        address_header: "Address",
        company_header: "Company",
        status_header: "Status"
      }
    },
    unit_of_measurement: {
      title: "Unit of Measurement",
      add_uom: "Add Unit",
      new_uom: "New Unit",
      edit_uom: "Edit Unit",
      delete_uom: "Delete UOM",
      delete_uom_item: "Delete Uom Item",
      basic_details: "Basic Details",
      msg: {
        confirm_delete: "Are you sure you want to delete UOM",
        confirm_delete_item: "Are you sure you want to delete Uom item",
        items_error: "Please Add UOM Items",
        unit_error: "Please select one unit of measure base unit True",
        base_unit_error: "Please Select Only One Base Unit"
      },
      uomModal: {
        title: "Add Item",
        uom_label: "Unit of measure",
        uom_placeholder: "Enter Unit of measure",
        symbol_label: "Symbol",
        symbol_placeholder: "Enter Symbol",
        base_unit_label: "Is Base Unit",
        conversation_factor_label: "Conversation Factor",
        conversation_factor_placeholder: "Enter Conversation Factor",
      },
      table: {
        unit_name_header: "Unit Name",
        symbol_header: "Symbol",
        base_unit_header: "Base Unit",
        status_header: "Status"
      }
    },
    stock_transfer: {
      name: "Stock Transfers",
      title: "This is STOCK TRANSFER module",
      add_label: "Add Stock Transfer",
      edit_label: "Edit Stock Transfer",
      draft_label: "Draft",
      view_label: "View Stock Transfer",
      source_location_label: "Source Location:",
      destination_location_label: "Destination Location:",
      add_item: "Add Item",
      msg: {
        save: "Stock Transfer saved successfully.",
        delete: "Stock Transfer deleted successfully.",
        error: "An error occurred while processing the Stock Transfer.",
        location_err: "Source Location And Destination Location cannot be same.",
        delete_item: 'Delete Item Entry',
        delete_item_msg: `Are you sure you want to delete Item Entry ? `,
        traceability_err: 'Traceability not possible as material out of stock for selected Location.',
        traceability_msg: 'Traceability is Completed.',
        delete_stock: 'Delete Stock Transfer',
        delete_stock_msg: `Are you sure you want to delete Stock Transfer ?`,
        operation_add_err: 'Something went wrong in operation add.',
        traceability_description: 'Changing the quantity or item will remove traceability data. Do you want to proceed?',
        trackingDetailsError: "Please add the tracking details",
        trackingDetailsUpdateError: "Something went wrong in tracking update",
        delete_stockTransfer: "Delete StockTransfer",
        delete_stockTransfer_msg: "Are you sure you want to delete StockTransfer ",
      },
      traceFields: {
        traceability: "Traceability",
        traceDetails_header: "Trace Details",
        item_label: "Item",
        location_label: "Location",
        destinationLocation_header: "Destination Location",
        availableQty_header: "Available",
        Qty_header: "Quantity",
        request_header: "Request",
        reserve_header: "Reserve",
        lot_header: "Lot/Serial number",
        lot_placeholder: "Select Lot/Serial number",
        lot_placeholder_input: "Enter Lot/Serial number",
        bin_header: "Bin number",
        bin_placeholder: "Select Bin number",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        add_lot_label: "Add Lot Number",
        type_label: "Type",
        type_placeholder: "Select Lot Number",
        lot_label: "Lot Number",
        lot_enter_placeholder: "Enter Lot Number",
        bin_label: "Bin",
        bin_add_placeholder: "Select Bin",
        lotList: "Lot/Serial Number List",
        lotEntries: "Lot/Serial Number Entries",
        confirm_delete: "Are you sure you want to delete?",
        delete_title: "Delete Entry"
      },
      fields: {
        id_label: "ID",
        from_warehouse_label: "From Warehouse",
        to_warehouse_label: "To Warehouse",
        date_label: "Date",
        status_label: "Status",
      },
      table: {
        id_header: "ID",
        from_warehouse_header: "From Warehouse",
        to_warehouse_header: "To Warehouse",
        date_header: "Date",
        status_header: "Status",
        trace_detail: "Track Detail",
        company_header: "Company",
        source_location_header: "Source Location",
        destination_location_header: "Destination Location",
        contact_person_header: "Contact Person",
        scheduled_date_header: "Scheduled Date",
      },
      item_table: {
        add_item: "Add Item",
        item_header: "Item",
        item_placeholder: "Select Item",
        request_quantity_header: "Request Quantity",
        source_available_quantity_header: "Source Available Quantity",
        destination_available_quantity_header: 'Destination Available Quantity',
        back_ordered_header: "Back Order",
        landedCost_header: "Is Landed Cost",
        vendor_header: "Vendor Item Name",
        vendor_placeholder: "Enter Vendor Item Name",
        uom_header: "UoM",
        uom_placeholder: "Select UoM",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        description_header: "Description",
        description_placeholder: "Enter Description",
        rate_header: "Rate",
        rate_placeholder: "Enter Rate",
        transfer_quantity_header: "Transfer Quantity",
        transfer_amount_header: "Transfer Amount",
        operation_type_header: "operation Type",
        discountItem_header: "Discount Item",
        discountItem_placeholder: "Select Discount Item",
        discountRate_header: "Discount Rate (%)",
        discountRate_placeholder: "Discount Rate",
        grossAmount_header: "Gross Amount",
        grossAmount_placeholder: "Gross Amount",
        taxRate_header: "Tax Rate",
        taxRate_placeholder: "Tax Rate",
        taxAmount_header: "Tax Amount",
        taxAmount_placeholder: "Tax Amount",
        discountAmount_header: "Discount Amount",
        discountAmount_placeholder: "Discount Amount",
        netAmount_header: "Net Amount",
        netAmount_placeholder: "Net Amount",
        totalAmount_header: "Total Amount",
        totalAmount_placeholder: "Total Amount",
        taxTemplate_header: "Tax Template",
        taxTemplate_placeholder: "Select Tax Template",
        location_header: "Location",
        location_placeholder: "Select Location",
        department_header: "Department",
        department_placeholder: "Select Department",
        classification_header: "Classification",
        classification_placeholder: "Select Classification",
        narration_header: "Narration",
        narration_placeholder: "Enter Narration",
        poLine_header: "Purchase Order Line",
        onHand_header: "On Hand",
        remaining_header: "Remaining",
        available_header: "Available",
        traceDetails_header: "Trace Details",
        orderLine_header: "Order Line",
      },
    },
    bin_transfer: {
      title: "Bin Transfer",
      add_label: "Add New Bin Transfer",
      edit_label: "Edit Bin Transfer",
      new_bin_transfer: "New BinTransfer",
      draft: "Draft",
      view_label: "View Bin Transfer",
      source_location_label: "Source Location:",
      destination_location_label: "Destination Location:",
      add_item: "Add Item",
      msg: {
        save: "Bin transfer saved successfully.",
        delete: "Bin transfer deleted successfully.",
        error: "An error occurred while processing the Bin transfer.",
        itemSave: "Item saved successfully.",
        itemSaveError: "Something went wrong in an item save",
        itemDelete: "Item deleted successfully",
        itemDeleteError: "Something went wrong in an item delete",
        delete_binTransfer: "Delete BinTransfer",
        delete_binTransfer_msg: "Are you sure you want to delete BinTransfer ",
        location_err: "Source Bin And Destination Bin cannot be same.",
        delete_binTransfer_item: 'Delete BinTransfer Item',
        delete_binTransfer_item_msg: "Are you sure you want to delete BinTransfer item ?",
        operation_add_error: 'Something went wrong in operation add.',
        trace_error: "Changing the quantity or item will remove traceability data. Do you want to proceed?",
        trace_error_msg: 'Traceability not possible as material out of stock for selected Location.',
        trace_completed: 'Traceability is Completed.',
        delete_bin_msg: "Are you sure you want to delete Bin",
      },
      fields: {
        id_label: "ID",
        from_warehouse_label: "From Warehouse",
        to_warehouse_label: "To Warehouse",
        date_label: "Date",
        status_label: "Status",
        delete_bin: "Delete Bin",
        delee_bin_transfer: "Delete BinTransfer"

      },
      table: {
        id_header: "ID",
        from_warehouse_header: "From Warehouse",
        to_warehouse_header: "To Warehouse",
        date_header: "Date",
        status_header: "Status",
        location_header: "Location",
        source_bin_header: "Source Bin",
        destination_bin_header: "Destination Bin",
        contact_person_header: "Contact person",
        company_header: "Company"
      },
      traceFields: {
        traceability: "Traceability",
        traceDetails_header: "Trace Details",
        item_label: "Item",
        location_label: "Location",
        destinationLocation_header: "Destination Location",
        availableQty_header: "Available",
        Qty_header: "Quantity",
        request_header: "Request",
        reserve_header: "Reserve",
        lot_header: "Lot/Serial number",
        lot_placeholder: "Select Lot/Serial number",
        lot_placeholder_input: "Enter Lot/Serial number",
        bin_header: "Bin number",
        bin_placeholder: "Select Bin number",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        add_lot_label: "Add Lot Number",
        type_label: "Type",
        type_placeholder: "Select Lot Number",
        lot_label: "Lot Number",
        lot_enter_placeholder: "Enter Lot Number",
        bin_label: "Bin",
        bin_add_placeholder: "Select Bin",
        lotList: "Lot/Serial Number List",
        lotEntries: "Lot/Serial Number Entries",
        confirm_delete: "Are you sure you want to delete?",
        delete_title: "Delete Entry",
        bin_number: "Bin Number",
        bin_number_placeholder: "Select Bin Number",
        source_available_header: "Source Available Quantity",
        destination_available_header: "Destination Available Quantity",
      },
      item_table: {
        add_item: "Add Item",
        item_header: "Item",
        item_placeholder: "Select Item",
        request_quantity_header: "Request Quantity",
        source_available_quantity_header: "Source Available Quantity",
        destination_available_quantity_header: 'Destination Available Quantity',
        back_ordered_header: "Back Order",
        landedCost_header: "Is Landed Cost",
        vendor_header: "Vendor Item Name",
        vendor_placeholder: "Enter Vendor Item Name",
        uom_header: "UoM",
        uom_placeholder: "Select UoM",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        description_header: "Description",
        description_placeholder: "Enter Description",
        rate_header: "Rate",
        rate_placeholder: "Enter Rate",
        transfer_quantity_header: "Transfer Quantity",
        transfer_quantity_placeholder: "Enter Transfer Quantity",
        transfer_amount_header: "Transfer Amount",
        amount_header: "Amount",
        source_available_header: "Source Available",
        source_available_placeholder: "Enter Source Available",
        destination_available_header: "Destination Available",
        destination_available_placeholder: "Enter Destination Available",
        operation_type_header: "operation Type",
        discountItem_header: "Discount Item",
        discountItem_placeholder: "Select Discount Item",
        discountRate_header: "Discount Rate (%)",
        discountRate_placeholder: "Discount Rate",
        grossAmount_header: "Gross Amount",
        grossAmount_placeholder: "Gross Amount",
        taxRate_header: "Tax Rate",
        taxRate_placeholder: "Tax Rate",
        taxAmount_header: "Tax Amount",
        taxAmount_placeholder: "Tax Amount",
        discountAmount_header: "Discount Amount",
        discountAmount_placeholder: "Discount Amount",
        netAmount_header: "Net Amount",
        netAmount_placeholder: "Net Amount",
        totalAmount_header: "Total Amount",
        totalAmount_placeholder: "Total Amount",
        taxTemplate_header: "Tax Template",
        taxTemplate_placeholder: "Select Tax Template",
        location_header: "Location",
        location_placeholder: "Select Location",
        department_header: "Department",
        department_placeholder: "Select Department",
        classification_header: "Classification",
        classification_placeholder: "Select Classification",
        narration_header: "Narration",
        narration_placeholder: "Enter Narration",
        poLine_header: "Purchase Order Line",
        onHand_header: "On Hand",
        remaining_header: "Remaining",
        available_header: "Available",
        traceDetails_header: "Trace Details",
        orderLine_header: "Order Line",
      },
    },
    scrap: {
      title: "Scrap",
      add_label: "New Scrap",
      edit_label: "Edit Scrap",
      fields: {
        id_label: "ID",
        date_label: "Date",
        status_label: "Status",
      },
      msg: {
        location_err: "Source Location And Destination Location cannot be same.",
        delete_item: 'Delete Item Entry',
        delete_item_msg: `Are you sure you want to delete Item Entry ? `,
        delete_operational: "Delete Operational Item",
        delete_operational_msg: "Are you sure you want to delete?",
        traceability_err: 'Traceability not possible as material out of stock for selected Location.',
        traceability_msg: 'Traceability is Completed.',
        delete_stock: 'Delete Stock Transfer',
        delete_stock_msg: `Are you sure you want to delete Stock Transfer ?`,
        operation_add_err: 'Something went wrong in operation add.',
        traceability_description: 'Changing the quantity or item will remove traceability data. Do you want to proceed?',
        trackingDetailsError: "Please add the tracking details",
        trackingDetailsUpdateError: "Something went wrong in tracking update",
        trackingError: "Tracking needs to be generated for the items",
        delete_scrap: "Delete Scrap",
        delete_scrap_msg: `Are you sure you want to delete?`,
        delete_category: "Delete Category",
        delete_category_msg: `Are you sure you want to delete?`,

      },
      traceFields: {
        traceability: "Traceability",
        traceDetails_header: "Trace Details",
        item_label: "Item",
        select_item: "Select Item",
        location_label: "Location",
        destinationLocation_header: "Destination Location",
        availableQty_header: "Available",
        Qty_header: "Quantity",
        requestedQty_header: "Requested Quantity",
        request_header: "Request",
        reserve_header: "Reserve",
        reserve_quantity_header: "Reserve Quantity",
        lot_header: "Lot/Serial number",
        lot_placeholder: "Select Lot/Serial number",
        lot_placeholder_input: "Enter Lot/Serial number",
        bin_header: "Bin number",
        bin_placeholder: "Select Bin number",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        add_lot_label: "Add Lot Number",
        type_label: "Type",
        type_placeholder: "Select Lot Number",
        lot_label: "Lot Number",
        lot_enter_placeholder: "Enter Lot Number",
        bin_label: "Bin",
        bin_add_placeholder: "Select Bin",
        lotList: "Lot/Serial Number List",
        lotEntries: "Lot/Serial Number Entries",
        confirm_delete: "Are you sure you want to delete?",
        delete_title: "Delete Entry",
        bin_number: "Bin Number",
        bin_number_placeholder: "Select Bin Number",
        source_available_header: "Source Available Quantity",
        destination_available_header: "Destination Available Quantity",
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        status_header: "Status",
        company_header: "Company",
        source_location_header: "Source Location",
        destination_location_header: "Destination Location",
        contact_person_header: "Contact Person",
        scheduled_date_header: "Scheduled Date",
      },
      item_table: {
        add_item: "Add Item",
        item_header: "Item",
        item_placeholder: "Select Item",
        request_quantity_header: "Request Quantity",
        source_available_quantity_header: "Source Available Quantity",
        destination_available_quantity_header: 'Destination Available Quantity',
        back_ordered_header: "Back Order",
        landedCost_header: "Is Landed Cost",
        vendor_header: "Vendor Item Name",
        vendor_placeholder: "Enter Vendor Item Name",
        uom_header: "UoM",
        uom_placeholder: "Select UoM",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        description_header: "Description",
        description_placeholder: "Enter Description",
        rate_header: "Rate",
        rate_placeholder: "Enter Rate",
        transfer_quantity_header: "Transfer Quantity",
        transfer_amount_header: "Transfer Amount",
        operation_type_header: "operation Type",
        discountItem_header: "Discount Item",
        discountItem_placeholder: "Select Discount Item",
        discountRate_header: "Discount Rate (%)",
        discountRate_placeholder: "Discount Rate",
        grossAmount_header: "Gross Amount",
        grossAmount_placeholder: "Gross Amount",
        taxRate_header: "Tax Rate",
        taxRate_placeholder: "Tax Rate",
        taxAmount_header: "Tax Amount",
        taxAmount_placeholder: "Tax Amount",
        discountAmount_header: "Discount Amount",
        discountAmount_placeholder: "Discount Amount",
        netAmount_header: "Net Amount",
        netAmount_placeholder: "Net Amount",
        totalAmount_header: "Total Amount",
        totalAmount_placeholder: "Total Amount",
        taxTemplate_header: "Tax Template",
        taxTemplate_placeholder: "Select Tax Template",
        location_header: "Location",
        location_placeholder: "Select Location",
        department_header: "Department",
        department_placeholder: "Select Department",
        classification_header: "Classification",
        classification_placeholder: "Select Classification",
        narration_header: "Narration",
        narration_placeholder: "Enter Narration",
        poLine_header: "Purchase Order Line",
        onHand_header: "On Hand",
        remaining_header: "Remaining",
        available_header: "Available",
        traceDetails_header: "Trace Details",
        orderLine_header: "Order Line",
      },
    },
    inventory_adjustment: {
      name: "Inventory Adjustment",
      title: "This is INVENTORY ADJUSTMENT module",
      add_label: "New Inventory Adjustment",
      edit_label: "Edit Inventory Adjustment",
      add_reason: "Add Reason",
      reson_name: "Reason Name",
      reson_name_placeholder: "Enter Reason Name",
      table: {
        id_header: "ID",
        date_header: "Date",
        status_header: "Status",
        company_header: "Company",
        account_header: "Account",
        reason_header: "Reason",
        narration_header: "Narration"
      },
      msg: {
        location_err: "Source Location And Destination Location cannot be same.",
        delete_item: 'Delete Item Entry',
        delete_item_msg: `Are you sure you want to delete Item Entry ? `,
        delete_operational: "Delete Operational Item",
        delete_operational_msg: "Are you sure you want to delete?",
        traceability_err: 'Traceability not possible as material out of stock for selected Location.',
        traceability_msg: 'Traceability is Completed.',
        delete_stock: 'Delete Stock Transfer',
        delete_stock_msg: `Are you sure you want to delete Stock Transfer ?`,
        operation_add_err: 'Something went wrong in operation add.',
        traceability_description: 'Changing the quantity or item will remove traceability data. Do you want to proceed?',
        trackingDetailsError: "Please add the tracking details",
        trackingDetailsUpdateError: "Something went wrong in tracking update",
        trackingError: "Tracking needs to be generated for the items",
        deleteInventoryAdjustmentItem: "Delete InventoryAdjustment Item",
        deleteInventoryAdjustmentItemMsg: `Are you sure you want to delete Inventory Adjustment?`,
        serialQuantityError: "The quantity cannot be more than 1 for items with serial number tracking",
        changeInventoryItemQuantity: "Change Inventory Item Quantity",
        changeInventoryItemQuantityMsg: "Are you sure you want to change Item Quantity ?"
      },
      traceFields: {
        traceability: "Traceability",
        traceDetails_header: "Trace Details",
        item_label: "Item",
        select_item: "Select Item",
        location_label: "Location",
        destinationLocation_header: "Destination Location",
        availableQty_header: "Available",
        Qty_header: "Quantity",
        requestedQty_header: "Requested Quantity",
        request_header: "Request",
        reserve_header: "Reserve",
        reserve_quantity_header: "Reserve Quantity",
        available_quantity_header: "Available Quantity",
        available_quantity_placeholder: "Select Available Quantity",
        lot_header: "Lot/Serial number",
        lot_placeholder: "Select Lot/Serial number",
        lot_placeholder_input: "Enter Lot/Serial number",
        bin_header: "Bin number",
        bin_placeholder: "Select Bin number",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        add_lot_label: "Add Lot Number",
        type_label: "Type",
        type_placeholder: "Select Lot Number",
        lot_label: "Lot Number",
        lot_enter_placeholder: "Enter Lot Number",
        bin_label: "Bin",
        bin_add_placeholder: "Select Bin",
        lotList: "Lot/Serial Number List",
        lotEntries: "Lot/Serial Number Entries",
        confirm_delete: "Are you sure you want to delete?",
        delete_title: "Delete Entry",
        bin_number: "Bin Number",
        bin_number_placeholder: "Select Bin Number",
        source_available_header: "Source Available Quantity",
        destination_available_header: "Destination Available Quantity",
        delete_inventory_adjustment: "Delete inventoryAdjustment",
        delete_inventory_adjustment_msg: "Are you sure you want to delete Inventory Adjustment"
      },
      item_table: {
        add_item: "Add Item",
        item_header: "Item",
        item_placeholder: "Select Item",
        request_quantity_header: "Request Quantity",
        source_available_quantity_header: "Source Available Quantity",
        destination_available_quantity_header: 'Destination Available Quantity',
        back_ordered_header: "Back Order",
        backOrdered_placeholder: "Select Back Order",
        landedCost_header: "Is Landed Cost",
        vendor_header: "Vendor Item Name",
        vendor_placeholder: "Enter Vendor Item Name",
        uom_header: "UoM",
        uom_placeholder: "Select UoM",
        quantity_header: "Quantity",
        amount_label: "Amount",
        quantity_placeholder: "Enter Quantity",
        description_header: "Description",
        description_placeholder: "Enter Description",
        rate_header: "Rate",
        rate_placeholder: "Enter Rate",
        transfer_quantity_header: "Transfer Quantity",
        transfer_amount_header: "Transfer Amount",
        operation_type_header: "operation Type",
        discountItem_header: "Discount Item",
        discountItem_placeholder: "Select Discount Item",
        discountRate_header: "Discount Rate (%)",
        discountRate_placeholder: "Discount Rate",
        grossAmount_header: "Gross Amount",
        grossAmount_placeholder: "Gross Amount",
        taxRate_header: "Tax Rate",
        taxRate_placeholder: "Tax Rate",
        taxAmount_header: "Tax Amount",
        taxAmount_placeholder: "Tax Amount",
        discountAmount_header: "Discount Amount",
        discountAmount_placeholder: "Discount Amount",
        netAmount_header: "Net Amount",
        netAmount_placeholder: "Net Amount",
        totalAmount_header: "Total Amount",
        totalAmount_placeholder: "Total Amount",
        taxTemplate_header: "Tax Template",
        taxTemplate_placeholder: "Select Tax Template",
        location_header: "Location",
        location_placeholder: "Select Location",
        department_header: "Department",
        department_placeholder: "Select Department",
        classification_header: "Classification",
        classification_placeholder: "Select Classification",
        narration_header: "Narration",
        narration_placeholder: "Enter Narration",
        poLine_header: "Purchase Order Line",
        onHand_header: "On Hand",
        remaining_header: "Remaining",
        available_header: "Available",
        traceDetails_header: "Trace Details",
        orderLine_header: "Order Line",
      },
    },
    settings: {
      landed_cost_label: "Is Landed Cost",
      msg: {
        update_success: "Inventory Setting updated successfully"
      }
    },
    inventory_valuation: {
      title: "Inventory Valuation",
      title_header: "Inventory Valuation Detail",
      totalValue: 'Total Value by Category',
      stockStatus: 'Stock Status Distribution',
      summary_view: 'Summary View',
      nothing_to_show: "Nothing to show",
      nothing: "Nothing is here to show you",
      delete_bank: "Delete Bank",
      delete_bank_description: "Are you sure you want to delete this bank?",
      download_report: "Download Report",
      detail_view: 'Detail View',
    },
    reorder: {
      title: "Reorder",
      title_header: "Reorder Detail",
      nothing_to_show: "Nothing to show",
      nothing: "Nothing is here to show you",
      delete_bank: "Delete Bank",
      delete_bank_description: "Are you sure you want to delete this bank?",
      download_report: "Download Report",
      detail_view: 'Detail View',
    },
    stock_status: {
      title: "Stock Status",
      title_header: "Stock Status Detail",
      nothing_to_show: "Nothing to show",
      nothing: "Nothing is here to show you",
      delete_bank: "Delete Bank",
      delete_bank_description: "Are you sure you want to delete this bank?",
      download_report: "Download Report",
      detail_view: 'Detail View',
    },
    stock_movement: {
      title: "Stock Movement",
      title_header: "Stock Movement Detail",
      nothing_to_show: "Nothing to show",
      nothing: "Nothing is here to show you",
      delete_bank: "Delete Bank",
      delete_bank_description: "Are you sure you want to delete this bank?",
      download_report: "Download Report",
      detail_view: 'Detail View',
    },
    expiry_date: {
      title: "Expiry Date",
      title_header: "Expiry Date Detail",
      nothing_to_show: "Nothing to show",
      nothing: "Nothing is here to show you",
      delete_bank: "Delete Bank",
      delete_bank_description: "Are you sure you want to delete this bank?",
      download_report: "Download Report",
      detail_view: 'Detail View',
    },
    stockReconciliationReport: {
      title: "Stock Reconciliation",
    },
    slowMovingInventoryReport: {
      title: "Slow-Moving Inventory",
    },
    warehouseStockAgingReport: {
      title: "Warehouse Stock Aging",
    },
    warehouseTransfersReport: {
      title: "Warehouse Transfers",
    },
    returnToVendorReport: {
      title: "Return to Vendor",
    },
  },
  project: {
    name: "Project",
    title: "This is PROJECT module",
  },
  procurement: {
    name: "Procurement",
    title: "This is PROCUREMENT module",
    dashboard: {
      title: "Dashboard",
      all_time_label: "All Time",
    },
    purchaseOrder: {
      title: "Purchase Order",
      add_label: "Add New Purchase Order",
      edit_label: "Edit Purchase Order",
      msg: {
        save: "Purchase order saved successfully.",
        delete: "Purchase order deleted successfully.",
        error: "An error occurred while processing the Purchase order.",
        itemSave: "Item saved successfully.",
        itemSaveError: "Something went wrong in an item save",
        itemDelete: "Item deleted successfully",
        itemDeleteError: "Something went wrong in an item save",
        requestApproved: "Purchase Order has been approved successfully.",
        requestRejected: "Purchase Order has been rejected successfully.",
        requestSubmitted: "Purchase Order has been submitted for approval",
        requiredItemsError: "Please fill required field in items",
        requiredError: "Please fill atleast one field",
        allRequiredError: "Please fill all the required fields",
        requiredItemExpenseError: "Please add at least one item or expense",
        confirmDeleteItem: "Are you sure you want to delete item?",
        confirmDeleteExpense: "Are you sure you want to delete expense?",
        confirmDeleteEntry: "Are you sure you want to delete entry?",
        confirmUpdate: "Are you sure you want to update status?"
      },
      sections: {
        items: "Items",
        attachment: "Attachment",
        companyShippibngAddress: "Company Shipping Address",
        companyBillingAddress: "Company Billing Address",
        classification: "Classification",
        discounts: "Discounts",
        subtotal: "Subtotal",
        taxesAndCharges: "Taxes and Charges",
        total: "Totals",
      },
      fields: {
        id_label: "ID",
        id_placeholder: "Purchase Order ID",
        poId_label: "Purchase Order",
        grnId_label: "ID",
        grnId_placeholder: "ID",
        date_label: "Date",
        date_placeholder: "Select Date",
        supplier_label: "Supplier",
        supplier_placeholder: "Select Supplier",
        vendor_label: "Vendor",
        vendor_placeholder: "Select Vendor",
        company_label: "Company",
        company_placeholder: "Select Company",
        location_label: "Location",
        location_placeholder: "Select Location",
        confirmation_label: "Confirmation Date",
        confirmation_placehodler: "Select Date",
        expectedReceipt_label: "Expected Receipt Date",
        expectedReceipt_placehodler: "Select Date",
        agreement_label: "Agreement",
        agreement_placeholder: "Select Agreement",
        currency_label: "Currency",
        currency_placeholder: "Select Currency",
        exchangeRate_label: "Exchange Rate",
        exchangeRate_placeholder: "0.00",
        paymentTerm_label: "Payment Terms",
        paymentTerm_placeholder: "Select Payment Terms",
        purchaseRepresentavive_label: "Purchase Representative",
        purchaseRepresentavive_placeholder: "Select Purchase Representative",
        referenceNo_label: "Reference No.",
        referenceNo_placeholder: "Enter Reference No.",
        incoTerm_label: "Incoterm",
        incoTerm_placeholder: "Select Incoterm",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        department_label: "Department",
        department_placeholder: "Select Department",
        attachment_label: "Attach your file here",
        attachedFile_label: "Attached File",

        supplierAddress_label: "Supplier Address",
        supplierAddress_placeholder: "Select Supplier Address",

        contactPerson_label: "Contact Person",
        contactPerson_placeholder: "Select Contact Person",

        shippingAddress_label: "Shipping Address",
        shippingAddress_placeholder: "Select Shipping Address",
        billingAddress_label: "Billing Address",
        billingAddress_placeholder: "Select Billing Address",
        placeOfSupply_label: "Place of Supply",
        placeOfSupply_placeholder: "Select Place of Supply",

        totalQty_label: "Total Quantity",
        total_label: "Total (INR)",
        itemDiscount_label: "Item Discount",
        additionalDiscount_label: "Additional Discount",
        totalDiscount_label: "Total Discount",
        subtotalExcludingTaxes_label: "Subtotal Excluding Taxes",
        subtotalExcludingDiscount_label: "Subtotal Excluding Discount",
        taxesAndChargesAdded_label: "Taxes & Charges Added",
        taxesAndChargesDeducted_label: "Taxes & Charges Deducted",
        totalTaxesAndChargesAdded_label: "Total Taxes and Charges Added",
        grandTotal_label: "Grand Total",
        roundOffDifference_label: "Round Off Difference",

        tax_code_label: "Tax Code",
        tax_rate_label: "Tax Rate",
        amount_label: "Amount",
        tax_label: "Tax",
        classification: "Classification",

        add_item_label: "Add Item",
        update_status_label: "Update Status"

      },
      table: {
        id_header: "ID",
        date_header: "Date",
        referenceNo_header: "Reference No.",
        confirmationDate_header: "Confirmation Date",
        vendor_header: "Vendor",
        purchaseRepresentative_header: "Purchase Representative",
        company_header: "Company",
        expectedReceipt_header: "Expected Receipt Date",
        totalValue_header: "Total Value",
        status_header: "Status",
        billingStatus_header: "Billing Status",
        receivingStatus_header: "Receiving Status",
      },
      item_table: {
        item_header: "Item",
        item_placeholder: "Select Item",
        landedCost_header: "Is Landed Cost",
        vendor_header: "Vendor Item Name",
        vendor_placeholder: "Enter Vendor Item Name",
        uom_header: "UoM",
        uom_placeholder: "Select UoM",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        description_header: "Description",
        description_placeholder: "Enter Description",
        rate_header: "Rate",
        rate_placeholder: "Enter Rate",
        discountItem_header: "Discount Item",
        discountItem_placeholder: "Select Discount Item",
        discountRate_header: "Discount Rate (%)",
        discountRate_placeholder: "Discount Rate",
        grossAmount_header: "Gross Amount",
        grossAmount_placeholder: "Gross Amount",
        taxRate_header: "Tax Rate",
        taxRate_placeholder: "Tax Rate",
        taxAmount_header: "Tax Amount",
        taxAmount_placeholder: "Tax Amount",
        discountAmount_header: "Discount Amount",
        discountAmount_placeholder: "Discount Amount",
        netAmount_header: "Net Amount",
        netAmount_placeholder: "Net Amount",
        totalAmount_header: "Total Amount",
        totalAmount_placeholder: "Total Amount",
        taxTemplate_header: "Tax Template",
        taxTemplate_placeholder: "Select Tax Template",
        location_header: "Location",
        location_placeholder: "Select Location",
        department_header: "Department",
        department_placeholder: "Select Department",
        classification_header: "Classification",
        classification_placeholder: "Select Classification",
        narration_header: "Narration",
        narration_placeholder: "Enter Narration",
        poLine_header: "Purchase Order Line",
        onHand_header: "On Hand",
        remaining_header: "Remaining",
        available_header: "Available",
        traceDetails_header: "Trace Details",
      },
      expense_table: {
        title: "Expense Detail",
        account_header: "Account",
        account_placeholder: "Select Account",
        rate_header: "Rate",
        rate_placeholder: "Enter Rate",
        discountItem_header: "Discount Item",
        discountItem_placeholder: "Select Discount Item",
        discountRate_header: "Discount Rate (%)",
        discountRate_placeholder: "Discount Rate",
        grossAmount_header: "Gross Amount",
        grossAmount_placeholder: "Gross Amount",
        taxRate_header: "Tax Rate",
        taxRate_placeholder: "Tax Rate",
        taxAmount_header: "Tax Amount",
        taxAmount_placeholder: "Tax Amount",
        discountAmount_header: "Discount Amount",
        discountAmount_placeholder: "Discount Amount",
        netAmount_header: "Net Amount",
        netAmount_placeholder: "Net Amount",
        totalAmount_header: "Total Amount",
        totalAmount_placeholder: "Total Amount",
        taxTemplate_header: "Tax Template",
        taxTemplate_placeholder: "Select Tax Template",
        taxCode_header: "Tax Code",
        taxCode_placeholder: "Select Tax Code",
        location_header: "Location",
        location_placeholder: "Select Location",
        department_header: "Department",
        department_placeholder: "Select Department",
        narration_header: "Narration",
        narration_placeholder: "Enter Narration",
      },
      bills_table: {
        id_header: "ID",
        date_header: "Date",
        totalValue_header: "Total Value",
        status_header: "Status",
        paymentStatus_header: "Payment Status",
      },
      tabs: {
        basicDetails: "Basic Details",
        addressAndContact: "Address & Contact",
      },
      itemsTabs: {
        itemEntries: "Item Entries",
        expensed: "Expenses",
      },
      grn: {
        title: "Goods Receipt",
        add_label: "Goods Receipt Note",
        edit_label: "Edit Goods Receipt Note",
        table: {
          id_header: "ID",
          date_header: "Date",
          vendor_header: "Vendor",
          company_header: "Company",
          currency_header: "Currency",
          referenceNo_header: "Ref. No",
          status_header: "Status",
        },
        msg: {
          save: "Goods Receipt Note saved successfully.",
          delete: "Goods Receipt Note deleted successfully.",
          error: "An error occurred while processing the Goods Receipt Note.",
          itemSave: "Item saved successfully.",
          itemSaveError: "Something went wrong in an item save",
          itemDelete: "Item deleted successfully",
          itemDeleteError: "Something went wrong in an item save",
          quantityError: "Quantity must be less than the remaining quantity",
          updateItemError: "Something went wrong while updating item",
          tracibility_message: "Changing the quantity or item will remove traceability data. Do you want to proceed?",
          traceability_success: "Traceability is Completed.",
          serialError: "This serial Number is already available",
          lotError: "This lot Number is already available",
          trackingDetailsError: "Please add the tracking details",
          trackingDetailsUpdateError: "Something went wrong in tracking updates",
          validateTrackingError: "Please add the tracking details to validate",
          grnScrapError: "Something went wrong in GRN Scrap"
        },
      },
      bills: {
        title: "Bills",
      },
      traceFields: {
        traceability: "Traceability",
        traceDetails_header: "Trace Details",
        item_label: "Item",
        location_label: "Location",
        destinationLocation_header: "Destination Location",
        availableQty_header: "Available",
        Qty_header: "Quantity",
        request_header: "Request",
        reserve_header: "Reserve",
        lot_header: "Lot/Serial number",
        lot_placeholder: "Select Lot/Serial number",
        bin_header: "Bin number",
        bin_placeholder: "Select Bin number",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",

        add_lot_label: "Add Lot Number",
        type_label: "Type",
        type_placeholder: "Select Lot Number",
        lot_label: "Lot Number",
        lot_enter_placeholder: "Enter Lot Number",
        bin_label: "Bin",
        bin_add_placeholder: "Select Bin"
      },
      buttons: {
        receive: "Receive",
        grn: "GRN",
        return: "Return",
        bill: "Bill",
        printGRN: 'Print GRN',
        printLabel: 'Print Label',
        grns: "GRNs",
        bills: "Bills",
        returns: "Returns"
      }
    },
    requestForQuote: {
      title: "Request for Quote",
      add_label: "Add New Request for Quote",
      add_response_label: "Add New Request for Quote Response",
      edit_label: "Edit Request for Quote",
      edit_response_label: "Edit Request for Quote Response",
      detail_label: "Request for Quote Details",
      previouse_price_msg: "See Previous Prices",
      response_title: "Responses",
      call_for_tender: "Call For Tender",
      select_company: "Select Company",
      select_assembly: "Select Assembly Item",
      select_warehouse: "Select warehouse",
      select_bom: "Select BoM",
      filter: "Filter",
      date_range: " Date Range:",
      date: "Date:",
      company: "Company:",
      assembly: "Assembly Items",
      location: "Location:",
      item: "Item:",
      bom: "BOM:",
      filter_by: "Filter By",
      clear_filter: "Clear Filter",
      sort: "Sort",
      add_item: "Add Item",
      edit_item: "Edit Item",
      add_commnent: "Add Comment",
      comment: "Comment",
      filterByResponseDate: "Filter By Response Date",
      alredy_awarded:
        "You have already selected the vendor for this item. Do you want to update the vendor details?",
      warn_awarded:
        "You have already selected other vendor for this item",
      msg: {
        save: "Request for quote saved successfully.",
        delete: "Request for quote deleted successfully.",
        cancel: "Are you sure you want to Cancel",
        error: "An error occurred while processing the Request for quote.",
        tendor: "Call For Tender",
        repsoneSave: "Response for quote saved successfully.",
        req_field_err: "Please fill atleast one field",
        delete_item: "Are you sure you want to delete item ?",
        delete_tender: "Are you sure you want to delete tender ?",
        all_field_err: "Please fill all the required fields.",
        update_status: "Update Status",
        update_status_msg: "Are you sure you want to update status?",
        enter_comment: 'Please enter a comment',
      },
      button: {
        response: "Response",
        order: "Order",
        agreement: "Agreement",
        rfq: "RFQ",
        orders: "Orders",
      },
      tabs: {
        basicDetails: "Basic Details",
        addressAndContact: "Address & Contact",
      },
      sections: {
        generalDetail: "Basic Detail",
        upload: "Attachment",
        classification: "Classification",
        items: "Items",
        discounts: "Discounts",
        call_for_tender: "Call For Tender",
        companyShippibngAddress: "Company Shipping Address",
        companyBillingAddress: "Company Billing Address",
      },
      dropdown: {
        print: "Print RFQ",
        sendEmail: "Send Email",
      },
      fields: {
        id_label: "ID",
        id_placeholder: "ID",
        date_label: "Date",
        date_placeholder: "Select Date",
        copy_product: "Copy Product",
        rfq_id_label: "RFQ ID",
        department_label: "Department",
        department_placeholder: "Select Department",
        orderDeadline_label: "Order Deadline",
        orderDeadline_placeholder: "Select Date",
        expectedRequiredDate_label: "Expected Required Date",
        expectedRequiredDate_placeholder: "Select Date",
        purchaseRepresentavive_label: "Purchase Representative",
        purchaseRepresentavive_placeholder: "Select Purchase Representative",
        paymentTerm_label: "Payment Terms",
        paymentTerm_placeholder: "Select Payment Terms",
        referenceNo_label: "Reference No.",
        lead_label: "Lead Time",
        lead_placeholder: "Enter Lead Time",
        referenceNo_placeholder: "Enter Reference No.",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        attachment_label: "Attach your file here",
        supplierAddress_label: "Supplier Address",
        supplierAddress_placeholder: "Select Supplier Address",
        contactPerson_label: "Contact Person",
        contactPerson_placeholder: "Select Contact Person",
        vendor_header: "Vendor",
        purchaseRepresentative_header: "Purchase Representative",
        company_label: "Company",
        company_placeholder: "Select Company",
        location_label: "Location",
        order_deadline_label: "Order Deadline",
        expected_required_date_label: "Expected Required Date",
        currency_label: "Currency",
        currency_placeholder: "Select Currency",
        exchangeRate_label: "Exchange Rate",
        view_attachment_label: "Attached file",
        vendor_label: "Vendor",
        vendor_placeholder: "Select Vendor",
        location_placeholder: "Select Location",
        exchangeRate_placeholder: "Enter Exchange Rate",
        incoterms_label: "Incoterms",
        incoterms_placeholder: "Select Incoterms",
        condition_header: "Condition",
        rate_header: "Rate",
        shippingAddress_label: "Shipping Address",
        shippingAddress_placeholder: "Select Shipping Address",
        billingAddress_label: "Billing Address",
        billingAddress_placeholder: "Select Billing Address",
        placeOfSupply_label: "Place of Supply",
        placeOfSupply_placeholder: "Select Place of Supply",
        search_company: 'Search Company',
        filter_by_company: 'Filter by Company',
        search_vendor: 'Search Vendor',
        filter_by_vendor: 'Filter by Vendor',
        search_items: 'Search Items',
        filter_by_items: 'Filter by Items',
        search_vendor_uom: 'Search Vendor UoM',
        filter_by_vendor_uom: 'Filter by Vendor UoM',
        search_currency: 'Search Currency',
        filter_by_currency: 'Filter by Currency',
        search_rfq: 'Search RFQ',
        filter_by_rfq: 'Filter by RFQ',
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        awarded_header: "Awarded",
        purchaseRepresentavive_label: "Purchase Representative",
        customer_header: "Customer",
        salesOrderStatus_header: "Sales Order Status",
        invoiceStatus_header: "Invoice Status",
        deliveryStatus_header: "Delivery Status",
        salesperson_header: "Salesperson",
        company_header: "Company",
        item_header: "Item",
        item_header_placeholder: "Select Item",
        orderDeadline_label: "Order Deadline",
        expectedRequiredDate_label: "Expected Required Date",
        uom_header: "UoM",
        requested_uom_header: "Requested UoM",
        vendor_uom_header: "Vendor UoM ",
        notes_header: "Notes",
        currency_label: "Currency",
        minimum_order_quantity: "Minimum Order Quantity",
        uom_header_placeholder: "Select UOM",
        description_header: "Description",
        description_header_placeholder: "Enter Description",
        expected_required_date_header: "Expected Required Date",
        expectedShippingDate_header_placeholder:
          "Select Expected Required Date",
        quantity_header: "Quantity",
        quantity_header_placeholder: "Enter Quantity",
        rate_header: "Rate",
        rate_header_placeholder: "Enter Rate",
        available_header: "Available",
        onHand_header: "On Hand",
        reserved_header: "Reserved",
        backOrdered_header: "Back Ordered",
        invoiced_header: "Invoiced",
        delivered_header: "Delivered",
        grossAmount_header: "Gross Amount",
        discountItem_header: "Discounted Item",
        discountedAmount_header: "Discount Amount",
        discountRate_header: "Discount Rate",
        netAmount_header: "Net Amount",
        taxTemplate_header: "Tax Template",
        taxAmount_header: "Tax Amount",
        totalAmount_header: "Total Amount",
        location_header: "Location",
        department_header: "Department",
        narration_header: "Narration",
        gross_amount_header: "Gross Amount",
        couponCode_header: "Coupon Code",
        account_header: "Account",
        type_header: "Type",
        promotionAmount_header: "Promotion Amount / %",
        promotion_amount_header: "Promotion Amount",
        discountAmount_header: "Discount Amount",
        referenceNo_header: "Reference No.",
        vendor_header: "Vendor",
        status_header: "Status",
        purchase_order_header: "Purchase Order",
        specification_header: "Specification",
        requested_quanity_header: "Requested Quantity",
        estimated_quantity_header: "Estimated Order Quantity Per Year",
        classification_header: "Classification",
        rfq_header: "RFQ ID",
        condition_header: "Condition",
        response_id_header: "Response ID",
        response_date_header: "Response Date",
        lead_time_header: "Lead Time",
        response_message_header: "Response Message",
        vendor_id_header: "Vendor ID",
        vendor_name_header: "Vendor Name",
        rate_in_base_currency: "Rate In Base Currency",
        rate_in_foreign_currency: "Rate In Foreign Currency",
      },
      item_table: {
        item_header: "Item",
        item_placeholder: "Select Item",
        landedCost_header: "Is Landed Cost",
        purchase_order: "Purchase Order",
        vendor_header: "Vendor Item Name",
        vendor_placeholder: "Enter Vendor Item Name",
        uom_header: "UoM",
        requested_uom: "Requested UoM",
        requested_uom_placeholder: "Select Requested UoM",
        vendor_uom: "Vendor UoM",
        vendor_uom_placeholder: "Select Vendor UoM",
        specification: "Specification",
        specification_placeholder: "Enter Specification",
        uom_placeholder: "Select UoM",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        description_header: "Description",
        description_placeholder: "Enter Description",
        requested_quantity_header: "Requested Quantity",
        requested_quantity_placeholder: "Enter Requested Quantity",
        estimated_quantity_per_year_header: "Estimated Quantity Per Year",
        estimated_quantity_per_year_placeholder: "Enter Estimated Quantity Per Year",
        rate_header: "Rate",
        rate_placeholder: "Enter Rate",
        min_order_quantity_header: "Minimum Order Quantity",
        min_order_quantity_placeholder: "Enter Minimum Order Quantity",
        discountItem_header: "Discount Item",
        discountItem_placeholder: "Select Discount Item",
        discountRate_header: "Discount Rate (%)",
        discountRate_placeholder: "Discount Rate",
        grossAmount_header: "Gross Amount",
        grossAmount_placeholder: "Gross Amount",
        taxRate_header: "Tax Rate",
        taxRate_placeholder: "Tax Rate",
        taxAmount_header: "Tax Amount",
        taxAmount_placeholder: "Tax Amount",
        discountAmount_header: "Discount Amount",
        discountAmount_placeholder: "Discount Amount",
        netAmount_header: "Net Amount",
        netAmount_placeholder: "Net Amount",
        totalAmount_header: "Total Amount",
        totalAmount_placeholder: "Total Amount",
        taxTemplate_header: "Tax Template",
        taxTemplate_placeholder: "Select Tax Template",
        location_header: "Location",
        location_placeholder: "Select Location",
        department_header: "Department",
        department_placeholder: "Select Department",
        classification_header: "Classification",
        classification_placeholder: "Select Classification",
        narration_header: "Narration",
        narration_placeholder: "Enter Narration",
        poLine_header: "Purchase Order Line",
        onHand_header: "On Hand",
        remaining_header: "Remaining",
        available_header: "Available",
        traceDetails_header: "Trace Details",
        condition_header: "Conditions",
      },
    },
    vendorReturns: {
      title: "Vendor Return Authorization",
      add_label: "Add New Vendor Return Authorization",
      edit_label: "Edit Vendor Return Authorization",
      msg: {
        save: "Vendor Return Authorization saved successfully.",
        delete: "Vendor Return Authorization deleted successfully.",
        error:
          "An error occurred while processing the Vendor Return Authorization.",
        itemSave: "Item saved successfully.",
        itemSaveError: "Something went wrong in an item save",
        itemDelete: "Item deleted successfully",
        itemDeleteError: "Something went wrong in an item save",
        requestApproved: "Vendor Return has approved successfully.",
        requestRejected: "Vendor Return has rejected successfully.",
        requestSubmitted: "Vendor Return has been submitted for approval",
        validated: "Vendor Return validated successfully",
        closed: "Vendor Return closed successfully",
        saveDraftError: "Please fill atleast one field",
        confirmDeleteItem: "Are you sure you want to delete item?",
        required_error: "Please fill all the required fields.",
      },
      sections: {
        items: "Items",
        attachment: "Attachment",
        companyShippibngAddress: "Shipping Address",
        companyBillingAddress: "Billing Address",
        classification: "Classification",
        discounts: "Discounts",
        subtotal: "Subtotal",
        taxesAndCharges: "Taxes and Charges",
        total: "Totals",
      },
      fields: {
        id_label: "ID",
        id_placeholder: "Vendor Returns ID",
        poId_label: "Purchase Order",
        poId_placeholder: "Purchase Order ID",
        date_label: "Date",
        date_placeholder: "Select Date",
        supplier_label: "Supplier",
        supplier_placeholder: "Select Supplier",
        vendor_label: "Vendor",
        vendor_placeholder: "Select Vendor",
        company_label: "Company",
        company_placeholder: "Select Company",
        location_label: "Location",
        location_placeholder: "Select Location",
        confirmation_label: "Confirmation Date",
        confirmation_placehodler: "Select Date",
        expectedReceipt_label: "Expected Receipt Date",
        expectedReceipt_placehodler: "Select Date",
        agreement_label: "Agreement",
        agreement_placeholder: "Select Agreement",
        currency_label: "Currency",
        currency_placeholder: "Select Currency",
        exchangeRate_label: "Exchange Rate",
        exchangeRate_placeholder: "0.00",
        paymentTerm_label: "Payment Terms",
        paymentTerm_placeholder: "Select Payment Terms",
        purchaseRepresentavive_label: "Purchase Representative",
        purchaseRepresentavive_placeholder: "Select Purchase Representative",
        referenceNo_label: "Reference No.",
        referenceNo_placeholder: "Enter Reference No.",
        incoTerm_label: "Incoterm",
        incoTerm_placeholder: "Select Incoterm",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        department_label: "Department",
        department_placeholder: "Select Department",
        attachment_label: "Attach your file here",
        attachedFile_label: "Attached File",

        supplierAddress_label: "Supplier Address",
        supplierAddress_placeholder: "Select Supplier Address",

        contactPerson_label: "Contact Person",
        contactPerson_placeholder: "Select Contact Person",

        shippingAddress_label: "Shipping Address",
        shippingAddress_placeholder: "Select Shipping Address",
        billingAddress_label: "Billing Address",
        billingAddress_placeholder: "Select Billing Address",
        placeOfSupply_label: "Place of Supply",
        placeOfSupply_placeholder: "Select Place of Supply",

        totalQty_label: "Total Quantity",
        total_label: "Total (INR)",
        itemDiscount_label: "Item Discount",
        additionalDiscount_label: "Additional Discount",
        totalDiscount_label: "Total Discount",
        subtotalExcludingTaxes_label: "Subtotal Excluding Taxes",
        subtotalExcludingDiscount_label: "Subtotal Excluding Discount",
        taxesAndChargesAdded_label: "Taxes & Charges Added",
        taxesAndChargesDeducted_label: "Taxes & Charges Deducted",
        totalTaxesAndChargesAdded_label: "Total Taxes and Charges Added",
        grandTotal_label: "Grand Total",
        roundOffDifference_label: "Round Off Difference",

        tax_code_label: "Tax Code",
        tax_rate_label: "Tax Rate",
        amount_label: "Amount",
        tax_label: "Tax",
        classification: "Classification",

        add_item_label: "Add Item",
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        vendor_header: "Vendor",
        purchaseRepresentative_header: "Purchase Representative",
        company_header: "Company",
        deliveryAddress_header: "Delivery Address",
        status_header: "Status",
        deliveryStatus_header: "Delivery Status",
        refundStatus_header: "Refund Status",
      },
      item_table: {
        item_header: "Item",
        item_placeholder: "Select Item",
        landedCost_header: "Is Landed Cost",
        vendor_header: "Vendor Item Name",
        vendor_placeholder: "Enter Vendor Item Name",
        uom_header: "UoM",
        uom_placeholder: "Select UoM",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        description_header: "Description",
        description_placeholder: "Enter Description",
        rate_header: "Rate",
        rate_placeholder: "Enter Rate",
        discountItem_header: "Discount Item",
        discountItem_placeholder: "Select Discount Item",
        discountRate_header: "Discount Rate (%)",
        discountRate_placeholder: "Discount Rate",
        grossAmount_header: "Gross Amount",
        grossAmount_placeholder: "Gross Amount",
        taxRate_header: "Tax Rate",
        taxRate_placeholder: "Tax Rate",
        taxAmount_header: "Tax Amount",
        taxAmount_placeholder: "Tax Amount",
        discountAmount_header: "Discount Amount",
        discountAmount_placeholder: "Discount Amount",
        netAmount_header: "Net Amount",
        netAmount_placeholder: "Net Amount",
        totalAmount_header: "Total Amount",
        totalAmount_placeholder: "Total Amount",
        taxTemplate_header: "Tax Template",
        taxTemplate_placeholder: "Select Tax Template",
        location_header: "Location",
        location_placeholder: "Select Location",
        department_header: "Department",
        department_placeholder: "Select Department",
        classification_header: "Classification",
        classification_placeholder: "Select Classification",
        narration_header: "Narration",
        narration_placeholder: "Enter Narration",
        poLine_header: "Purchase Order Line",
        onHand_header: "On Hand",
        remaining_header: "Remaining",
        available_header: "Available",
        traceDetails_header: "Trace Details",
      },
      deliveries_table: {
        id_header: "ID",
        date_header: "Date",
        deliveryStatus_header: "Status",
        company_header: "Company",
        location_header: "Location",
      },
      tabs: {
        basicDetails: "Basic Details",
        addressAndContact: "Address & Contact",
      },
      itemsTabs: {
        itemEntries: "Item Entries",
        expensed: "Expenses",
      },
      deliveries: {
        title: "Deliveries",
      },
      buttons: {
        deliveries: "Deliveries",
        debit_note: "Debit Note",
        delivery: "Delivery"
      }
    },
    deliveryOrder: {
      title: "Delivery Order",
      add_label: "Add New Delivery Order",
      edit_label: "Edit Delivery Order",
      vra_title: "Vendor Return Authorization",
      msg: {
        save: "Delivery order saved successfully.",
        delete: "Delivery order deleted successfully.",
        error: "An error occurred while processing the Delivery order.",
        itemSave: "Item saved successfully.",
        itemSaveError: "Something went wrong in an item save",
        itemDelete: "Item deleted successfully",
        itemDeleteError: "Something went wrong in an item save",
        trackingErrorMessage: "Tracking not generated for order",
        saveDraftError: "Please fill atleast one field",
        required_error: "Please fill all the required fields.",
        traceability_error: "Traceability not possible as material out of stock for selected Location.",
        traceability_success: "Traceability is Completed.",
        confirmDeleteItem: "Are you sure you want to delete item?",
        tracibility_message: "Changing the quantity or item will remove traceability data. Do you want to proceed?",
        packageError: "Please add the Package details",
        trackingDetailsError: "Please add the tracking details",
        confirmValidate: "Are you sure you want to validate the deliver order?",
        itemTrackingError: "Please add the Lots/Serial No. details to the item lines to proceed further.",
        confirmUpdate: "Are you sure you want to update status?"
      },
      sections: {
        basicDetails: "Basic Details",
        items: "Items",
        attachment: "Attachment",
        companyShippibngAddress: "Company Shipping Address",
        companyBillingAddress: "Company Billing Address",
        classification: "Classification",
      },
      fields: {
        id_label: "ID",
        id_placeholder: "Delivery Order ID",
        returnAuthorization_label: "Return Authorization",
        returnAuthorization_placeholer: "Enter Return Authorization",
        poId_label: "Purchase Order",
        date_label: "Date",
        date_placeholder: "Select Date",
        vendor_label: "Vendor",
        vendor_placeholder: "Select Vendor",
        company_label: "Company",
        company_placeholder: "Select Company",
        location_label: "Location",
        location_placeholder: "Select Location",
        agreement_label: "Agreement",
        agreement_placeholder: "Select Agreement",
        currency_label: "Currency",
        currency_placeholder: "Select Currency",
        exchangeRate_label: "Exchange Rate",
        exchangeRate_placeholder: "0.00",
        paymentTerm_label: "Payment Terms",
        paymentTerm_placeholder: "Select Payment Terms",
        purchaseRepresentavive_label: "Purchase Representative",
        purchaseRepresentavive_placeholder: "Select Purchase Representative",
        referenceNo_label: "Reference No.",
        referenceNo_placeholder: "Enter Reference No.",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        department_label: "Department",
        department_placeholder: "Select Department",
        attachment_label: "Attach your file here",
        attachedFile_label: "Attached File",
        status_label: "Status",
        status_placeholder: "Select Status",

        supplierAddress_label: "Supplier Address",
        supplierAddress_placeholder: "Select Supplier Address",

        contactPerson_label: "Contact Person",
        contactPerson_placeholder: "Select Contact Person",

        shippingAddress_label: "Shipping Address",
        shippingAddress_placeholder: "Select Shipping Address",
        billingAddress_label: "Billing Address",
        billingAddress_placeholder: "Select Billing Address",
        placeOfSupply_label: "Place of Supply",
        placeOfSupply_placeholder: "Select Place of Supply",

        expectedShippingDate_label: "Expected Shipping Date",
        expectedShippingDate_placeholder: "Select Date",
        shippingRule_label: "Shipping Rule",
        shippingRule_placeholder: "Select Shipping Rule",
        shippingCost_label: "Shipping Cost",
        shippingCost_placeholder: "Enter Shipping Cost",
        handlingCost_label: "Handling Cost",
        handlingCost_placeholder: "Enter Handling Cost",
        shippingTaxTemplate_label: "Shipping Tax Template",
        shippingTaxTemplate_placeholder: "Select Shipping Tax Template",
        handlingTaxTemplate_label: "Handling Tax Template",
        handlingTaxTemplate_placeholder: "Select Handling Tax Template",
        shippingTaxAmount_label: "Shipping Tax Amount",
        shippingTaxAmount_placeholder: "Enter Shipping Tax Amount",
        handlingTaxAmount_label: "Handling Tax Amount",
        handlingTaxAmount_placeholder: "Enter Handling Tax Amount",
        incoterm_label: "Incoterm",
        incoterm_placeholder: "Select Incoterm",

        add_item_label: "Add Item",
        update_status_label: "Update Status"
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        returnAuthorization_header: "Return Authorization",
        status_header: "Status",
        vendor_header: "Vendor",
        agreement_header: "Agreement",
        company_header: "Company",
        location_header: "Location",
      },
      tabs: {
        basicDetails: "Basic Details",
        addressAndContact: "Address & Contact",
        shipping: "Shipping",
        packages: "Packages",
      },
      item_table: {
        item_header: "Item",
        item_placeholder: "Select Item",
        returnAuthorizationLine_header: "Return Authorization Line",
        returnAuthorizationLine_placeholder: "Enter Return Authorization Line",
        landedCost_header: "Is Landed Cost",
        vendor_header: "Vendor Name",
        vendor_placeholder: "Enter Vendor Name",
        uom_header: "UoM",
        uom_placeholder: "Select UoM",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        description_header: "Description",
        description_placeholder: "Enter Description",
        rate_header: "Rate",
        rate_placeholder: "Enter Rate",
        location_header: "Location",
        location_placeholder: "Select Location",
        department_header: "Department",
        department_placeholder: "Select Department",
        classification_header: "Classification",
        classification_placeholder: "Select Classification",
        narration_header: "Narration",
        narration_placeholder: "Enter Narration",
        poLine_header: "Purchase Order Line",
        onHand_header: "On Hand",
        onHand_placeholder: "Enter On Hand",
        remaining_header: "Remaining",
        remaining_placeholder: "Enter Remaining",
        reserved_header: "Reserved",
        reserved_placeholder: "Enter Reserved",
        available_header: "Available",
        available_placeholder: "Enter Available",
        package_header: "Package",
        traceDetails_header: "Trace Details",
      },
      package_table: {
        name_header: "Package Name",
        dimensions_header: "Dimensions",
        weight_header: "Weight",
        details_header: "Package Details",
      },
      traceFields: {
        traceability: "Traceability",
        traceDetails_header: "Trace Details",
        item_label: "Item",
        sourceLocation_label: "Location",
        available_header: "Available",
        lot_header: "Lot/Serial number",
        lot_placeholder: "Select Lot/Serial number",
        bin_header: "Bin number",
        bin_placeholder: "Select Bin number",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
      },
      packageFields: {
        package_title: "Package",
        packaging_label: "Packaging",
        packagingDetails_label: "Packaging Details",
        item_label: "Item",
        sourceLocation_label: "Location",
        available_header: "Available",
        package_header: "Package",
        package_placeholder: "Select Package",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
      },
      button: {
        purchase_order: "Purchase Order"
      }
    },
    landedCost: {
      name: "Purchase Landed Cost",
      title: "Landed Cost",
      subHeading:
        "Efficiently document your expenses and keep your financial records in order.",
      add_label: "New Landed Cost",
      edit_label: "Edit Landed Cost",
      view_label: "Landed Cost Details",
      msg: {
        save: "Landed Cost saved successfully.",
        delete: "Landed Cost deleted successfully.",
        error: "An error occurred while processing the landed cost.",
        requestApproved: "Landed Cost has approved successfully.",
        requestRejected: "Landed Cost has rejected successfully.",
        requestSubmitted: "Landed Cost has been submitted for approval",
        validated: "Landed Cost validated successfully",
        closed: "Landed Cost closed successfully",
        confirmDeleteItem: "Are you sure you want to delete landed cost item?"
      },
      sections: {
        basic_details: "Basic Details",
        items: "Items",
        item_valuation: "Item Valuation",
        attachments: "Attachments",
        classification: "Classification",
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        name_header: "Name",
        purchase_representative_header: "Purchase Representative",
        vendor_header: "Vendor",
        company_header: "Company",
        valid_header: "Valid Up To",
        status_header: "Status",
      },
      fields: {
        id_label: "ID",
        id_placeholder: "Landed Cost ID",
        date_label: "Date",
        date_placeholder: "Select Date",
        receipt_label: "Receipt",
        receipt_placeholder: "Select Receipt",
        bill_label: "Bill",
        bill_placeholder: "Select Bill",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        location_label: "Location",
        location_placeholder: "Select Location",
        department_label: "Department",
        department_placeholder: "Select Department",
        view_attachments_label: "View Attached Files",
        add_item_label: "Add New Item"
      },
      item_table: {
        item_name_header: "Item",
        description_header: "Description",
        bill_header: "Bill",
        account_header: "Account",
        split_method_header: "Split Method",
        cost_header: "Cost",
        fields: {
          item_label: "Item",
          item_placeholder: "Select Item",
          description_label: "Description",
          description_placeholder: "Enter Description",
          bill_label: "Bill",
          bill_placeholder: "Select Bill",
          account_label: "Account",
          account_placeholder: "Select Account",
          split_method_label: "Split Method",
          split_method_placeholder: "Select Split Method",
          cost_label: "Cost",
          cost_placeholder: "Enter Cost",
        },
      },
      item_valuation_table: {
        cost_line_header: "Cost Line",
        item_name_header: "Item",
        quantity_header: "Quantity",
        original_value_header: "Original Value",
        new_value_header: "New Value",
        additional_landed_cost_header: "Additional Landed Cost",
      },
    },
    request: {
      name: "Requests",
      title: "Requests",
      add_label: "Add New Request",
      edit_label: "Edit  Request",
      tax: "Tax",
      sections: {
        generalDetails: "Basic Details",
        items: "Items",
        classification: "Classification",
        upload: "Attachment",
      },
      msg: {
        requestApproved: "Requests has been approved successfully.",
        requestRejected: "Requests has been rejected successfully.",
        requestSubmitted: "Requests has been submitted for approval.",
        req_item_err: "Please fill required field in item:",
        cancel_msg: "Are you sure you want to Cancelled",
        close_msg: "Are you sure you want to Close"
      },
      button: {
        order: "Order",
        rfq: "RFQ",
      },
      fields: {
        id_label: "ID",
        id_placeholder: "ID",
        date_label: "Date",
        date_placeholder: "Select Date",
        company_label: "Company",
        company_placeholder: "Select Company",
        purchase_represntive_label: "Purchase Representative",
        purchase_represntive_placeholder: "Select Purchase Representative",
        vendor_label: "Vendor",
        vendor_placeholder: "Select Vendor",
        currency_label: "Currency",
        currency_placeholder: "Select Currency",
        narration_label: "Narration",
        narration_Placeholder: "Enter Narration",
        location_label: "Location",
        location_placeholder: "Select Location",
        deparatment_label: "Department",
        department_placeholder: "Select Department",
        tax_code_label: "Tax Code",
        tax_rate_label: "Tax Rate",
        add_item_label: "Add Item",
        package_label: "Package",
        packaging_label: "Packaging",
        traceDetails_header: "Trace Details",
        trackDetails_header: "Track Details",
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        representative_label: "Purchase Representative",
        vendor_label: "Vendor",
        total_amount_label: "Total Amount",
        status_label: "Status",
        item_header: "Item",
        item_placeholder: "Select Item",
        vendor_header: "Vendor Name",
        vendor_placeholder: "Enter Vendor Name",
        uom_header: "UoM",
        uom_placeholder: "Select UoM",
        description_header: "Description",
        description_placeholder: "Enter Descriptioon",
        delivery_commitment_date_header: "Delivery Commitment Date",
        delivery_commitment_date_placeholder: "Enter Delivery Commitment Date",
        expected_shipping_date_header: "Expected Shipping Date",
        expected_shipping_date_placeholder: "Expected Shipping Date",
        available_header: "Available",
        on_hand_header: "On Hand",
        on_hand_placeholder: "Enter On hand Quantity",
        company_header: "Company",
        status_header: "Status",
        quantity_header: "Quantity",
        reserved_header: "Reserved",
        reserved_placeholder: "Enter Reserved quantity",
        tax_rate_placeholder: "Enter Tax rate",
        rate_header: "Rate",
        gross_amount_header: "Gross Amount",
        gross_amount_placeholder: "Enter Gross Amount",
        discount_header: "Discounted Item",
        discount_placeholder: "Select Discount Item",
        discount_rate_header: "Discount Rate (%)",
        discount_rate_placeholder: "Enter Discounted rate",
        discount_amount_header: "Discount Amount",
        discount_amount_placeholder: "Enter Discount Amount",
        net_amount_header: "Net Amount",
        tax_template_header: "Tax Template",
        tax_template_placeholder: "Select Tax Template",
        tax_rate_header: "Tax Rate",
        tax_amount_header: "Tax Amount",
        tax_amount_placeholder: "Enter Tax Amount",
        promotion_amount: "Promotion Amount",
        total_amount_header: "Total Amount",
        location_header: "Location",
        location_placeholder: "Select Location",
        deparatment_header: "Department",
        department_placeholder: "Select Department",
        narration_header: "Narration",
        narration_placeholder: "Enter Narration",
        supplier_address_header: "Supplier Address",
        supplier_address_placeholder: "Select Supplier Address",
        contact_person_header: "Contact Person",
        contact_person_placeholder: "Select Contact Person",
        shipping_address_header: "Shipping Address",
        shipping_address_placeholder: "Select Shipping Address",
        billing_address_header: "Billing Address",
        billing_address_placeholder: "Select Billing Address",
        place_of_supply_header: "Place of Supply",
        place_of_supply_placeholder: "Select Place of Supply",
        classification_header: "classification",
        amount: "Amount",
        date_label: "Date",
        rate_label: "Rate",
        rate_placeholder: "Enter Rate",
        date_placeholder: "Select Date",
        customer_lable: "Customer",
        customer_placeholder: "Select Customer",
        location_label: "Location",
        sales_order_label: "Sales Order",
        sales_order_placeholder: "Select Sales Order",
        operation_type_label: "Operation Type",
        operation_type_placeholder: "Select Operation Type",
        salesperson_label: "Salesperson",
        salesperson_placeholder: "Select Salesperson",
        company_label: "Company",
        company_placeholder: "Select Company",
        reference_label: "Reference Number",
        reference_placeholder: "Enter Reference Number",
        status_placeholder: "Select Status",
        narration_label: "Narration",
        grossAmount_header: "Gross Amount",
        discountItem_header: "Discounted Item",
        discountedAmount_header: "Discount Amount",
        netAmount_header: "Net Amount",
        taxTemplate_header: "Tax Template",
        taxAmount_header: "Tax Amount",
        totalAmount_header: "Total Amount",
        department_header: "Department",
      },
    },
    agreement: {
      name: "Purchase Agreements",
      title: "Purchase Agreements",
      subHeading:
        "Efficiently document your expenses and keep your financial records in order.",
      add_label: "New Purchase Agreement",
      edit_label: "Edit Purchase Agreement",
      view_label: "Purchase Agreement Details",
      msg: {
        save: "Purchase agreement saved successfully.",
        delete: "Purchase agreement deleted successfully.",
        error: "An error occurred while processing the purchase agreement.",
        requestApproved: "Purchase Agreement has approved successfully.",
        requestRejected: "Purchase Agreement has rejected successfully.",
        requestSubmitted: "Purchase Agreement has been submitted for approval",
        validated: "Purchase Agreement validated successfully",
        closed: "Purchase Agreement closed successfully",
        req_field_err: "Please fill atleast one field",
        delete_err: "Are you sure you want to delete agreement item ?",
        validate_err: "Are you sure you want to Validate Agreement:"
      },
      sections: {
        basic_details: "Basic Details",
        items: "Items",
        attachments: "Attachments",
        classification: "Classification",
        add_item: "Add Item",
      },
      table: {
        item_header: "Item",
        item_placeholder: "Select Item",
        id_header: "ID",
        date_header: "Date",
        name_header: "Name",
        purchase_representative_header: "Purchase Representative",
        vendor_header: "Vendor",
        company_header: "Company",
        valid_header: "Valid Up To",
        status_header: "Status",
      },
      fields: {
        id_label: "ID",
        id_placeholder: "Purchase Agreement ID",
        date_label: "Date",
        date_placeholder: "Select Date",
        name_label: "Name",
        name_placeholder: "Enter Name",
        type_label: "Agreement Type",
        type_placeholder: "Select Agreement Type",
        vendor_label: "Vendor",
        vendor_placeholder: "Select Vendor",
        purchase_representative_label: "Purchase Representative",
        purchase_representative_placeholder: "Select Purchase Representative",
        valid_up_to_label: "Valid Up To",
        valid_up_to_placeholder: "Select Date",
        company_label: "Company",
        company_placeholder: "Select Company",
        currency_label: "Currency",
        currency_placeholder: "Select Currency",
        payment_terms_label: "Payment Terms",
        payment_terms_placeholder: "Select Payment Terms",
        incoterms_label: "Incomterms",
        incoterms_placeholder: "Select Incoterms",
        instructions_label: "Instructions",
        instructions_placeholder: "Enter Instructions",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        update_vendor_prices_label: "Update Vendor Prices",
        location_label: "Location",
        location_placeholder: "Select Location",
        department_label: "Department",
        department_placeholder: "Select Department",
        view_attachments_label: "View Attached Files",
      },
      item_table: {
        item_name_header: "Item",
        vendor_header: "Vendor Name",
        uom_header: "UoM",
        description_header: "Description",
        specification_header: "Specification",
        rate_header: "Rate",
        min_order_qty_header: "Minimum Order Quantity",
        gross_amount: "Gross Amount",
        fields: {
          item_label: "Item",
          item_placeholder: "Select Item",
          vendor_label: "Vendor Item Name",
          vendor_placeholder: "Vendor Item Name",
          uom_label: "UoM",
          uom_placeholder: "Select UoM",
          description_label: "Description",
          description_placeholder: "Enter Description",
          specification_label: "Specification",
          specification_placeholder: "Enter Specification",
          rate_label: "Rate",
          rate_placeholder: "Enter Rate",
          min_order_qty_label: "Minimum Order Quantity",
          min_order_qty_placeholder: "Enter Quantity",
          gross_amount_label: "Gross Amount",
          gross_amount_placeholder: "Gross Amount",
        },
      },
    },
    settings: {
      enable_purchase_expense_label: "Enable Purchase Expenses",
      enable_advance_billing_label: "Enable Advanced Billing"
    },
    termsAndConditions: {
      title: "Terms & Conditions",
      add_label: "Add New Term",
      edit_label: "Edit Term",
      fields: {
        id: "ID",
        name: "Name",
        status: "Status",
        id_placeholder: "Term ID",
        name_placeholder: "Enter Term Name",
      },
      table: {
        id: "ID",
        name: "Name",
        status: "Status",
        type: "Type"
      }
    },
    reports: {
      purchaseOrderSummary: { title: "PO Summary" },
      purchaseOrderDetail: { title: "PO Detail" },
      purchaseInvoiceSummary: { title: "Purchase Invoice Summary" },
      purchaseInvoiceDetail: { title: "Purchase Invoice Detail" },
      approvedVsPendingPO: { title: "Approved vs Pending PO" },
      materialRequirementException: { title: "Material Requirement Exception" },
      supplierContractCompliance: { title: "Supplier Contract Compliance" },
      supplierRankingScorecard: { title: "Supplier Ranking" },
      purchaseReturn: { title: "Purchase Return" },
      purchaseOrderCancellation: { title: "PO Cancellation" },
      purchaseTrend: { title: "Purchase Trend" },
      receivedOrdered: { title: "Received vs Ordered" },
      supplierAgingPayable: { title: "Supplier Aging Payable" },
      purchasePriceVariance: { title: "Purchase Price Variance" },
      openPurchaseOrder: { title: "Open Purchase Order" },
    }
  },
  manufacturing: {
    name: "Manufacturing",
    title: "This is MANUFACTURING module",
    dashboard: {
      title: "Dashboard",
      all_time_label: "All Time",
      total_orders_label: "Total Orders",
      manufacturing_orders_label: "Manufacturing Orders",
      planning_label: "Planning",
      editing_dashboard_mode_label: "Editing Dashboard Mode",
      edit_layout_mode_label: "Edit Layout",
      more_icon_label: "more icon"
    },
    equipments: {
      title: "Equipments",
      add_label: "Add New Equipment",
      edit_label: "Edit Equipment",
      tableColumns: {
        id_header: "ID",
        dateTime_header: "Date & Time",
        unitsConsumed_header: "Units Consumed (A)",
        description_header: "Description",
        description_placeholder: "Enter Description",
        attachment_header: "Attachment",
        voltageIn_header: "Voltage In (V)",
        startDate_header: "Start Date",
        endDate_header: "End Date",
        workCentre_header: "Work Centre",
        maintenanceStatus_header: "Maintanance Status",
        maintenanceStatus_placeholder: "Select Status",
        assignedUser_header: "Assigned User",
        maintenanceCompany_header: "Maintenance Company",
        maintenanceCompany_placeholder: "Enter Maintenance Company",
        date_header: "Date",
        date_placeholder: "DD/MM/YYYY",
      },
      table: {
        id_header: "ID",
        equipmentName_header: "Equipment Name",
        equipmentCategory_header: "Equipment Category",
        workCentre_header: "Work Centre",
        narration_header: "Narration"
      },
      buttons: {
        saveAsDraft_label: "Save To Draft",
        discard_label: "Discard",
        save_label: "Save",
      },
      msg: {
        delete_label: 'Delete Equipment',
        deleteMsg: 'Are you sure you want to delete Equipment:',
        save: 'Equipment saved successfully.',
        saveDraftError: "Please fill atleast one field",
        delete: 'Record deleted successfully.'
      },
      tabs: {
        generalDetails: "General Details",
        failures: "Failures",
        maintenanceHistory: "Maintenance History",
      },
      sections: {
        detail: "Detail",
        generalDetail: "General Detail",
        usedBy: "Used By",
        equipmentDetails: "Equipment Details",
        electricityConsumptionDetails: "Electricity Consumption Details",
        voltageInspectionDetails: "Voltage Inspection Details",
        maintenance: "Maintenance",
        classification: "Classification",
        attachment: "Attachment",
      },
      fields: {
        fixedAsset_label: "Fixed Asset",
        fixedAsset_placeholder: "Select Asset",
        equipmentName_label: "Equipment Name",
        equipmentName_placeholder: "Enter Equipment Name",
        equipmentCategory_label: "Equipment Category",
        equipmentCategory_placeholder: "Select Equipment Category",
        company_label: "Company",
        company_placeholder: "Select Company",
        alternateEquipment_label: "Alternate Equipment",
        alternateEquipment_placeholder: "Select Alternate Equipment",
        usedBy_label: "Used By",
        usedBy_department: "Department",
        usedBy_employee: "Employee",
        usedBy_other: "Other",
        workCentre_label: "Work Centre",
        workCentre_placeholder: "Select Work Centre",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        vendor_label: "Vendor",
        vendor_placeholder: "Select Vendor",
        model_label: "Model",
        model_placeholder: "Enter Model",
        serialNumber_label: "Serial Number",
        serialNumber_placeholder: "Enter Serial Number",
        equipmentCost_label: "Equipment Cost",
        equipmentCost_placeholder: "Enter Equipment Cost",
        effectiveDate_label: "Effective Date",
        effectiveDate_placeholder: "Select Effective Date",
        warrantyExpirationDate_label: "Warranty Expiration Date",
        warrantyExpirationDate_placeholder: "Select Warranty Expiration Date",
        electricityConsumptionDetails_label: "Electricity Consumption Details",
        voltageInspectionDetails_label: "Voltage Inspection Details",
        maintenance_label: "Maintenance",
        maintenancePeriod_label: "Maintenance Period",
        maintenancePeriod_placeholder: "Select Period",
        date_label: "Date",
        date_placeholder: "Select Date",
        lastMaintenanceDate_label: "Last Maintenance Date",
        lastMaintenanceDate_placeholder: "Select Last Maintenance Date",
        makeItRecurring_label: "Make it Recurring",
        location_label: "Classification",
        location_placeholder: "Classification",
        department_label: "Department",
        department_placeholder: "Select Department",
        attachment_image_label: "Attach Equipment Image",
        attachment_document_label: "Attach Equipment Documents",
        upload_label: "Upload",
        status_label: 'Status',
        image_label: "Equipment Image",
        document_label: "Equipment Documents",
        location: "Location",
        department: 'Department'
      },
    },
    wip: {
      title: 'WIP Settings',
      msg: {
        save: 'Settings updated successfully.'
      },
      field: {
        allowWip_label: 'Allow WIP Process',
        wip_account_label: 'WIP Account',
      }
    },
    workCentreCategories: {
      title: "Work Centre Categoreis",
      add_label: "Add New Category",
      edit_label: "Edit Category",
      sections: {
        generalDetail: "General Detail",
      },
      table: {
        id_header: "ID",
        categoryName_header: "Category Name",
        item_header: "Item",
        narration_header: "Narration"
      },
      fields: {
        name_label: "Name",
        categoryTitle_label: "Category Title",
        name_placeholder: "Enter Name",
        item_label: "Item",
        item_placeholder: "Select Item",
        type_label: "Type",
        type_placeholder: "Select Type",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
      },
      msg: {
        deleteTitle: 'Delete Category',
        deleteWorkCenter: 'Are you sure you want to delete Work Centre Category:',
        save: 'Category updated successfully.',
        saveDraftError: "Please fill atleast one field",
        delete: 'Delete Work Centre Category',
        draft: 'Category is saved as a draft.'
      },
    },
    workCentre: {
      title: "Work Centre",
      add_label: "Add New Work Centre",
      edit_label: "Edit Work Centre",
      sections: {
        generalDetail: "General Detail",
        productionDetail: "Production Details",
        equipmentDetail: "Equipment Details",
        attachment: "Attachment",
        workingHours: "Working Hours",
      },
      msg: {
        deleteTitle: 'Delete Work Center',
        deleteWorkCenter: 'Are you sure you want to delete Work Center:',
        save: 'Work centre saved successfully.',
        saveDraftError: "Please fill atleast one field",
        delete: 'Record deleted successfully.'
      },
      fields: {
        workCentre_label: "Work Centre",
        workCentre_placeholder: "Enter work centre name",
        workCentreCode_label: "Work Centre Code",
        workCentreCode_placeholder: "Enter Work Centre Code",
        location_label: "Location",
        location_placeholder: "Select Location",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        company_label: "Company",
        company_placeholder: "Select Company",
        alternateWC_label: "Alternate WC",
        alternateWC_placeholder: "Select Alternate WC",
        usedBy_label: "Used By",
        usedBy_placeholder: "This Efficiency",
        capacity_label: "Capacity",
        capacity_placeholder: "Enter Capacity",
        costingDetails_label: "Costing Details",
        costingDetails_placeholder: "",
        setupTime_label: "Setup Time",
        setupTime_placeholder: "Enter Setup Time in Minutes",
        cleanUpTime_label: "Clean Up Time",
        cleanUpTime_placeholder: "Enter Clean Up Time in Minutes",
        equipmentDetails_label: "Equipment Details",
        equipmentDetails_placeholder: "",
        attachment_label: "Attach Document",
        attachment_placeholder: "Attach Document",
        workingHours_label: "Working Hours",
        workingHours_placeholder: "Select Work Centre",
        sameForAlldays_label: "Same For All Days",
        sameForAlldays_placeholder: "",
        timeEfficiency_label: "Time Efficiency (%)",
        timeEfficiency_placeholder: "Enter Percentage",
        oeeTarget_label: "OEE Target (%)",
        oeeTarget_placeholder: "Enter Percentage",
        operation_label: "operation_name",
        copy_from: "Copy From",
        same_for_all_days: "Same For All Days",
      },
      table: {
        srNo_header: "Sr No.",
        workCentre_header: "Work Centre Name",
        workCentreCode_header: "Code",
        capacity_header: "Capacity",
        id_header: "ID",
        alternativeWC_header: "Alternative WC",
        company_header: 'Company',
        category_header: "Category",
        valuePerHour_header: "Value Per Hour",
        valuePerMinute_header: "Value Per Minute",
        fixRate_header: "Fix Rate",
        equipment_header: "Equipment",
        equipmentCategory_header: "Equipment Category"
      }
    },
    operation: {
      title: "Operations",
      add_label: "Add New Operation",
      edit_label: "Edit Operation",
      delete_label: "Delete Operation",
      sections: {
        generalDetail: "General Detail",
        costingDetail: "Costing Details",
        instructions: "Instructions",
      },
      table: {
        srNo_header: "Sr No.",
        category_header: "Category",
        category_placeholder: "Select Category",
        valuePerHour_header: "Value Per Hour",
        valuePerHour_placeholder: "Enter cost per hour",
        valuePerMinute_header: "Value Per Minute",
        valuePerMinute_placeholder: "Enter value",
        fixRate_header: "Fix Rate",
        fixRate_plcaeholder: "Enter Fix Rate",
        title_header: "Title",
        title_palceholder: "Enter Title",
        description_header: "Description",
        description_placeholder: "Enter Description",
        attachment_header: "Attachment",
        operationName_header: "Operation Name",
        id_header: "ID",
        workCentre_header: "Work Centre",
        defaultDuration_header: "Duration",
        actualDurationComputation_header: "Duration Computation",
      },
      fields: {
        operationName_label: "Operation Name",
        operationName_placeholder: "Enter Operation name",
        workCentre_label: "Work Centre",
        workCentre_placeholder: "Enter work centre name",
        company_label: "Company",
        company_placeholder: "Select Company",
        location_label: "Location",
        location_placeholder: "Select Location",
        defaultDuration_label: "Default Duration (In Minutes)",
        defaultDuration_placeholder: "Enter Default Duration",
        defaultLabour_label: "Default Labour",
        defaultLabour_placeholder: "Enter Default Labour",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        actualDurationComputation_label: "Actual Duration Computation",
        computationBasedOnTrackedTime_label: "Compute Based on Tracked Time",
        setDurationManually_label: "Set Duration Manually",
        copyFrom_label: "Copy From",
        copyFrom_placeholder: "Select Operation",
      },
      msg: {
        deleteDescription: "Are you sure you want to delete Operation",
        success: 'Operation saved successfully.',
        saveDraftError: "Please fill atleast one field",
        description: 'Are you sure you want to delete Operation:'
      }
    },
    routing: {
      title: "Routing",
      add_label: "Add New Route",
      edit_label: "Edit Route",
      saveMsg: "Route saved Successfully.",

      sections: {
        generalDetail: "General Detail",
        routingDetail: "Routing Details",
      },
      msg: {
        deleteTitle: 'Delete Route',
        deleteRoute: 'Are you sure you want to delete Route:',
        save_draft_err: "Please fill atleast one field",
        delete: 'Record deleted successfully.'
      },
      table: {
        no_header: "No.",
        operation_header: "Operation",
        operation_placeholder: "Select Operation",
        operationSequence_header: "Operation Sequence",
        operationSequence_placeholder: "Enter Operation Sequence",
        rawMaterials_header: "Raw Materials",
        rawMaterials_placeholder: "Select Raw Materials",
        workCenter_header: "Work Center",
        workCenter_placeholder: "Select Work Center",
        durationComputation_header: "Actual Duration Computation",
        durationComputation_placeholder: "Select Actual Duration Computation",
        duration_header: "Duration (In Minutes)",
        narration_header: "Narration",
        id_header: "ID",
        date_header: "Date",
        name_header: "Name",
        item_header: "Item",
        bom_header: "Bill of Material",
        location_header: "Location"
      },
      fields: {
        id_label: "ID",
        id_placeholder: "Enter ID",
        date_label: "Date",
        date_placeholder: "Select Date",
        name_label: "Name",
        name_placeholder: "Enter Name",
        billOfMaterial_label: "Bill of Material",
        billOfMaterial_placeholder: "Select Bill of Material",
        item_label: "Item",
        item_placeholder: "Select Item",
        location_label: "Location",
        location_placeholder: "Select Location",
        company_label: "Company",
        company_placeholder: "Select Company",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        status_label: "Status",
        status_placeholder: "Set Status",
        makeItDefaultForLocation_label: "Make It Default for Location",
      },
    },
    bom: {
      title: "Bill of Materials",
      add_label: "Add Bill of Material",
      edit_label: "Edit Bill of Material",
      more_icon_label: "more icon",
      msg: {
        save: "Bill of Material saved Successfully.",
        requestApproved: "Bill of Material has approved successfully.",
        requestRejected: "Bill of Material has rejected successfully.",
        requestSubmitted: "Bill of Material has been submitted for approval",
        delete: "Bill of Material deleted successfully.",
        bom_err: "Something went wrong.",
        noData: "No data available",
        save_draft_err: 'Please fill atleast one field',
        delete_record: "Record deleted successfully.",
        err_delete_record: "Something went wrong on deleting the record.",
        approve_reject_record: `Are you sure you want to :approved Bill of Material: :id ?`
      },

      sections: {
        generalDetail: "General Detail",
        materials: "Materials",
      },
      fields: {
        name_label: "Name",
        name_placeholder: "Enter Name",
        item_label: "Item",
        item_placeholder: "Select Item",
        versionNumber_label: "Version Number",
        versionNumber_placeholder: "Enter Version Number",
        quantity_label: "Quantity",
        quantity_placeholder: "Enter Quantity",
        uom_label: "Units of Measurement",
        uom_placeholder: "Select Units of Measurement",
        company_label: "Company",
        company_placeholder: "Select Company",
        startDate_label: "Start Date",
        startDate_placeholder: "Select Start Date",
        endDate_label: "End Date",
        endDate_placeholder: "Select End Date",
        location_label: "Location",
        location_placeholder: "Select Location",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        status_label: "Status",
      },
      table: {
        id_header: "ID",
        bom_name_header: "Bill of Material Name",
        product_header: "Product",
        version_number_header: "Version Number",
        status_header: "Status",
        item_header: "Item",
        item_placeholder: "Select Item",
        description_header: "Description",
        description_placeholder: "Enter Description",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        uom_header: "UOM",
        uom_placeholder: "Select UOM",
        toConsume_header: "To Consume (%)",
        toConsume_placeholder: "Enter To Consume (%)",
        scrap_header: "Scrap (%)",
        narration_header: "Narration",
      },
    },
    gate: {
      title: "Gate Register",
      add_label: "Add Gate Register",
      edit_label: "Edit Gate Register",
      msg: {
        save: "Gate Register saved successfully.",
        update: "Gate Register updated successfully.",
        requestApproved: "Gate Register has approved successfully.",
        requestRejected: "Gate Register has rejected successfully.",
        requestSubmitted: "Gate Register has been submitted for approval",
        delete: "Gate Register deleted successfully.",
        vehicleNumberSave: "Vehicle number saved Successfully.",
        noEntryData: "No Entry Details Added Yet.",
        noExitData: "No Exit Details Added Yet.",
        gate_err: "Something went wrong.",
        noData: "No data available"
      },
      sections: {
        generalDetail: "General Detail",
        vehicleDetail: "Vehicle Details",
        driverDetail: "Driver Details",
        entryDetail: "Entry Details",
        exitDetail: "Exit Details",
        attachment: "Attachment",
      },
      fields: {
        id_label: "ID",
        id_placeholder: "Please Enter ID",
        date_label: "Date",
        date_placeholder: "Select Date",
        createdby_label: "Created By",
        createdby_placeholder: "Select Created By",
        location_label: "Location",
        location_placeholder: "Select Location",
        company_label: "Company",
        company_placeholder: "Select Company",
        vehicle_number_label: "Vehicle Number",
        vehicle_number_placeholder: "Select Vehicle Number",
        vehicle_type_label: "Vehicle Type",
        vehicle_type_placeholder: "Select Vehicle Type",
        transport_name_label: "Transport Name",
        transport_name_placeholder: "Enter Transport Name",
        driver_name_label: "Driver Name",
        driver_name_placeholder: "Enter Name",
        driver_contact_number_label: "Driver Contact Number",
        driver_contact_number_placeholder: "Enter Contact Number",
        driver_identification_number_label: "Identification Number",
        driver_identification_number_placeholder: "Enter Identification Number",
        entryDateTime_label: "Entry Date & Time",
        entryDateTime_placeholder: "Select Date & Time",
        entry_transaction_referenece_label: "Entry Transaction Reference",
        entry_transaction_referenece_placeholder: "Enter Entry Transaction Reference",
        entry_purpose_label: "Entry Purpose",
        entry_purpose_placeholder: "Enter Entry Purpose",
        entry_material_label: "Entry Material",
        entry_material_placeholder: "Enter Entry Material Details",
        exitDateTime_label: "Exit Date & Time",
        exitDateTime_placeholder: "Select Date & Time",
        exit_transaction_referenece_label: "Exit Transaction Reference",
        exit_transaction_referenece_placeholder: "Enter Exit Transaction Reference",
        exit_purpose_label: "Exit Purpose",
        exit_purpose_placeholder: "Enter Exit Purpose",
        exit_material_label: "Exit Material",
        exit_material_placeholder: "Enter Exit Material Details",
        attachment_document_label: 'Attach your file here',
        add_vehicle_number_label: "Vehicle Number",
        add_vehicle_number_placeholder: "Enter Vehicle Number",
        add_vehicle_type_label: "Vehicle Type",
        add_vehicle_type_placeholder: "Enter Vehicle Type",
        vehicle_label: "Vehicle",
        driver_label: "Driver",
        vehicle_number_modal_label: "Add Vehicle Number",
        vehicle_type_modal_label: "Add Vehicle Type",
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        vehicle_header: "Vehicle",
        driver_header: "Driver",
        entry_date_time_header: "Entry Date & Time",
        exit_date_time_header: "Exit Date & Time",
        item_header: "Item",
        item_placeholder: "Select Item",
        description_header: "Description",
        description_placeholder: "Enter Description",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        uom_header: "UOM",
        uom_placeholder: "Select UOM",
        toConsume_header: "To Consume (%)",
        toConsume_placeholder: "Enter To Consume (%)",
        scrap_header: "Scrap (%)",
        narration_header: "Narration",
      },
    },
    jobCards: {
      title: "Job Cards",
      add_label: "Add Job Cards",
      edit_label: "Edit Job Cards",
      operationList_label: "Operations List",
      completionRecord_label: "Completion Record",
      job_card_label: "Job Card",
      add_job_card_label: "Add Job Card",
      edit_job_card_label: "Edit Job Card",
      table: {
        id_header: "ID",
        date_header: "Date",
        Company_header: "Company",
        Location_header: "Location",
        Item_header: "Item",
        Material_status_header: "Material status",
        uom_header: "Unit of Measurement",
        bom_header: "Bills of Materials",
        quantity_header: "Quantity",
        routing_header: "Routing",
        status_header: "Status",
        srno_header: "Sr No.",
        Description_header: "Description",
        available_header: "Available",
        reserved_header: "Reserved",
        on_hand_header: "On Hand",
        consume_header: "Consume (%)",
        department_header: "Department",
        scrap_header: "Scrap (%)",
        narration_header: "Narration",
        company_header: "Company",
        location_header: "Location",
        item_header: "Item",
        description_header: "Description",
        operation_header: "Operation",
        operation_sequence_header: "Operation Sequence",
        raw_material_header: "Raw Material",
        operation_person_header: "Operation Person",
        equipment_header: "Equipment",
        work_center_header: "Work Center",
        scheduled_start_date_header: "Schedule Start Date",
        expected_labor_header: "Expected Labor",
        expected_duration_header: "Expected Duration",
        actual_duration_header: "Actual Duration",
        instructions_header: "Instructions",
        actions_header: "Actions",

        noOfEquipment_header: "No. of Equipments",
        laborResources_header: "Labor Resources",
        laborSetupTime_header: "Labor Setup Time (In Minutes)",
        laborRunTime_header: "Labor Run Time (In Minutes)",
        machineResources_header: "Machine Resources",
        machineSetupTime_header: "Machine Setup Time (In Minutes)",
        machineRunTime_header: "Machine Run Time (In Minutes)",
        jobCardId_header: "Job Card ID",
        workOrderId_header: "Work Order ID",
      },
      sections: {
        generalDetail: "General Detail",
        material: "Material",
        routingDetails: "Routing Details",
        classification: "Classification",
      },
      fields: {
        id_label: "Id",
        id_placeholder: "Please Enter id",
        date_label: "Date",
        date_placeholder: "DD-MM-YYYY",
        company_label: "Company",
        company_placeholder: "Select Company",
        location_label: "Location",
        location_placeholder: "Select Location",
        item_label: "Item",
        item_placeholder: "Select Item",
        uom_label: "Unit of Measurements (UoM)",
        uom_placeholder: "Select Unit of Measurements",
        bom_label: "Bill of Material",
        bom_placeholder: "Select Bill of Material",
        quantity_label: "Quantity",
        quantity_placeholder: "Enter Quantity",
        routing_label: "Routing",
        routing_placeholder: "Select Routing",
        manufacturing_time_label: "Manufacturing Time",
        manufacturing_time_placeholder: "Enter Manufacturing Time",
        production_start_date_label: "Production Start Date",
        production_start_date_placeholder: "DD-MM-YYYY",
        production_end_date_label: "Production End Date",
        production_end_date_placeholder: "DD-MM-YYYY",
        reference_number_label: "Reference Number",
        reference_number_placeholder: "Enter Reference Number",
        responsible_person_label: "Responsible Person",
        responsible_person_placeholder: "Select Responsible Person",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        department_label: "Department",
        department_placeholder: "Select Department",

        workOrder_label: "Work Order",
        workOrder_placeholder: "Add Work Order",
        jobCard_label: "Job Card",
        jobCard_placeholder: "Add Job Card",
        builtQuantity_label: "Build Quantity",
        block_label: "Block",
        reason_label: "Reason",
        reason_placeholder: "Select Reason",
        equipments_label: "Select Equipments",
        alternet_equipment_label: "Do you want to use alternative work equipment for the work order?",
        alternet_equipment_yes_label: "Yes",
        alternet_equipment_no_label: "No",
        released_label: "Released",
        unit_of_measurement_label: "Unit Of Measurement",
        materials_label: "Materials",
        mark_complete_label: "Mark Complete",
        mark_complete_description: "This action will mark operation as :nextStatus.Do you really want to continue?",
        equipment_maintenance_label: "Equipment Maintenance",
        equipment_maintenance_description: "Your Equipment Maintenance is done, Do you want to replace it with Alternative Equipment?",
        build_label: "Build",
        delete_item_label: "Delete Item",
        mark_complete_modal_complete_description: "This action will mark all operations as Completed. Do you really want to continue?",
        mark_complete_modal_not_complete_description: "This action will mark all operations as not Completed. Do you really want to continue?",
      },
      msg: {
        save: "Job Card saved Successfully.",
        closed: "Job Card has closed successfully.",
        cancelled: "Job Card has cancelled successfully.",
        released: "Job Card has been released",
        delete: "Job Card deleted successfully.",
        noOperationRemaining: "All Operation have been added to completion",
        recordCompletionSave: "Record completion saved successfully",
        job_card_err: "Something went wrong.",
        noData: "No data available",
        save_draft_err: 'Please fill atleast one field',
        no_attachment: "No attachment available",
        choose_record_err: "Please choose atleast one record",
        job_card_delete: "Are you sure you want to delete Job Card"
      },

      buttons: {
        recordCompletion_label: "Record Completion",
        completion_label: "Completion",
        view_instruction_label: "View Instruction",
      },
    },
    masterJobCard: {
      title: "Master Job Card",
    },
    buildOrder: {
      title: "Build Order",
      add_label: "Add New Build Order",
      edit_label: "Edit Build Order",
      msg: {
        build_order_err: "Something went wrong.",
        noData: "No data available",
        delete_build: "Are you sure you want to delete Build Order",
        save_build_order: "Build Order saved successfully.",
        save_draft_err: 'Please fill atleast one field',
        traceability_err: "Traceability not possible as material out of stock for selected Location.",
        traceability_completed: "Traceability is Completed.",
        err_delete_record: "Something went wrong on deleting the record.",
        delete_record: "Record deleted successfully.",
        trackingDetailsError: "Please add the tracking details",
        quantityError: "The added quantity is :moreOrLess than the transfer quantity",
        tracking_update_err: "Something went wrong in tracking update",
        delete_entry: "Are you sure you want to delete ?",
        cancel_build: "Are you sure you want to Cancel Build Order",
        validate_lot: "Please select the lot/serial number and done quantity for each material to Validate it.",
        validate_lot_complete: "Please select the lot/serial number and done quantity for Finished Item to Mark it as Complete.",
      },
      sections: {
        generalDetail: "General Detail",
        materials: "Materials",
        classification: "Classification",
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        company_header: "Company",
        location_header: "Location",
        item_header: "Item",
        uom_header: "Unit of Measurement",
        bom_header: "Bills of Materials",
        quantity_header: "Quantity",
        routing_header: "Routing",
        status_header: "Status",
      },
      fields: {
        WorkOrder_label: "Work Order",
        WorkOrder_label_placeholder: "Enter Work Order",
        Id: "Id",
        Id_placeholder: "Enter Id",
        Date: "Date",
        Date_placeholder: "DD-MM-YYYY",
        Company_label: "Company",
        Company_label_placeholder: "Select Company",
        location_label: "Location",
        location_label_placeholder: "Select Location",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        items_label: "Items",
        items_placeholder: "Select Items",
        uom_label: "Unit Of Measurement",
        uom_placeholder: "Select Unit Of Measurement",
        bom_label: "Bills of Materials",
        bom_placeholder: "Select Bills of Materials",
        Quantity: "Quantity",
        Quantity_placeholder: "Enter Quantity",
        Routing_label: "Routing",
        Routing_placeholder: "Select Routing",
        department_label: "Department",
        department_placeholder: "Select Department",
        cleanUpTime_label: "Clean Up Time",
        cleanUpTime_placeholder: "Enter Clean Up Time in Minutes",
        equipmentDetails_label: "Equipment Details",
        equipmentDetails_placeholder: "",
        attachment_label: "Attach Document",
        attachment_placeholder: "Attach Document",
        workingHours_label: "Working Hours",
        workingHours_placeholder: "Select Build Order",
        sameForAlldays_label: "Same For All Days",
        sameForAlldays_placeholder: "",
        timeEfficiency_label: "Time Efficiency (%)",
        timeEfficiency_placeholder: "Enter Percentage",
        oeeTarget_label: "OEE Target (%)",
        oeeTarget_placeholder: "Enter Percentage",
        delete_build_order_label: "Delete Build Order",
        total_bom_cost_label: "Total BoM Cost",
        total_operation_cost_label: "Total Operation Cost",
        total_work_center_cost_label: "Total Work Center Cost",
        total_duration: "Total Duration",
        total_cost_label: "Total Cost",
        operation_name_label: "Operation Name",
        cost_label: "Cost",
        expand_row_label: "expand row",
        labour_label: "Labour",
        product_name_label: "Product Name",
        required_label: "Required",
        consumed_label: "Consumed",
        price_per_unit_label: "Price Per Unit",
        work_centre_label: "Work Centre",
        work_order_label: 'Work Order',
        manufacturing_build_order_details_label: "Manufacturing Build Order Details",
        cost_analysis_label: "Cost Analysis",
        to_build_label: "To Build",
        manufacturing_raw_materials_label: "Manufacturing Raw Materials",
        lot_label: "Lot Number",
        lot_placeholder: "Enter Lot Number",
        add_lot_label: "Add Lot Number",
        type_label: "Type",
        type_placeholder: "Select Lot Number",
        bin_label: "Bin",
        bin_placeholder: "Select Bin",
        lot_serial_number_label: "Lot/serial Number",
        lot_or_serial_number_label: "Lot/Serial Number",
        lot_or_serial_number_placeholder: "Please enter Lot/Serial Number",
        select_lot_or_serial_number_placeholder: "Select Lot/Serial Number",
        bin_number_label: "Bin Number",
        bin_number_placeholder: "Select Bin Number",
        item_label: "Item",
        built_quantity_label: "Built Quantity",
        available_quantity_label: "Available Quantity",
        track_detail_label: "Track Detail",
        lot_serial_number_list_label: "Lot/Serial Number List",
        lot_serial_number_entries_label: "Lot/Serial Number Entries",
        delete_entry_label: "Delete Entry",
        print_bom_label: "Print Bill of Material",
        id_label: "ID",
        job_card_label: "Job Card",
        mark_completed_label: "Mark Completed",
        validate_material_issue_label: "Validate (Material Issue)",
        unbuild_order_label: "Unbuild Order",
        accounting_ledger_label: "Accounting Ledger",
        cancel_build_order_label: "Cancel Build Order",
        ok_label: "Ok",
        validation_error_label: "Validation Error",
        manufacturing_label: "Manufacturing",
        unbuild_label: "Unbuild",
        total_weight_label: "Total Weight",
      },
    },
    unbuildOrder: {
      title: "Unbuild  Order",
      add_label: "Add New Unbuild  Order",
      edit_label: "Edit Unbuild  Order",
      sections: {
        generalDetail: "General Detail",
        materials: "Materials",
        classification: "Classification",
      },
      msg: {
        unbuild_order_err: "Something went wrong.",
        noData: "No data available",
        delete_unbuild: "Are you sure you want to delete Unbuild Order: :unbuildOrderToDelete ?",
        save_unbuild_order: "Unbuild Order saved successfully.",
        save_draft_err: 'Please fill atleast one field',
        traceability_err: "Traceability not possible as material out of stock for selected Location.",
        traceability_completed: "Traceability is Completed.",
        err_delete_record: "Something went wrong on deleting the record.",
        delete_record: "Record deleted successfully.",
        trackingDetailsError: "Please add the tracking details",
        quantityError: "The added quantity is :moreOrLess than the transfer quantity",
        tracking_update_err: "Something went wrong in tracking update",
        delete_entry: "Are you sure you want to delete ?",
        cancel_build: "Are you sure you want to Cancel Build Order",
        validate_lot: "Please select the lot/serial number and done quantity for each material to Validate it.",
        validate_lot_complete: "Please select the lot/serial number and done quantity for Finished Item to Mark it as Complete.",
        traceability_message: "Changing the quantity or item will remove traceability data. Do you want to proceed?",
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        company_header: "Company",
        location_header: "Location",
        item_header: "Item",
        uom_header: "Unit of Measurement",
        bom_header: "Bills of Materials",
        quantity_header: "Quantity",
        routing_header: "Routing",
        status_header: "Status",
      },
      fields: {
        WorkOrder_label: "Work Order",
        WorkOrder_label_placeholder: "Enter Work Order",
        BuildOrder_label: "Build  Order",
        BuildOrder_label_placeholder: "Enter Build Order",
        Id: "Id",
        Id_placeholder: "Enter Id",
        Date: "Date",
        Date_placeholder: "DD-MM-YYYY",
        Company_label: "Company",
        Company_label_placeholder: "Select Company",
        location_label: "Location",
        location_label_placeholder: "Select Location",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        items_label: "Items",
        items_placeholder: "Select Items",
        uom_label: "Unit Of Measurement",
        uom_placeholder: "Select Unit Of Measurement",
        bom_label: "Bills of Materials",
        bom_placeholder: "Select Bills of Materials",
        build_quantity: "Quantity Build",
        build_quantity_placeholder: "Enter Quantity Build",
        unbuild_Quantity: "Quantity To Unbuild",
        unbuild_quantity_placeholder: "Enter Quantity To Unbuild",
        Routing_label: "Routing",
        Routing_placeholder: "Select Routing",
        department_label: "Department",
        department_placeholder: "Select Department",
        cleanUpTime_label: "Clean Up Time",
        cleanUpTime_placeholder: "Enter Clean Up Time in Minutes",
        equipmentDetails_label: "Equipment Details",
        equipmentDetails_placeholder: "",
        attachment_label: "Attach Document",
        attachment_placeholder: "Attach Document",
        workingHours_label: "Working Hours",
        workingHours_placeholder: "Select Unbuild  Order",
        sameForAlldays_label: "Same For All Days",
        sameForAlldays_placeholder: "",
        timeEfficiency_label: "Time Efficiency (%)",
        timeEfficiency_placeholder: "Enter Percentage",
        oeeTarget_label: "OEE Target (%)",
        oeeTarget_placeholder: "Enter Percentage",
        add_new_label: "Add New",
        delete_unbuild_order_label: "Delete Unbuild Order",
        manufacturing_raw_materials_label: "Manufacturing Raw Materials",
        traceability_label: "Traceability",
        item_label: "Item",
        quantity_label: "Quantity",
        build_quantity_label: "Build Quantity",
        lot_label: "Lot Number",
        lot_placeholder: "Enter Lot Number",
        add_lot_label: "Add Lot Number",
        type_label: "Type",
        type_placeholder: "Select Lot Number",
        bin_label: "Bin",
        bin_placeholder: "Select Bin",
        lot_serial_number_label: "Lot/serial Number",
        lot_or_serial_number_label: "Lot/Serial Number",
        lot_or_serial_number_placeholder: "Please enter Lot/Serial Number",
        select_lot_or_serial_number_placeholder: "Select Lot/Serial Number",
        bin_number_label: "Bin Number",
        bin_number_placeholder: "Select Bin Number",
        built_quantity_label: "Built Quantity",
        available_quantity_label: "Available Quantity",
        track_detail_label: "Track Detail",
        lot_serial_number_list_label: "Lot/Serial Number List",
        lot_serial_number_entries_label: "Lot/Serial Number Entries",
        delete_entry_label: "Delete Entry",
        print_bom_label: "Print Bill of Material",
        id_label: "ID",
        job_card_label: "Job Card",
        mark_completed_label: "Mark Completed",
        validate_material_issue_label: "Validate (Material Issue)",
        unbuild_order_label: "Unbuild Order",
        accounting_ledger_label: "Accounting Ledger",
        cancel_build_order_label: "Cancel Build Order",
        ok_label: "Ok",
        validation_error_label: "Validation Error",
        manufacturing_label: "Manufacturing",
        unbuild_label: "Unbuild",
      },
    },
    workOrder: {
      title: "Work order",
      add_label: "Add Work Order",
      edit_label: "Edit Work Order",
      workOrderDetails_label: "Work Order Details",
      materialIssueDetails_label: "Material Issue Details",
      addMaterialIssue_label: "Add Material Issue",
      materialIssueed_label: "Material Issue Details",
      issuedMaterials_label: "Issued Materials",
      issueMaterial_label: "Issue Material",
      accouting_ledger_label: "Accouting Ledger",
      journal_items_label: "Journal Items",
      add_material_label: "Add Material",

      msg: {
        save: "Work Order saved Successfully.",
        closed: "Work Order has closed successfully.",
        cancelled: "Work Order has cancelled successfully.",
        released: "Work Order has been released",
        delete: "Work Order deleted successfully.",
        work_order_err: "Something went wrong.",
        noData: "No data available",
        quantity_err: "Quantity is required in item",
        save_draft_err: 'Please fill atleast one field',
        delete_record: "Record deleted successfully.",
        err_delete_record: "Something went wrong on deleting the record.",
        traceability_err: "Traceability not possible as material out of stock for selected Location.",
        traceability_completed: "Traceability is Completed.",
        serial_number_err: "This serial Number is already available",
        lot_number_err: "This lot Number is already available",
        trackingDetailsError: "Please add the tracking details",
        quantityError: "The added quantity is :moreOrLess than the transfer quantity",
        tracking_update_err: "Something went wrong in tracking update",
        delete_entry: "Are you sure you want to delete ?",
      },
      sections: {
        generalDetail: "General Detail",
        clasification: "Classification",
        materials: "Materials",
      },
      fields: {
        id_label: "ID",
        id_placeholder: "Enter ID",
        date_label: "Date",
        date_placeholder: "Select Date",
        company_label: "Company",
        company_placeholder: "Select Company",
        location_label: "Location",
        location_placeholder: "Select Location",
        item_label: "Item",
        item_placeholder: "Select Item",
        uom_label: "Unit of Measurement (UoM)",
        uom_placeholder: "Select Unit of Measurement",
        billOfMaterial_label: "Bill of Material",
        billOfMaterial_placeholder: "Select Bill of Material",
        quantity_label: "Quantity",
        quantity_placeholder: "Enter Quantity",
        routing_label: "Routing",
        routing_placeholder: "Select Routing",
        manufacturingTime_label: "Manufacturing Time",
        manufacturingTime_placeholder: "Enter Manufacturing Time",
        productionStartDate_label: "Production Start Date",
        productionStartDate_placeholder: "Select Production Start Date",
        productionEndDate_label: "Production End Date",
        productionEndDate_placeholder: "Select Production End Date",
        referenceNumber_label: "Reference Number",
        referenceNumber_placeholder: "Enter Reference Number",
        responsiblePerson_label: "Responsible Person",
        responsiblePerson_placeholder: "Select Responsible Person",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        department_label: "Department",
        department_placeholder: "Select Department",
        material_label: "Material",
        material_placeholder: "Select Material",
        build_label: "Build",
        total_bom_cost_label: "Total BoM Cost",
        total_operation_cost_label: "Total Operation Cost",
        total_work_center_cost_label: "Total Work Center Cost",
        total_duration_text: "Total Duration : :duration Mins",
        total_cost_label: "Total Cost",
        cost_label: "Cost",
        operation_name_label: "Operation Name",
        expand_row_label: "expand row",
        labour_label: "Labour",
        machine_label: "Machine",
        product_name_label: "Product Name",
        required_label: "Required",
        consumed_label: "Consumed",
        price_per_unit_label: "Price Per Unit",
        work_centre_label: "Work Centre",
        work_order_label: 'Work Order',
        manufacturing_work_order_details_label: "Manufacturing Work Order Details",
        cost_analysis_label: "Cost Analysis",
        lot_label: "Lot Number",
        lot_placeholder: "Enter Lot Number",
        add_lot_label: "Add Lot Number",
        type_label: "Type",
        type_placeholder: "Select Lot Number",
        bin_label: "Bin",
        bin_placeholder: "Select Bin",
        manufacturing_raw_materials_label: "Manufacturing Raw Materials",
        lot_serial_number_label: "Lot/serial Number",
        lot_or_serial_number_label: "Lot/Serial Number",
        lot_or_serial_number_placeholder: "Please enter Lot/Serial Number",
        select_lot_or_serial_number_placeholder: "Select Lot/Serial Number",
        bin_number_label: "Bin Number",
        bin_number_placeholder: "Select Bin Number",
        available_quantity_label: "Available Quantity",
        track_detail_label: "Track Detail",
        lot_serial_number_list_label: "Lot/Serial Number List",
        lot_serial_number_entries_label: "Lot/Serial Number Entries",
        delete_entry_label: "Delete Entry",
        print_bom_label: "Print Bill of Material",
        sales_order_label: "Sales Order",
        customer_label: "Customer",
        material_length: "Material Length",
        material_width: "Material Width",
        material_thickness: "Material Thickness",
        color_label: "Color",
        size_label: "Size",
        markingThickness_label: "Marking Thickness",
        category_label: "Category",
        embossingMark_label: "Embossing Mark",
      },
      table: {
        item_header: "Item",
        item_placeholder: "Select Item",
        description_header: "Description",
        description_placeholder: "Enter Description",
        uom_header: "Unit of Measurement",
        uom_placeholder: "Select UOM",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        available_header: "Available",
        available_placeholder: "Enter Available Quantity",
        reserved_header: "Reserved",
        reserved_placeholder: "Enter Reserved Quantity",
        onHand_header: "On Hand",
        onHand_placeholder: "Enter On Hand Quantity",
        classification_header: "Classification",
        classification_placeholder: "Select Department",
        consume_header: "Consume (%)",
        consume_placeholder: "Enter Consume (%)",
        scrap_header: "Scrap (%)",
        narration_header: "Narration",
        company_header: "Company",
        location_header: "Location",
        bom_header: "Bom",
        routing_header: "Bom",

        id_header: "ID",
        date_header: "Date",
        accountNumber_header: "Account Number",
        journal_header: "Journal",
        debit_header: "Debit",
        credit_header: "Credit",
        amount_header: "Amount",
        paymentMethod_header: "Payment Method",
        material_status_header: "Material Status",
        unit_of_measurement_header: "Unit of Measurement",
        bill_of_materials_header: "Bill of Materials",
        quantity_text_header: "Quantity",
        routing_text_label: "Routing",
        status_header: "Status",
        category_header: "Category",
      },
    },
    manageOperation: {
      title: "Manage Operations",
      msg: {
        save: "Work Order saved Successfully.",
        closed: "Work Order has closed successfully.",
        cancelled: "Work Order has cancelled successfully.",
        released: "Work Order has been released",
        delete: "Work Order deleted successfully.",
        work_order_operation_err: "Something went wrong.",
        operation_ready: "Select those operation which status is Ready",
        operation_not_blocked: "Select those operation which status is Not Blocked",
        operation_in_progress: "Select those operation which status is In progress",
        noData: "No data available",
        mark_complete_description: "This action will mark operation as :nextStatus.Do you really want to continue?",
        delete_unbuild: "Are you sure you want to delete Unbuild Order: :unbuildOrderToDelete ?",
        save_unbuild_order: "Unbuild Order saved successfully.",
        save_draft_err: 'Please fill atleast one field',
        traceability_err: "Traceability not possible as material out of stock for selected Location.",
        traceability_completed: "Traceability is Completed.",
        err_delete_record: "Something went wrong on deleting the record.",
        delete_record: "Record deleted successfully.",
        trackingDetailsError: "Please add the tracking details",
        quantityError: "The added quantity is :moreOrLess than the transfer quantity",
        tracking_update_err: "Something went wrong in tracking update",
        delete_entry: "Are you sure you want to delete ?",
        cancel_build: "Are you sure you want to Cancel Build Order",
        validate_lot: "Please select the lot/serial number and done quantity for each material to Validate it.",
        validate_lot_complete: "Please select the lot/serial number and done quantity for Finished Item to Mark it as Complete.",
        traceability_message: "Changing the quantity or item will remove traceability data. Do you want to proceed?",
        bulk_update: "Are you sure you want to :actionLabel :selectedIds selected operations ?",
        no_attachment: "No attachment available",
      },
      table: {
        work_order_header: "Work Order ID",
        bom_header: "Bill of Material",
        sequence_header: "Operation Sequence",
        raw_materials_header: "Raw Materials",
        operation_person_header: "Operation Person",
        equipment_header: "Equipment",
        work_center_header: "Work Center",
        schedule_start_date_header: "Schedule Start Date",
        expected_labor_header: "Expected labor",
        expected_duration_header: "Expected Duration",
        actual_duration_header: "Actual Duration",
        status_header: "Status",
        instruction_header: "Instructions",
      },
      fields: {
        item_selected_label: "item selected",
        complete_label: "Complete",
        block_label: "Block",
        start_label: "Start",
        yes_label: "Yes",
        no_label: "No",
        mark_complete_label: "Mark Complete",
        equipment_maintenance_label: "Equipment Maintenance",
        equipment_maintenance_description: "Your Equipment Maintenance is done, Do you want to replace it with Alternative Equipment?",
        operations_label: "Operations",
        reason_label: "Reason",
        reason_placeholder: "Select Reason",
        equipments_label: "Select Equipments",
        alternet_equipment_label: "Do you want to use alternative work equipment for the work order?",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        work_order_label: "Search Work Order",
        work_order_placeholder: "Work Order",
        bom_label: "Search Bill of Material",
        bom_placeholder: "Bill of Material",
        op_sequence_label: "Search Operation Sequence",
        op_sequence_placeholder: "Operation Sequence",
        raw_material_label: "Search Raw Material",
        raw_material_placeholder: "Raw Material",
        op_person_label: "Search Operation Person",
        op_person_placeholder: "Operation Person",
        work_center_label: "Search Work Center",
        work_center_placeholder: "Work Center",
      }
    },
    demand: {
      title: "Demand Planning",
      fields: {
        type_label: "Type",
        type_placeholder: "Select Type",
        subsidiary_label: "Subsidiary",
        subsidiary_placeholder: "Select Subsidiary",
        search_subsidiary_placeholder: "Search Subsidiary",
        location_label: "Location",
        location_placeholder: "Select Location",
        search_location_placeholder: "Search Location",
        item_label: "Item",
        item_placeholder: "Select Item",
        search_item_placeholder: "Search Item",
        asOfDate_label: "As of Date",
        asOfDate_placeholder: "Select Date",
        showBelowReorderPoint_label: "Show Below Reorder Point",
        procurement_label: "Procurement",
        production_label: "Production",
        demand_label: "Demand",
        material_label: "Material",
      },
      table: {
        item_header: "Item",
        description_header: "Description",
        units_header: "Units",
        demand_header: "Demand",
        onHand_header: "On Hand",
        onOrder_header: "On Order",
        available_header: "Available",
        committed_header: "Committed",
        pr_header: "PR",
        required_header: "Required",
        date: "Date",
        transaction: "Transaction",
        location: "Location",
        quantity: "Quantity",
        raw_material: "Raw Material",
        customer: "Customer",
        bill_of_material_header: "Bill of Material",
        material_list_header: "Material List",
        summery_label: "Summery",
      },
      summary: {
        total_label: "Total",
        viewDetails_label: "View Details",
      },
      actions: {
        filter_label: "Filter",
        refresh_label: "Refresh",
        clearAll_label: "Clear All",
      },
    },
    operationBlock: {
      title: "Operation Block",
      add_label: "Add Operation Block",
      edit_label: "Edit Operation Block",
      msg: {
        save: "Operation Block saved Successfully.",
        requestApproved: "Operation Block has approved successfully.",
        requestRejected: "Operation Block has rejected successfully.",
        requestSubmitted: "Operation Block has been submitted for approval",
        delete: "Operation Block deleted successfully.",
        deleteDescription: `Are you sure you want to :approve Bill: :id ?`,
      },

      sections: {
        generalDetail: "Basic Detail",
        materials: "Materials",
      },
      fields: {
        work_order: "Work Order",
        work_order_placeholder: "Select Work Order",
        work_center: "Work Center",
        work_center_placeholder: "Select Work Center",
        block_reason_label: "Block Reason",
        block_reason_placeholder: "Select Block Reason",
        operation_label: "Operation",
        operation_placeholder: "Select Operation",
        assigned_user_label: "Assigned User",
        assigned_user_placeholder: "Select Assigned User",
        company_label: "Company",
        company_placeholder: "Select Company",
        startDate_label: "Start Date",
        startDate_placeholder: "Select Start Date",
        endDate_label: "End Date",
        endDate_placeholder: "Select End Date",
        location_label: "Location",
        location_placeholder: "Select Location",
        description_label: "Description",
        description_placeholder: "Enter Description",
        status_label: "Status",
      },
      table: {
        id_header: "ID",
        block_reason_header: "Block Reason",
        start_Date_header: "Start Date & Time",
        end_Date_header: "End Date & Time",
        work_center_header: "Work Center",
        assigner_user_header: "Assigned User",
        company_header: "Company",
        description_header: "Description",
      },
    },
    failure: {
      title: "Equipment Failure",
      add_label: "Add Equipment Failure",
      edit_label: "Edit Equipment Failure",
      mark_completed: "Mark Completed",
      mark_description: "This action will mark operation as Completed. Do you really want to continue?",
      button: {
        maintanance_completed: "Maintanance Completed"
      },
      msg: {
        save: "Equipment Failure saved Successfully.",
        closed: "Equipment Failure has closed successfully.",
        cancelled: "Equipment Failure has cancelled successfully.",
        released: "Equipment Failure has been released",
        delete: "Equipment Failure deleted successfully.",
        save_draft_err: 'Please fill atleast one field',
      },
      sections: {
        generalDetail: "General Detail",
        clasification: "Classification",
        attachment: "Attachment",
      },
      table: {
        work_order_header: "Work Order ID",
        bom_header: "Bill of Material",
        sequence_header: "Operation Sequence",
        raw_materials_header: "Raw Materials",
        operation_person_header: "Operation Person",
        equipment_header: "Equipment",
        work_center_header: "Work Center",
        schedule_start_date_header: "Schedule Start Date",
        expected_labor_header: "Expected labor",
        expected_duration_header: "Expected Duration",
        actual_duration_header: "Actual Duration",
        status_header: "Status",
        instruction_header: "Instructions",
        id_header: "ID",
        equipmentName_header: "Equipment Name",
        startDate_header: "Start Date",
        endDate_header: "End Date",
        workCentre_header: "Work Center",
        assignedUser_header: "Assigned User",
        description_header: "Description",
        duration_header: "Duration",
        company_header: "Company",
        maintenanceStatus_header: "Maintenance Status"
      },
      fields: {
        workOrder_label: "Work Order",
        workOrder_placeholder: "Select Work Order",
        workCentre_label: "Work Centre",
        workCentre_placeholder: "Select Work Centre",
        company_label: "Company",
        company_placeholder: "Select Company",
        location_label: "Location",
        location_placeholder: "Select Location",
        operation_label: "Operation",
        operation_placeholder: "Select Operation",
        equipment_label: "Equipment",
        equipment_placeholder: "Select Equipment",
        startDate_label: "Start Date and Time",
        startDate_placeholder: "Select Start Date & Time",
        endDate_label: "End Date and Time",
        endDate_placeholder: "Select End Date & Time",
        assignedUser_label: "Assigned User",
        assignedUser_placeholder: "Select Assigned User",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        attachment_label: "Attachment",
        attachment_placeholder: "Attach Document",
        maintenanceStatus_label: "Maintenance Status",
        maintenanceDuration_label: "Maintenance Duration",
        attachment_document_label: "Attachment Document",
      },
    },
    reports: {

      completionReports: {
        title: "Completion Report",
        table: {
          item: 'Item',
          description: 'Description',
          location: 'Location',
          wo_name: 'Work Order',
          bom: 'BoM',
          document_id: 'Document ID',
          type: 'Type',
          date: 'Date',
          quantityBuild: 'Quantity Build',
          scrapQuantity: 'Scrap Quantity',
          wo_quantity: 'Work Order Quantity'
        }
      },
      componentWhereUsed: {
        title: "Components Where Used",
        table: {
          finished_product_name: 'Assembly',
          bom_name: 'BoM',
          bom_quantity: 'BoM Quantity',
          uom_name: 'UoM',
          on_hand: 'On Hand',
          available: 'Available',
          back_order: 'Back Order',
          on_order: 'On Order',
          start_date: 'Start Date',
          end_date: 'End Date'
        }
      },
      bomInquiry: {
        title: "BoM Inquiry",
        table: {
          finished_product_name: 'Raw Material Item',
          bom_quantity: 'BoM Quantity',
          component_quantity: 'Units',
          on_hand: 'On Hand',
          available: 'Available',
          back_order: 'Back Order',
          on_order: 'On Order'
        }
      },
      factoryDailyConsumption: {
        title: "Factory Daily Consumption",
        table: {
          location: 'Location',
          description: 'Description',
          type: 'Type',
          document_id: 'Document ID',
          date: 'date',
          work_order: 'Work Order',
          issue_quantity: 'Issue Quantity',
          scrap_quantity: 'Scrap Quantity',
          unit_cost: 'Unit Cost',
          total_cost: 'Total Cost',
          uom: 'UoM',
        }
      },
      costRollup: {
        title: "Cost Rollup",
        table: {
          assembly_item: 'Assembly Item',
          wo_name: 'Work Order',
          date: 'Date',
          material: 'Material',
          quantity: 'Quantity',
          unit_price: 'Unit Price',
          total_price: 'Total Price'
        }
      },
      scrapReport: {
        title: "Scrap Report",
        table: {
          item_name: 'Item',
          location: 'Location',
          wo_name: 'Work Order',
          so_name: 'Scrap Order',
          wo_date: 'Date',
          wo_released_date: 'Description',
          scrap_quantity: 'Scrap Quantity',
          unit_cost: 'Unit Cost',
          total_cost: 'Total Cost',
          wo_quantity: 'Work Order Quantity',
          bo_quantity: 'Build Quantity',
          scrap_percentage: '% of Scrap Quantity',
          scrap_amount: 'Scrap Amount'
        }
      },
    },
  },
  crm: {
    name: "CRM",
    title: "This is CRM module",
    dashboard: {
      title: "Dashboard",
      all_time_label: "All Time",
    },
    customerSegment: {
      title: "Customer Segments",
      add_label: "Add New Customer Segment",
      edit_label: "Edit Customer Segment",
      msg: {
        save: "Customer Segment saved successfully.",
        requestApproved: "Customer Segment has been approved successfully.",
        requestRejected: "Customer Segment has been rejected successfully.",
        requestSubmitted: "Customer Segment has been submitted for approval.",
        delete: "Customer Segment deleted successfully.",
        save_draft_err: 'Please fill atleast one field',
      },

      sections: {
        generalDetail: "General Detail",
        conditions: "Conditions",
        attachment: "Attachment",
      },
      fields: {
        id_label: "ID",
        id_placeholder: "Enter ID",
        name_label: "Name",
        name_placeholder: "Enter Name",
        company_label: "Company",
        company_placeholder: "Select Company",
        startDate_label: "Start Date",
        startDate_placeholder: "Select Date",
        endDate_label: "End Date",
        endDate_placeholder: "Select Date",
        narration_label: "Narration",
        narration_placeholder: "Write Narration",
        autoAssign_label: "Auto Assign",

        purchaseAmount_label: "Purchase Amount",
        purchaseAmount_placeholder: "Enter Purchase Amount",
        purchaseCount_label: "Purchase Count",
        purchaseCount_placeholder: "Enter Purchase Count",
        segmentDuration_label: "Segment Duration",
        segmentDuration_placeholder: "Select Date",

        attachment_label: "Attach Document",
        view_attachment_label: "Attached file",
        attachment_placeholder: "Attach your file here",
        upload_label: "Upload",
      },
      table: {
        id_header: "ID",
        segmentName_header: "Segment Name",
        segmentDuration_header: "Segment Duration",
        purchaseAmount_header: "Purchase Amount",
        purchaseCount_header: "Purchase Count",
        validityStartDate_header: "Validity Start Date",
        validityEndDate_header: "Validity End Date",
        company_header: "Company",
        status_header: "Status",
      },
    },
    shippmentRules: {
      title: "Shipping Rule",
      add_label: "Add New Shipping Rule",
      edit_label: "Edit Shipping Rule",
      subHeading:
        "Efficiently document your expenses and keep your financial records in order.",
      msg: {
        save: "Shipping Rule saved Successfully.",
        requestApproved: "Shipping Rule has approved successfully.",
        requestRejected: "Shipping Rule has rejected successfully.",
        requestSubmitted: "Shipping Rule has been submitted for approval",
        delete: "Shipping Rule deleted successfully.",
        save_draft_err: 'Please fill atleast one field'
      },

      sections: {
        generalDetail: "Basic Detail",
        upload: "Attachment",
      },
      fields: {
        id: "ID",
        id_placeholder: "Enter ID",
        name_label: "Name",
        name_placeholder: "Enter Name",
        company_label: "Company",
        company_placeholder: "Select Company",
        location_label: "Location",
        location_placeholder: "Select Location",
        shipping_cost_label: "Shipping Cost",
        shipping_cost_placeholder: "Enter Shipping Cost",
        handling_cost_label: "Handling Cost",
        handling_cost_placeholder: "Enter Handling Cost",
        shipping_account_label: "Shipping Account",
        shipping_account_placeholder: "Select Shipping Account",
        handling_account_label: "Handling Account",
        handling_account_placeholder: "Select Handling Account",
        status_label: "Status",
        narration_label: "Narration",
        narration_placeholder: "Write Narration",
        attachment_label: "Attached files",
      },
      table: {
        id_header: "ID",
        name_header: "Name",
        company_header: "Company",
        shipping_cost_header: "Shipping Cost",
        status_header: "Status",
        item_header: "Item",
        item_placeholder: "Select Item",
        description_header: "Description",
        description_placeholder: "Enter Description",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        uom_header: "UOM",
        uom_placeholder: "Select UOM",
        toConsume_header: "To Consume (%)",
        toConsume_placeholder: "Enter To Consume (%)",
        scrap_header: "Scrap (%)",
        narration_header: "Narration",
      },
    },
    quotation: {
      title: "Quotation",
      add_label: "Add New Quotation",
      edit_label: "Edit Quotation",
      item: "Item",
      add_item: "Add Item",
      select_item: "Select Item",
      view_revision: "View Revision",
      opportunity: "Opportunity",
      revision: "Revision",
      order: "Order",
      create_order: "Create Order",
      create_revision: "Create Revision",
      create_invoice: "Create Invoice",
      quotation_details: "Quotation Details",
      msg: {
        save: "Quotation saved successfully.",
        requestApproved: "Quotation has been approved successfully.",
        requestRejected: "Quotation has been rejected successfully.",
        requestSubmitted: "Quotation has been submitted for approval.",
        delete: "Quotation deleted successfully.",
        conditions: "Conditions",
        attachment: "Attachment",
        classification: "Classification",
        items: "items",
        discounts: "Discounts",
        upload: "Attachments",
        promotion_err: "Something went wrong in promotion apply",
        coupon_err: 'Coupon code must be alphanumeric.',
        item_err: 'Please add atleast one Item',
        req_field_err: 'Please fill all the required fields.',
        download_report_err: 'We are not able to download the report',
        status_change_confirmation: "Confirm Status Change",
        status_change_msg: "Are you sure you want to change the status to"
      },
      sections: {
        generalDetail: "Basic Detail",
        upload: "Attachment",
        classification: "Classification",
        items: "Items",
        discounts: "Discounts",
      },
      fields: {
        transaction_type_label: "Transaction Type",
        postingTime_label: "Posting Time",
        postingTime_placeholder: "HH:MM PM",
        id_label: "ID",
        id_placeholder: "Enter ID",
        date_label: "Date",
        date_placeholder: "Select Date",
        opportunity_label: "Opportunity",
        opportunity__placeholder: "Enter Opportunity",
        customer_label: "Customer",
        customer_placeholder: "Select Customer",
        select_customer: "Select Customer",
        manual_customer: "Manual",
        manual_customer_name_label: "Manual Customer Name",
        manual_customer_name_placeholder: "Enter Manual Customer Name",
        contact_person_label: "Contact Person",
        posting_label: "Postinig Time",
        posting_placeholder: "HH:MM PM",
        payment_terms_label: "Payment Terms",
        payment_terms_placeholder: "Select Payment Terms",
        company_label: "Company",
        company_placeholder: "Select Company",
        expiry_label: "Expiration Date",
        delivery_commitment_label: "Delivery Commitment Date",
        currency_label: "Currency",
        currency_placeholder: "Select Currency",
        exchnage_rate_label: "Exchange Rate",
        exchnage_rate_placeholder: "Enter Exchange Rate",
        sales_person_label: "Salesperson",
        sales_person_placeholder: "Select Salesperson",
        reference_number_label: "Reference Number",
        reference_number_placeholder: "Enter Reference Number	",
        recurring_label: "Recurring",
        recurring_placeholder: "Select Recurring",
        until_date_label: "Untill Date",
        status_label: "Status",
        status_placeholder: "Select Status",
        version_label: "Version Number",
        version_placeholder: "1",
        upload_label: "Upload",
        narration_label: "Narration",
        narration_placeholder: "Write Narration",
        location_label: "Location",
        location_placeholder: "Select Location",
        department_label: "Department",
        department_placeholder: "Select Department",
        additional_discouny_item_header: "Apply Additional Discount On",
        additional_discount_placeholder: "Additional Discount",
        additional_discount_percent: "Additional Discount Percentage",
        additional_discount_amount: "Additional Discount Amount",
        is_round_off_header: "Round off",
        round_off_header: "Round off",
        round_off_amount: "Round Off Amount",
        round_off_placeholder: "Select round off",
        cash_or_non_trade_header: "Is Cash or Non Trade Discount",
        shipping_rule_header: "Shipping Rule",
        shipping_rule_placeholder: "Select Shipping Rule",
        shipping_cost_header: "Shipping Cost",
        shipping_cost_placeholder: "Enter Shipping Cost",
        handling_cost_header: "Handling Cost",
        handling_cost_placeholder: "Enter Handling Cost",
        handling_tax_template_header: "Handling Tax Template",
        handling_tax_template_placeholder: "Select Handling Tax Template",
        shipping_tax_template_header: "Shipping Tax Template",
        shipping_tax_template_placeholder: "Select Shipping Tax Template",
        handling_tax_amount_header: "Handling Tax Amount",
        handling_tax_amount_placeholder: "Select Handling Tax Amount",
        shipping_tax_amount_header: "Shipping Tax Amount",
        shipping_tax_amount_placeholder: "Enter Shipping Tax Amount",
        incoterm_header: "Incoterm",
        incoterm_placeholder: "Select Incoterm",
        supplier_address_header: "Supplier Address",
        attachment_label: "Attach your file here",
        tax_code: "Tax Code",
        tax_rate: "Tax Rate",
        actual_amount: "Actual Amount",
        uom: "UOM",
        select_uom: "Select UOM",
        delivery_commitment_date: "Delivery Commitement Date",
        delivery_commitment_date_placeholder: "Select Delivery Commitement Date",
        expected_shipping_date: "Expected Shipping Date",
        expected_shipping_date_placeholder: "Enter Expected Shipping Date",
        quantity: "Quantity",
        rate: "Rate",
        available: "Available",
        on_hand: "On Hand",
        commited: 'Commited',
        back_order: 'Back Order',
        delivered: 'Delivered',
        invoiced: 'Invoiced',
        discount_item: "Discount Item",
        discount_item_placeholder: "Select Discount Item",
        discount_rate_header: "Discount Rate (%)",
        amount: "Amount",
        gross_amount: "Gross Amount",
        tax_amount: "Tax Amount",
        discount_amount: "Discount Amount",
        net_amount: "Net Amount",
        total_amount: "Total Amount",
        tax: "Tax",
        tax_template: "Tax Template",
        select_tax_template: "Select Tax Template",
        terms_condition_content_label: "Terms & Condition (Contents)",
        termsCondition_label: "Terms & Conditions",
        terms_condition_placeholder: "Search Terms & Conditions",
        apply_quote_percentage: "Apply Quote Percentage",
        quote_percentage_label: "Quote Percentage (%)",
      },
      button: {
        apply_promotion: "Apply Promotions",
        apply: "Apply",
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        customer_header: "Customer",
        salesperson_header: "Salesperson",
        company_name_header: "Company Name",
        total_value_header: "Total Value",
        item_header: "Item",
        item_placeholder: "Select Item",
        uom_header: "UoM",
        uom_placeholder: "Select UoM",
        description_header: "Description",
        description_placeholder: "Enter Descriptioon",
        delivery_commitment_date_header: "Delivery Commitment Date",
        delivery_commitment_date_placeholder: "Enter Delivery Commitment Date",
        expected_shipping_date_header: "Expected Shipping Date",
        expected_shipping_date_placeholder: "Expected Shipping Date",
        available_header: "Available",
        on_hand_header: "On Hand",
        on_hand_placeholder: "Enter On hand Quantity",
        company_header: "Company",
        status_header: "Status",
        quantity_header: "Quantity",
        reserved_header: "Reserved",
        reserved_placeholder: "Enter Reserved quantity",
        tax_rate_placeholder: "Enter Tax rate",
        rate_header: "Rate",
        gross_amount_header: "Gross Amount",
        gross_amount_placeholder: "Enter Gross Amount",
        discount_header: "Discounted Item",
        discount_placeholder: "Select Discount Item",
        discount_rate_header: "Discount Rate (%)",
        discount_rate_placeholder: "Enter Discounted rate",
        discount_amount_header: "Discount Amount",
        discount_amount_placeholder: "Enter Discount Amount",
        net_amount_header: "Net Amount",
        tax_template_header: "Tax Template",
        tax_template_placeholder: "Select Tax Template",
        tax_rate_header: "Tax Rate",
        tax_amount_header: "Tax Amount",
        tax_amount_placeholder: "Enter Tax Amount",
        promotion_amount: "Promotion Amount",
        total_amount_header: "Total Amount",
        location_header: "Location",
        location_placeholder: "Select Location",
        deparatment_header: "Department",
        department_placeholder: "Select Department",
        narration_header: "Narration",
        narration_placeholder: "Enter Narration",
        supplier_address_header: "Supplier Address",
        supplier_address_placeholder: "Select Supplier Address",
        contact_person_header: "Contact Person",
        contact_person_placeholder: "Select Contact Person",
        shipping_address_header: "Shipping Address",
        shipping_address_placeholder: "Select Shipping Address",
        billing_address_header: "Billing Address",
        billing_address_placeholder: "Select Billing Address",
        place_of_supply_header: "Place of Supply",
        place_of_supply_placeholder: "Select Place of Supply",
      },
      tabs: {
        generalDetails: "Basic Details",
        address: "Address and Contact",
        shipping: "Shipping",
        promotion: "Promotion",
      },
    },
    promotions: {
      title: "Promotions",
      add_label: "Add Promotions",
      edit_label: "Edit Promotions",
      view_label: "Promotion Details",
      add_new_coupons: "Add New Coupons",
      add_new_condition_rewards: "Add New Condition & Rewards",
      rewards: "Rewards",
      view_coupon: "View Coupon",
      delete_reward: "Delete Reward",
      chage_type: "Change Type",
      coupons: "Coupons",
      msg: {
        save: "Promotions saved Successfully.",
        requestApproved: "Promotions has approved successfully.",
        requestRejected: "Promotions has rejected successfully.",
        requestSubmitted: "Promotions has been submitted for approval",
        delete: "Promotions deleted successfully.",
        save_coupon: "Coupon Saved Successfully.",
        save_reward: "Reward Saved Successfully",
        save_draft_err: 'Please fill atleast one field',
        delete_record: "Record deleted successfully.",
        confirm_reward_delete_msg: "Are you sure you want to delete the reward ?",
        confirm_change_type_remove_rewards_msg: "On changing the type the rewards would be removed"
      },

      sections: {
        generalDetail: "General Detail",
        conditionsRewards: "Conditions & Rewards",
        conditions: "Conditions",
        attachment: "Attachment",
        offerDetail: "Offer Detail",
        rewards: "Rewards"
      },
      fields: {
        id_label: "ID",
        id_placeholder: "Enter ID",
        name_label: "Name",
        name_placeholder: "Enter Name",
        item_label: "Item",
        item_placeholder: "Select Item",
        type_label: "Type",
        type_placeholder: "Select Type",
        versionNumber_label: "Version Number",
        versionNumber_placeholder: "Enter Version Number",
        quantity_label: "Quantity",
        quantity_placeholder: "Enter Quantity",
        uom_label: "Units of Measurement",
        attachment_label: "Attach Document",
        company_label: "Company",
        company_placeholder: "Select Company",
        startDate_label: "Start Date",
        startDate_placeholder: "Select Start Date",
        endDate_label: "End Date",
        endDate_placeholder: "Select End Date",
        expiryDate_label: "Expiry Date",
        expiryDate_placeholder: "Select Expiry Date",
        location_label: "Location",
        location_placeholder: "Select Location",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        status_label: "Status",
        limit_label: "Limit",
        limit_placeholder: "Limit",
        usage_limit_label: "Usage Limit",
        limit_usage_label: "Limit Usage",
        account_label: "Account",
        account_placeholder: "Select Account",
        percentage_label: "Percentage",
        fixed_amount_label: "Fixed Amount",
        buy_x_get_y_label: "Buy X Get Y",
        character_limit_label: "Character Limit",
        character_limit_placeholder: "Enter Character Limit",
        code_format_label: "Code Format",
        code_format_placeholder: "Select Code Format",
        alphanumeric_label: "Alphanumeric",
        coupon_number_header: "Number Of Coupons",
        coupon_number_placeholder: "Enter Number Of Coupons",
      },
      table: {
        id_header: "ID",
        name_header: "Name",
        type_header: "Type",
        items_header: "Items",
        company_header: "Company",
        end_date_header: "End Date",
        status_header: "Status",
        item_header: "Items",
        item_placeholder: "Select Item",
        item_category_header: "Item Categories",
        item_category_placeholder: "Enter Item Category",
        description_header: "Description",
        description_placeholder: "Enter Description",
        min_quantity_header: "Minimum Quantity",
        min_quantity_placeholder: "Enter Minimum Quantity",
        location_header: "Location",
        location_placeholder: "Select Location",
        discount_header: "Discount Percentage/Amount",
        discount_placeholder: "Enter Discount Value",
        customer_header: "Customer",
        customer_placeholder: "Select Customer",
        customer_segment_header: "Customer Segment",
        customer_segment_placeholder: "Select Customer Segment",
        discount_percentage_header: "Discount Percentage",
        discount_percentage_placeholder: "Enter Discount Percentage",
        discount_amount_header: "Discount Amount",
        discount_amount_placeholder: "Enter Discount Amount",
        max_amount_header: "Maximum Amount",
        narration_header: "Narration",
        order_total_header: "Order Total",
        product_header: "Products",
        product_placeholder: "Select Product",
        rewarding_product_header: "Rewarding Product",
        rewarding_product_placeholder: "Select Rewarding Product",
        rewarding_quantity_header: "Rewarding Quantity",
        condition_name_header: "Condition Name",
        category_header: "Categories",
        category_placeholder: "Select Categories",
        discount_value_header: "Discount Amount",
        enter_minimum_quantity_placeholder: "Enter minimum quantity",
        tax_label: "Tax",
        enter_condition_name_placeholder: "Enter Condition name",
        enter_reward_quantity_placeholder: "Enter reward quantity"
      },
    },
    opportunity: {
      title: "Opportunities",
      add_label: "Add Opportunity",
      edit_label: "Edit Opportunity",
      view_label: "Opportunity Details",
      view_sales_pipeline: "Sales Pipeline",
      add_item: "Add Item",
      item: "Item",
      item_placeholder: "Select Item",
      uom: "UOM",
      uom_placeholder: "Select UOM",
      description: "Description",
      description_placeholder: "Enter Description",
      delivery_commitment_date: "Delivery Commitement Date",
      delivery_commitment_date_placeholder: "Select Delivery Commitement Date",
      expected_shipping_date: "Expected Shipping Date",
      expected_shipping_date_placeholder: "Enter Expected Shipping Date",
      quantity: "Quantity",
      rate: "Rate",
      available: "Available",
      on_hand: "On Hand",
      reserved: "Reserved",
      discount_item: "Discount Item",
      discount_item_placeholder: "Select Discount Item",
      discount_rate: "Discount Rate (%)",
      amount: "Amount",
      gross_amount: "Gross Amount",
      tax_amount: "Tax Amount",
      discount_amount: "Discount Amount",
      net_amount: "Net Amount",
      total_amount: "Total Amount",
      tax: "Tax",
      tax_template: "Tax Template",
      tax_template_placeholder: "Select Tax Template",
      add_followup: "Add Follow Up",
      add_follow_up_date: "Add Follow Up Date and Time",
      add_new_log: "Add New Communication Log",
      communication_log: "Communication Log",
      expected_revenue: "Expected Revenue",
      expected_closing_date: "Expected Closing Date",
      created_on: "Created On",
      no_log: "No Logs added yet",
      view_more: "View More",
      view_in_calender: "View In Calendar",
      view_quotation: "View Quotation",
      make_quotation: "Make Quotation",
      view_sales_pipeline_label: "View Sales Pipeline",
      msg: {
        save: "Opportunity saved Successfully.",
        requestApproved: "Opportunity has approved successfully.",
        requestRejected: "Opportunity has rejected successfully.",
        requestSubmitted: "Opportunity has been submitted for approval",
        delete: "Opportunity deleted successfully.",
        save_as_draft: "Please fill atleast one field",
        delete_record: "Record deleted successfully.",
        err_delete_record: "Something went wrong on deleting the record.",
        shipping_address_err: "Another address is already marked as the default shipping address. Please uncheck that before selecting this one",
        billing_address_err: "Another address is already marked as the default billing address. Please uncheck that before selecting this one",
        update_address: "Something went wrong in address",
        contact_error: "Something went wrong in contact save",
        required_error: "Please fill all the required fields.",
        contact_req_error: "Please add atleast one contact",
        delete_description: "Are you sure you want to delete follow up ?",
        promotion_delete: "Something went wrong in promotion delete",
        promotion_success: "Promotion has been deleted",
        item_err: "Please add atleast one Item",
        delete_promotion: "Are you sure you want to delete promotion ?",
        delete_opportunity_item: "Are you sure you want to delete opportunity item ?",
        communicationLogMsg: "Something went wrong on communication log saving.",

      },
      tabs: {
        basic_details: "Basic Details",
        address: "Address",
        contact: "Contact",
        promotion: "Promotion",
      },
      sections: {
        generalDetail: "General Detail",
        items: "Items",
        attachment: "Attachment",
        follow_up: "Follow Up",
        ownerDetail: "Opportunity Owner Detail",
        classification: "Classification",
        amount: "Amount",
        tax: "Tax",
        add_follow_up: "Add Follow Up Date And Time",
        attachments: "Attachments",
      },
      button: {
        apply_promotion: "Apply Promotions",
        apply: "Apply",
      },
      fields: {
        id_label: "ID",
        id_placeholder: "Enter ID",
        name_label: "Name",
        name_placeholder: "Enter Name",
        item_label: "Item",
        item_placeholder: "Select Item",
        type_label: "Type",
        type_placeholder: "Select Type",
        versionNumber_label: "Version Number",
        versionNumber_placeholder: "Enter Version Number",
        quantity_label: "Quantity",
        quantity_placeholder: "Enter Quantity",
        uom_label: "UoM",
        uom_placeholder: "Select Units of Measurement",
        attachment_label: "Attach Document",
        company_label: "Company",
        company_placeholder: "Select Company",
        startDate_label: "Start Date",
        startDate_placeholder: "Select Start Date",
        endDate_label: "End Date",
        endDate_placeholder: "Select End Date",
        expiryDate_label: "Expiry Date",
        expiryDate_placeholder: "Select Expiry Date",
        location_label: "Location",
        location_placeholder: "Select Location",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        status_label: "Status",
        limit_label: "Limit",
        limit_placeholder: "Limit",
        usage_limit_label: "Usage Limit",
        limit_usage_label: "Limit Usage",
        account_label: "Account",
        percentage_label: "Percentage",
        fixed_amount_label: "Fixed Amount",
        buy_x_get_y_label: "Buy X Get Y",
        coupon_number_header: "Number Of Coupons",
        coupon_number_placeholder: "Enter Number Of Coupons",
        contact_header: "Contact",
        contact_placeholder: "Enter Contact",
        mobile_label: "Mobile",
        mobile_placeholder: "Enter Mobile",
        street1_header: "Street 1",
        street2_header: "Street 2",
        street3_header: "Street 3",
        street_placeholder: "Enter Street",
        zip_code_header: "Zip Code",
        closing_date_header: "Expected Closing Date",
        closing_date_placeholder: "Select Closing Date",
        expected_revenue_header: "Expected Revenue",
        expected_revenue_placeholder: "Enter Expected Revenue",
        stage_header: "Stage",
        stage_placeholder: "Select Stage",
        probability_header: "Probability",
        WinLoss_reason_header: "Win/Loss Reason",
        WinLoss_reason_placeholder: "Select Win/Loss Reason",
        phone_number_header: "Phone Number",
        phone_number_placeholder: "Enter Phone Number",
        email_header: "Email ID",
        email_placeholder: "Enter Email ID",
        website_header: "Website",
        website_placeholder: "Enter Website",
        currency_header: "Currency",
        currency_placeholder: "Select Currency",
        exchance_rate_header: "Exchange Rate",
        reference_no_header: "Reference No.",
        reference_no_placeholder: "Enter Reference No.",
        priority_header: "Priority",
        priority_placeholder: "Select Priority",
        salesperson_header: "Salesperson",
        salesperson_placeholder: "Select Salesperson",
        source_header: "Source",
        source_placeholder: "Select Source",
        industry_header: "Industry",
        industry_placeholder: "Select Industry",
        department_label: "Department",
        department_placeholder: "Select Department",
        status_header: "Status",
        coupon_code_label: "Coupon Code",
        coupon_code_placeholder: "Enter Coupon Code",
        delivery_commitment_date_label: "Deliver Commitment Date",
        delivery_commitment_date_placeholder: "Enter Deliver Commitment Date",
        expected_shipping_date_label: "Expected Shipping Date",
        expected_shipping_date_placeholder: "Enter Expected Shipping Date",
        rate_label: "Rate",
        rate_placeholder: "Enter Rate",
        available_label: "Available",
        onhand_label: "On Hand",
        reserved_label: "Reserved",
        discount_item_label: "Discount Item",
        discount_item_placeholder: "Select Discount Item",
        discount_rate_label: "Discount Rate",
        gross_amount_label: "Gross Amount",
        net_amount_label: "Net Amount",
        tax_amount_label: "Tax Amount",
        discount_amount_label: "Discount Amount",
        total_amount_label: "Total Amount",
        tax_template_label: "Tax Template",
        tax_template_placeholder: "Select Tax Template",
        follow_up_type_label: "Follow Up Type",
        follow_up_type_placeholder: "Select Follow Up Type",
        remind_me_label: "Remind Me",
        remind_me_placeholder: "Select Time",
        date_label: "Date",
        date_placeholder: "Enter Date",
        time_label: "Time",
        time_placeholder: "Enter Time",
        address_type_label: "Address Type",
        address_type_placeholder: "Select Address Type",
        addressee_label: "Addressee",
        addressee_placeholder: "Enter Addressee",
        address_label: "Address",
        address_placeholder: "Enter Address",
        zip_code_label: "Zip Code",
        zip_code_placeholder: "Enter Zip Code",
        city_label: "City",
        city_placeholder: "Select City",
        state_label: "State",
        state_placeholder: "Select State",
        country_label: "Country",
        country_placeholder: "Select Country",
        summary_label: "Summary",
        view_attachment_label: "Attached file",
        followup_calender_view: "Follow Ups Calendar View",
        customer_not_ready: "Customer Not Ready",
        good_lead: "Good Lead",
        install_base: "Install Base",
        lost_to_competition: "Lost to Competition",
        lost_to_internal_developement: "Lost to Internal Development",
        lost_to_no_decision: "Lost to No Decision",
        no_bandwidth: "No Bandwidth",
        no_budget: "No Budget",
        add_follow_up: "Add Follow Up",
        date: "Date",
        enter_date: "Enter Date",
        time: "Time",
        enter_time: "Enter Time",
        description: "Description",
        enter_description: "Enter Description",
        add_new_log: "Add New Communication Log",
        log_title: "Title",
        communication_type: "Communication Type",
        agenda: "Agenda",
        venue: "Venue",
        enter_log_title: "Enter Title",
        select_communication_type: "Select Communication Type",
        enter_agenda: "Enter Agenda",
        enter_venue: "Enter Venue",
        responsible_person_label: "Responsible Person",

        address_detail: "Address Detail",
        tax_code: "Tax Code",
        tax_rate: "Tax Rate",
      },
      table: {
        id_header: "ID",
        company_header: "Company",
        expected_revenue_header: "Expected Revenue",
        stage_header: "Stage",
        closing_date_header: "Closing Date",
        contact_name_header: "Contact Name",
        salesperson_header: "Salesperson",
        item_header: "Items",
        item_placeholder: "Select Item",
        item_category_header: "Item Categories",
        item_category_placeholder: "Enter Item Category",
        description_header: "Description",
        description_placeholder: "Enter Description",
        min_quantity_header: "Minimum Quantity",
        min_quantity_placeholder: "Enter Minimum Quantity",
        location_header: "Location",
        location_placeholder: "Select Location",
        discount_header: "Discount Value",
        discount_placeholder: "Enter Discount Value",
        customer_header: "Customer",
        customer_placeholder: "Select Customer",
        customer_segment_header: "Customer Segment",
        customer_segment_placeholder: "Select Customer Segment",
        discount_percentage_header: "Discount Percentage",
        discount_percentage_placeholder: "Enter Discount Percentage",
        max_amount_header: "Maximum Amount",
        narration_header: "Narration",
        order_total_header: "Order Total",
        entries_header: "Entries",
        contact_header: "Contacts",
        uom_header: "UoM",
        delivery_commitment_label: "Delivery Commitment Date",
        expected_Shipping_date_label: "Expected Shipping Date",
        quantity_label: "Quantity",
        available_label: "Available",
        onhand_label: "On Hand",
        reserved_label: "Reserved",
        rate_label: "Rate",
        gross_amount_label: "Gross Amount",
        discount_item_label: "Discounted Item",
        discount_rate_label: "Discount Rate",
        discount_amount_label: "Discounted Amount",
        net_amount_label: "Net Amount",
        tax_template_label: "Tax Template",
        tax_rate_label: "Tax Rate",
        tax_amount_label: "Tax Amount",
        total_amount_label: "Total Amount",
        department_label: "Department",
        narration: "Narration",
        promotionAmount_header: "Promotion Amount",

        name_header: "Name",
        email_header: "Email",

        followUpType_header: "Follow Up Type",
        followUpDateTime_header: "Follow Up Date & Time",
        followUpRemindMe_header: "Remind Me",
        followUpDescription_header: "Description",

        addressType_header: "Address Type",
        addressee_header: "Addressee",
        defaultShippingAddress_header: "Default shipping address",
        defaultBillingAddress_header: "Default Billing address",
        countryCode_header: "Country Code",
        contactNumber_header: "Contact Number",
        addrressOne_header: "Address 1",
        addressTwo_header: "Address 2",
        addressThree_header: "Address 3",
        zipCode_header: "Zip Code",
        city_header: "City",
        state_header: "State",
        country_header: "Country",
        summary_header: "Summary",
      },
    },
    leads: {
      title: "Leads",
      add_label: "Add New Lead",
      edit_label: "Edit Lead",
      cancel: "Cancel",
      save: "Save",
      no_log: "No Logs added yet",
      view_more: "View More",
      add_new_log: "Add New Log",
      view_in_calender: "View In Calendar",
      entries: "Entries",
      contacts: "Contacts",
      msg: {
        save: "Lead saved successfully.",
        delete: "Lead deleted successfully.",
        error: "An error occurred while processing the lead.",
        saveDraftErr: 'Please fill atleast one field',
        communicationLogMsg: "Something went wrong on communication log saving.",
        shipping_error: "Another address is already marked as the default shipping address. Please uncheck that before selecting this one",
        another_address: "Another address is already marked as the default billing address. Please uncheck that before selecting this one",
        update_address: "Something went wrong in address",
        contact_error: "Something went wrong in contact save",
        required_error: "Please fill all the required fields.",
        contact_req_error: "Please add atleast one contact",
        delete_description: "Are you sure you want to delete follow up ?",
      },
      sections: {
        generalDetail: "General Detail",
        address: "Address",
        contact: "Contact",
        followUp: "Follow Up",
        ownerDetails: "Lead Owner Details",
        classification: "Classification",
        attachments: "Attachments",
      },
      fields: {
        type_lable: "Type",
        id_label: "ID",
        id_placeholder: "Enter ID",
        firstName_label: "First Name",
        firstName_placeholder: "Enter First Name",
        middleName_label: "Middle Name",
        middleName_placeholder: "Enter Middle Name",
        lastName_label: "Last Name",
        lastName_placeholder: "Enter Last Name",
        name_label: "Name",
        type_label: 'Type',
        name_placeholder: "Enter Lead Name",
        lead_company_label: "Lead Company",
        company_label: "Company",
        company_placeholder: "Enter Company Name",
        phone_label: "Phone No.",
        phone_placeholder: "Enter Phone Number",
        email_label: "Email ID",
        email_placeholder: "Enter Email ID",
        website_label: "Website",
        website_placeholder: "Enter Website URL",
        status_label: "Status",
        status_placeholder: "Select Status",
        conversion_probability_label: "Conversion Probability",
        reference_number_label: "Reference No.",
        reference_number_placeholder: "Enter Reference No.",
        leadSource_label: "Source",
        leadSource_placeholder: "Select Source",
        salesPerson_label: "Salesperson",
        salesPerson_placeholder: "Select Salesperson",
        phoneNumber_label: "Phone Number",
        phoneNumber_placeholder: "Enter Phone Number",
        industry_label: "Industry",
        industry_placeholder: "Select Industry",
        currency_label: "Currency",
        currency_placeholder: "Select Currency",
        priority_label: "Priority",
        priority_placeholder: "Select Priority",
        narration_label: "Narration",
        narration_placeholder: "Enter Notes or Narration",
        location_label: "Location",
        location_placeholder: "Select Location",
        department_label: "Department",
        department_placeholder: "Select Department",
        annualRevenue_label: "Annual Revenue",
        annualRevenue_placeholder: "Enter Annual Revenue",
        view_attachment_label: "Attached file",
        responsible_person_label: "Responsible Person",
        responsible_person_placeholder: "Enter  Responsible Person",
        customer_label: "Customer",
        lead_status_label: "Lead Status",
        followup_calender_view: "Follow Ups Calendar View",
        add_follow_up: "Add Follow Up",
        date: "Date",
        enter_date: "Enter Date",
        time: "Time",
        enter_time: "Enter Time",
        description: "Description",
        enter_description: "Enter Description",
        add_new_log: "Add New Communication Log",
        log_title: "Title",
        communication_type: "Communication Type",
        agenda: "Agenda",
        venue: "Venue",
        enter_log_title: "Enter Title",
        select_communication_type: "Select Communication Type",
        enter_agenda: "Enter Agenda",
        enter_venue: "Enter Venue",
        vat_number_label:"Vat Number",
        create_industry_label: "Create New Industry",
        industry_name_label: "Industry Name",
        industry_name_placeholder: "Enter Industry Name",
        vat_number_placeholder: "Enter Vat Number",
        crn_placeholder: "Enter CRN",
      },
      table: {
        id_header: "ID",
        name_header: "Name",
        company_header: "Company",
        status_header: "Status",
        lead_status_header: "Lead Status",
        owner_header: "Owner",
        source_header: "Source",

        followUpType_header: "Follow Up Type",
        selectFollowUpType_header: "Select Follow Up Type",
        followUpDateTime_header: "Follow Up Date & Time",
        remindMe_header: "Remind Me",
        selectTime_header: "Select Time",
        description_header: "Description",
        addFollowUpDateTime_header: "Add Follow Up Date & Time",
        addressType_header: "Address Type",
        addressee_header: "Addressee",
        defaultShippingAddress_header: "Default shipping address",
        defaultBillingAddress_header: "Default Billing address",
        countryCode_header: "Country Code",
        contactNumber_header: "Contact Number",
        addrressOne_header: "Address 1",
        addressTwo_header: "Address 2",
        addressThree_header: "Address 3",
        zipCode_header: "Zip Code",
        city_header: "City",
        state_header: "State",
        country_header: "Country",
        summary_header: "Summary",

        email_header: "Email",
      },
      tabs: {
        basicDetails: "Basic Details",
        address: "Address",
        contact: "Contact",
      },
    },
    deliveryOrder: {
      title: "Delivery Orders",
      subHeading:
        "Efficiently document your expenses and keep your financial records in order.",
      add_label: "Add Delivery Order",
      edit_label: "Edit Delivery Order",
      msg: {
        save: "Delivery Order saved successfully.",
        requestApproved: "Delivery Order has been approved successfully.",
        requestRejected: "Delivery Order has been rejected successfully.",
        requestSubmitted: "Delivery Order has been submitted for approval.",
        delete: "Delivery Order deleted successfully.",
        conditions: "Conditions",
        attachment: "Attachment",
        classification: "Classification",
        items: "items",
        discounts: "Discounts",
        upload: "Attachments",
        quantityMessage: "Quantity should be less than remaining quantity for ",
        singleQuantityMessage: "Quantity should be less than remaining quantity",
        trackingErrorMessage: "Tracking not generated for order",
        serialError: "This serial Number is already available",
        lotError: "This lot Number is already available",
        tracibility_message: "Changing the quantity or item will remove traceability data. Do you want to proceed?",
        traceability_error: "Traceability not possible as material out of stock for selected Location.",
        traceability_success: "Traceability is Completed.",
        package_delete_message: "Deleting this item will also delete all component items linked to its package item",
        quantityError: "The added quantity is more than the quantity",
        packageSaveError: "Something went wrong in package save.",
        packageSave: "Package deleted successfully",
        trackingError: "Tracking not generated for order",
        required_error: "Please fill all the required fields.",
        trackingDetailsError: "Please add the tracking details",
        trackingDetailsUpdateError: "Something went wrong in tracking updates",
        confirm_delete: "Are you sure you want to delete?",
        delete_title: "Delete Entry"
      },
      fields: {
        id_placeholder: "Enter ID",
        id_label: "ID",
        date_label: "Date",
        currency_label: "Currency",
        currency_placeholder: "Select Currency",
        date_placeholder: "Select Date",
        lead_label: "Lead",
        quotation_label: "Quotation",
        opportunity_label: "Opportunity",
        customer_lable: "Customer",
        customer_placeholder: "Select Customer",
        location_label: "Location",
        location_placeholder: "Select Location",
        sales_order_label: "Sales Order",
        sales_order_placeholder: "Select Sales Order",
        operation_type_label: "Operation Type",
        operation_type_placeholder: "Select Operation Type",
        salesperson_label: "Salesperson",
        salesperson_placeholder: "Select Salesperson",
        company_label: "Company",
        company_placeholder: "Select Company",
        reference_label: "Reference Number",
        reference_placeholder: "Enter Reference Number",
        status_label: "Status",
        status_placeholder: "Select Status",
        narration_label: "Narration",
        narration_placeholder: "Write Narration",
        expected_shipping_date: "Expected Shipping Date",
        expiry_label: "Expiration Date",
        billing_address_label: "Billing Address",
        billing_address_placeholder: "Select Billing Address",
        place_of_supply_header: "Place of Supply",
        place_of_supply_placeholder: "Select Place of Supply",
        shipping_address_label: "Shipping Address",
        payment_terms_label: "Payment Terms",
        customer_po_number_label: "Customer PO Number",
        exchnage_rate_label: "Exchange Rate",
        recurring_label: "Recurring",
        until_date_label: "Untill Date",
        department_lable: "Department",
        attachment_label: "Attach Document",
        operation_label: "Operation",
        shipping_rule_header: "Shipping Rule",
        shipping_rule_placeholder: "Select Shipping Rule",
        shipping_cost_header: "Shipping Cost",
        shipping_cost_placeholder: "Enter Shipping Cost",
        handling_cost_header: "Handling Cost",
        handling_cost_placeholder: "Enter Handling Cost",
        handling_tax_template_header: "Handling Tax Template",
        handling_tax_template_placeholder: "Select Handling Tax Template",
        shipping_tax_template_header: "Shipping Tax Template",
        shipping_tax_template_placeholder: "Select Shipping Tax Template",
        handling_tax_amount_header: "Handling Tax Amount",
        handling_tax_amount_placeholder: "Select Handling Tax Amount",
        shipping_tax_amount_header: "Shipping Tax Amount",
        shipping_tax_amount_placeholder: "Enter Shipping Tax Amount",
        incoterm_header: "Incoterm",
        incoterm_placeholder: "Select Incoterm",
        add_item_label: "Add Item",
        edit_item_label: "Edit Item",
        tax_label: "Tax",
        amount_label: "Amount",
        package_label: "Package",
        packaging_label: "Packaging",
        traceDetails_header: "Trace Details",
        trackDetails_header: "Track Details",
        packagingDetails_label: "Packaging Details",
        attachedFile_label: "Attached File",
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        salesorder_header: "Sales Order",
        status_header: "Status",
        salesperson_header: "Salesperson",
        customer_header: "Customer",
        location_header: "Location",
        company_header: "Company",
        item_label: "Item",
        item_placeholder: "Select Item",
        id_placeholder: "Enter ID",
        sales_order_line_label: "Sales Order line",
        sales_order_placeorder: "Select sales Order",
        quantity_label: "Quantity",
        quantity_placeholder: "Enter Quantity",
        on_hand_label: "On Hand",
        on_hand_placeholder: "Enter Price",
        reserved_label: "Reserved",
        remaining_label: "Remaining",
        deparatment_label: "Department",
        department_placeholder: "Select Department",
        id_label: "ID",
        date_label: "Date",
        date_placeholder: "Select Date",
        customer_lable: "Customer",
        customer_placeholder: "Select Customer",
        location_label: "Location",
        location_placeholder: "Select Location",
        sales_order_label: "Sales Order",
        sales_order_placeholder: "Select Sales Order",
        operation_type_label: "Operation Type",
        operation_type_placeholder: "Select Operation Type",
        salesperson_label: "Salesperson",
        salesperson_placeholder: "Select Salesperson",
        place_of_supply_header: "Place of Supply",
        place_of_supply_placeholder: "Select Place of Supply",
        company_label: "Company",
        company_placeholder: "Select Company",
        reference_label: "Reference Number",
        reference_placeholder: "Enter Reference Number",
        status_label: "Status",
        status_placeholder: "Select Status",
        narration_label: "Narration",
        narration_placeholder: "Write Narration",
        supplier_address_header: "Supplier Address",
        supplier_address_placeholder: "Select Supplier Address",
        contact_person_header: "Contact Person",
        contact_person_placeholder: "Select Contact Person",
        company_shipping_address_header: " Shipping Address",
        shipping_address_header: "Shipping Address",
        shipping_address_placeholder: "Select Shipping Address",
        company_billing_address_header: " Billing Address",
        billing_address_header: "Billing Address",
        billing_address_placeholder: "Select Billing Address",
      },
      sections: {
        generalDetails: "Basic Details",
        item: "Items",
        classification: "Classification",
        upload: "Attachment",
      },
      tabs: {
        generalDetails: "Basic Details",
        address: "Address and Contact",
        shipping: "Shipping",
        promotion: "Promotion",
        package: "Package",
      },
      packageFields: {
        item_label: "Item",
        sourceLocation_label: "Location",
        available_header: "Available",
        package_header: "Package",
        package_placeholder: "Select Package",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
      },
      traceFields: {
        traceability: "Traceability",
        item_label: "Item",
        location_label: "Location",
        destinationLocation_header: "Destination Location",
        availableQty_header: "Available",
        Qty_header: "Quantity",
        request_header: "Request",
        reserve_header: "Reserve",
        lot_header: "Lot/Serial number",
        lot_placeholder: "Select Lot/Serial number",
        enter_lot_placeholder: "Please enter Lot/Serial Number",
        bin_header: "Bin number",
        bin_placeholder: "Select Bin number",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        lotList: "Lot/Serial Number List",
        lotEntries: "Lot/Serial Number Entries"
      },
      button: {
        sales_order: "Sale Order"
      }
    },
    salesOrder: {
      title: "Sales Order",
      add_label: "Add Sales Order",
      edit_label: "Edit Sales Order",
      add_item: "Add Item",
      item: "Item",
      item_placeholder: "Select Item",
      uom: "UOM",
      uom_placeholder: "Select UOM",
      description: "Description",
      description_placeholder: "Enter Description",
      delivery_commitment_date: "Delivery Commitement Date",
      delivery_commitment_date_placeholder: "Select Delivery Commitement Date",
      expected_shipping_date: "Expected Shipping Date",
      expected_shipping_date_placeholder: "Enter Expected Shipping Date",
      quantity: "Quantity",
      rate: "Rate",
      available: "Available",
      on_hand: "On Hand",
      reserved: "Reserved",
      discount_item: "Discount Item",
      discount_item_placeholder: "Select Discount Item",
      discount_rate: "Discount Rate (%)",
      amount: "Amount",
      gross_amount: "Gross Amount",
      tax_amount: "Tax Amount",
      discount_amount: "Discount Amount",
      net_amount: "Net Amount",
      total_amount: "Total Amount",
      committed: 'Committed',
      back_ordered: "Back Ordered",
      msg: {
        save: "Sales order saved successfully.",
        delete: "Sales order deleted successfully.",
        error: "An error occurred while processing the sales order.",
        requestApproved: "Sales order has been approved successfully.",
        requestRejected: "Sales order has been rejected successfully.",
        requestSubmitted: "Sales order has been submitted for approval.",
        promotionRemoved: "promotions have been removed due to expiration of their validity.",
        req_field_err: 'Please fill atleast one field',
        req_field_err1: 'Please fill all the required fields.',
        promotion_err: "Something went wrong on promotion apply",
        coupon_err: 'Coupon code must be alphanumeric.',
        delete_descriptiom: "Are you sure you want to delete item ?",
        promotion_delete: 'Something went wrong in promotion delete',
        promotion_delete_success: "Promotion has been deleted",
        delete_promotion_description: "Are you sure you want to delete promotion ?",
      },
      button: {
        apply_promotion: "Apply Promotions",
        apply: "Apply",
      },
      sections: {
        generalDetail: "General Detail",
        address: "Address",
        contact: "Contact",
        classification: "Classifications",
        attachment: "Attachment",
        items: "Items",
        delivery: "Delivery",
        discounts: "Discounts",
        companyShippibngAddress: "Shipping Address",
        companyBillingAddress: "Billing Address",
        salesOrderdetails: "Sales Order Details",
      },
      fields: {
        transaction_type_label: "Transaction Type",
        type_lable: "Type",
        id_label: "ID",
        id_placeholder: "Enter ID",
        date_label: "Date",
        date_placeholder: "Select Date",
        opportunity_label: "Opportunity",
        opportunity_placeholder: "Select Opportunity",
        quotation_label: "Quotation",
        quotation_placeholder: "Select Quotation",
        customer_label: "Customer",
        customer_placeholder: "Select Customer",
        postingTime_label: "Posting Time",
        postingTime_placeholder: "HH:MM PM",
        paymentTerm_label: "Payment Terms",
        paymentTerm_placeholder: "Select Payment Terms",
        company_label: "Company",
        company_placeholder: "Select Company",
        currency_label: "Currency",
        currency_placeholder: "Select Currency",
        exchangeRate_label: "Exchange Rate",
        exchangeRate_placeholder: "0.00",
        expirationDate_label: "Expiration Date",
        expirationDate_placeholder: "Select Date",
        salesPerson_label: "Salesperson",
        salesPerson_placeholder: "Select Salesperson",
        poNumber_label: "PO Number",
        poNumber_placeholder: "Enter PO Number",
        recurring_label: "Recurring",
        recurring_placeholder: "Select Recurring",
        untilDate_label: "Untill Date",
        untilDate_placeholder: "Select Date",
        location_label: "Location",
        location_placeholder: "Select Location",
        department_label: "Department",
        department_placeholder: "Select Department",
        deliveryDate_label: "Delivery Date",
        deliveryDate_placeholder: "Select Date",
        deliveryCommitmentDate_label: "Delivery Commitment Date",
        deliveryCommitmentDate_placeholder: "Select Date",
        additionalDiscountOn_label: "Apply Additional Discount On",
        additionalDiscountOn_placeholder: "Additional Discount",
        additionalDiscountPercentage_label: "Additional Discount Percentage",
        additionalDiscountPercentage_placeholder:
          "Enter Additional Discount Percentage",
        additionalDiscountAmount_label: "Additional Discount Amount",
        additionalDiscountAmount_placeholder:
          "Enter Additional Discount Amount",
        cashOrNonTarde_label: "Is Cash or Non Trade Discount",
        roundOffCheck_label: "Round off",
        roundOff_label: "Round off",
        roundOffAmount_label: "Round Off Amount",
        roundOff_placeholder: "Select round off",
        attachment_label: "Attach your file here",
        attachedFile_label: "Attached file",
        narration_label: "Narration",

        supplierAddress_label: "Supplier Address",
        supplierAddress_placeholder: "Select Supplier Address",
        contactPerson_label: "Contact Person",
        contactPerson_placeholder: "Select Contact Person",
        shippingAddress_label: "Shipping Address",
        shippingAddress_placeholder: "Select Shipping Address",
        billingAddress_label: "Billing Address",
        billingAddress_placeholder: "Select Billing Address",
        placeOfSupply_label: "Place of Supply",
        placeOfSupply_placeholder: "Select Place of Supply",

        expectedShippingDate_label: "Expected Shipping Date",
        expectedShippingDate_placeholder: "Select Date",
        shippingRule_label: "Shipping Rule",
        shippingRule_placeholder: "Select Shipping Rule",
        shippingCost_label: "Shipping Cost",
        shippingCost_placeholder: "Enter Shipping Cost",
        handlingCost_label: "Handling Cost",
        handlingCost_placeholder: "Enter Handling Cost",
        shippingTaxTemplate_label: "Shipping Tax Template",
        shippingTaxTemplate_placeholder: "Select Shipping Tax Template",
        handlingTaxTemplate_label: "Handling Tax Template",
        handlingTaxTemplate_placeholder: "Select Handling Tax Template",
        shippingTaxAmount_label: "Shipping Tax Amount",
        shippingTaxAmount_placeholder: "Enter Shipping Tax Amount",
        handlingTaxAmount_label: "Handling Tax Amount",
        handlingTaxAmount_placeholder: "Enter Handling Tax Amount",
        incoterm_label: "Incoterm",
        incoterm_placeholder: "Select Incoterm",
        tax_code: "Tax Code",
        tax_rate: "Tax Rate",
        actual_amount: "Actual Amount",
        uom: "UOM",
        select_uom: "Select UOM",
        delivery_commitment_date: "Delivery Commitement Date",
        delivery_commitment_date_placeholder: "Select Delivery Commitement Date",
        expected_shipping_date: "Expected Shipping Date",
        expected_shipping_date_placeholder: "Enter Expected Shipping Date",
        quantity: "Quantity",
        rate: "Rate",
        available: "Available",
        on_hand: "On Hand",
        commited: 'Commited',
        back_order: 'Back Order',
        delivered: 'Delivered',
        invoiced: 'Invoiced',
        discount_item: "Discount Item",
        discount_item_placeholder: "Select Discount Item",
        discount_rate_header: "Discount Rate (%)",
        amount: "Amount",
        gross_amount: "Gross Amount",
        tax_amount: "Tax Amount",
        discount_amount: "Discount Amount",
        net_amount: "Net Amount",
        total_amount: "Total Amount",
        tax: "Tax",
        tax_template: "Tax Template",
        select_tax_template: "Select Tax Template",
        terms_condition_content_label: "Terms and Conditions",
        termsCondition_label: "Terms & Condition (Contents)",
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        customer_header: "Customer",
        salesOrderStatus_header: "Sales Order Status",
        invoiceStatus_header: "Invoice Status",
        deliveryStatus_header: "Delivery Status",
        salesperson_header: "Salesperson",
        company_header: "Company",
        item_header: "Item",
        item_header_placeholder: "Select Item",
        uom_header: "UOM",
        uom_header_placeholder: "Select UOM",
        description_header: "Description",
        description_header_placeholder: "Enter Description",
        deliveryCommitmentDate_header: "Delivery Commitment Date",
        deliveryCommitmentDate_header_placeholder:
          "Select Delivery Commitment Date",
        expectedShippingDate_header: "Expected Shipping Date",
        expectedShippingDate_header_placeholder:
          "Select Expected Shipping Date",
        quantity_header: "Quantity",
        quantity_header_placeholder: "Enter Quantity",
        rate_header: "Rate",
        rate_header_placeholder: "Enter Rate",
        available_header: "Available",
        onHand_header: "On Hand",
        reserved_header: "Reserved",
        backOrdered_header: "Back Ordered",
        invoiced_header: "Invoiced",
        delivered_header: "Delivered",
        grossAmount_header: "Gross Amount",
        discountItem_header: "Discounted Item",
        discountedAmount_header: "Discount Amount",
        discountRate_header: "Discount Rate",
        netAmount_header: "Net Amount",
        taxTemplate_header: "Tax Template",
        taxAmount_header: "Tax Amount",
        totalAmount_header: "Total Amount",
        location_header: "Location",
        department_header: "Department",
        narration_header: "Narration",
        gross_amount_header: "Gross Amount",
        couponCode_header: "Coupon Code",
        couponDescription_header: "Description",
        account_header: "Account",
        type_header: "Type",
        promotionAmount_header: "Promotion Amount / %",
        promotion_amount_header: "Promotion Amount",
        discountAmount_header: "Discount Amount",
      },
      tabs: {
        basicDetails: "Basic Details",
        addressAndContact: "Address & Contact",
        shipping: "Shipping",
        promotions: "Promotions ",
      },
    },
    customerReturn: {
      title: "Customer Returns",
      subHeading:
        "Efficiently document your expenses and keep your financial records in order.",
      add_label: "Add Customer Return",
      edit_label: "Edit Customer Return",
      add_grn_label: "Add GRN",
      edit_grn_label: "Edit GRN",
      grn_title: "GRN",
      goods_receipt_label: "Goods Receipt",
      msg: {
        save: "Customer Returns saved Successfully.",
        requestApproved: "Customer Returns has approved successfully.",
        requestRejected: "Customer Returns has rejected successfully.",
        requestSubmitted: "Customer Returns has been submitted for approval",
        delete: "Customer Returns deleted successfully.",
        grn_save: "GRN creatd successfully",
        grn_update: "GRN updated successfully",
        save_as_draft: "Please fill atleast one field",
        tracibility_message: "Changing the quantity or item will remove traceability data. Do you want to proceed?",
        item_err: "Please add atleast one Item",
        delete_item_error: "Something went wrong in an item delete",
        confirm_delete: "Are you sure you want to delete?",
        grn_delete_error: "Something went wrong in GRN delete",
        traceability_error: "Traceability not possible as material out of stock for selected Location.",
        traceability_success: "Traceability is Completed."
      },
      fields: {
        id_placeholder: "Enter ID",
        id_label: "ID",
        date_label: "Date",
        date_placeholder: "Select Date",
        lead_label: "Lead",
        quotation_label: "Quotation",
        opportunity_label: "Opportunity",
        customer_lable: "Customer",
        customer_placeholder: "Select Customer",
        location_label: "Location",
        location_placeholder: "Select Location",
        sales_order_label: "Sales Order",
        sales_order_placeholder: "Select Sales Order",
        operation_type_label: "Operation Type",
        operation_type_placeholder: "Select Operation Type",
        salesperson_label: "Salesperson",
        salesperson_placeholder: "Select Salesperson",
        company_label: "Company",
        company_placeholder: "Select Company",
        reference_label: "Reference Number",
        reference_placeholder: "Enter Reference Number",
        status_label: "Status",
        status_placeholder: "Select Status",
        narration_label: "Narration",
        narration_placeholder: "Write Narration",
        expected_shipping_date: "Expected Shipping Date",
        expiry_label: "Expiration Date",
        billing_address_label: "Billing Address",
        billing_address_placeholder: "Select Billing Address",
        place_of_supply_header: "Place of Supply",
        place_of_supply_placeholder: "Select Place of Supply",
        shipping_address_label: "Shipping Address",
        payment_terms_label: "Payment Terms",
        customer_po_number_label: "Customer PO Number",
        exchnage_rate_label: "Exchange Rate",
        recurring_label: "Recurring",
        until_date_label: "Untill Date",
        department_lable: "Department",
        attachment_label: "Attach Document",
        operation_label: "Operation",
        shipping_rule_header: "Shipping Rule",
        shipping_rule_placeholder: "Select Shipping Rule",
        shipping_cost_header: "Shipping Cost",
        shipping_cost_placeholder: "Enter Shipping Cost",
        handling_cost_header: "Handling Cost",
        handling_cost_placeholder: "Enter Handling Cost",
        handling_tax_template_header: "Handling Tax Template",
        handling_tax_template_placeholder: "Select Handling Tax Template",
        shipping_tax_template_header: "Shipping Tax Template",
        shipping_tax_template_placeholder: "Select Shipping Tax Template",
        handling_tax_amount_header: "Handling Tax Amount",
        handling_tax_amount_placeholder: "Select Handling Tax Amount",
        shipping_tax_amount_header: "Shipping Tax Amount",
        shipping_tax_amount_placeholder: "Enter Shipping Tax Amount",
        incoterm_header: "Incoterm",
        incoterm_placeholder: "Select Incoterm",
        currency_label: "Currency",
        currency_placeholder: "Select Currency",
        deparment_lable: "Deparment",
        deparment_placeholder: "Select Department",
        delivery_status: "Delivery Status",
        tax_code_label: "Tax Code",
        tax_rate_label: "Tax Rate",
        add_item_label: "Add Item",
        package_label: "Package",
        packaging_label: "Packaging",
        traceDetails_header: "Trace Details",
        trackDetails_header: "Track Details",
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        salesorder_header: "Sales Order",
        status_header: "Status",
        salesperson_header: "Salesperson",
        customer_header: "Customer",
        company_header: "Company",
        rma_status_header: "RMA Status",
        item_label: "Item",
        item_placeholder: "Select Item",
        id_placeholder: "Enter ID",
        sales_order_line_label: "Sales Order line",
        sales_order_placeorder: "Select sales Order",
        description_header: "Description",
        description_placeholder: "Enter Description",
        quantity_label: "Quantity",
        quantity_placeholder: "Enter Quantity",
        on_hand_label: "On Hand",
        on_hand_placeholder: "Enter Price",
        discount_header: "Discounted Item",
        discount_placeholder: "Select Discount Item",
        discountRate_header: "Discount Rate (%)",
        reserved_label: "Reserved",
        remaining_label: "Remaining",
        deparatment_label: "Department",
        department_placeholder: "Select Department",
        id_label: "ID",
        date_label: "Date",
        rate_label: "Rate",
        rate_placeholder: "Enter Rate",
        uom_header: "UOM",
        uom_placeholder: "Select UOM",
        date_placeholder: "Select Date",
        customer_lable: "Customer",
        customer_placeholder: "Select Customer",
        location_label: "Location",
        location_placeholder: "Select Location",
        sales_order_label: "Sales Order",
        sales_order_placeholder: "Select Sales Order",
        operation_type_label: "Operation Type",
        operation_type_placeholder: "Select Operation Type",
        salesperson_label: "Salesperson",
        salesperson_placeholder: "Select Salesperson",
        company_label: "Company",
        company_placeholder: "Select Company",
        reference_label: "Reference Number",
        reference_placeholder: "Enter Reference Number",
        status_label: "Status",
        status_placeholder: "Select Status",
        narration_label: "Narration",
        narration_placeholder: "Write Narration",
        supplier_address_header: "Supplier Address",
        supplier_address_placeholder: "Select Supplier Address",
        contact_person_header: "Contact Person",
        contact_person_placeholder: "Select Contact Person",
        company_shipping_address_header: "Company Shipping Address",
        shipping_address_header: "Shipping Address",
        shipping_address_placeholder: "Select Shipping Address",
        company_billing_address_header: "Company Billing Address",
        billing_address_header: "Billing Address",
        billing_address_placeholder: "Select Billing Address",
        grossAmount_header: "Gross Amount",
        discountItem_header: "Discounted Item",
        discountedAmount_header: "Discount Amount",
        netAmount_header: "Net Amount",
        taxTemplate_header: "Tax Template",
        tax_template_placeholder: "Select Tax Template",
        taxAmount_header: "Tax Amount",
        totalAmount_header: "Total Amount",
        location_header: "Location",
        department_header: "Department",
        narration_header: "Narration",
        gross_amount_header: "Gross Amount",
      },
      sections: {
        generalDetails: "Basic Details",
        item: "Items",
        classification: "Classification",
        upload: "Attachment",
      },
      tabs: {
        generalDetails: "Basic Details",
        address: "Address and Contact",
        shipping: "Shipping",
        promotion: "Promotion",
        package: "Package",
      },
      packageFields: {
        item_label: "Item",
        sourceLocation_label: "Location",
        available_header: "Available",
        package_header: "Package",
        package_placeholder: "Select Package",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
      },
      traceFields: {
        item_label: "Item",
        location_label: "Location",
        destinationLocation_header: "Destination Location",
        availableQty_header: "Available",
        Qty_header: "Quantity",
        request_header: "Request",
        reserve_header: "Reserve",
        lot_header: "Lot/Serial number",
        lot_placeholder: "Select Lot/Serial number",
        enter_lot_placeholder: "Please enter Lot/Serial Number",
        bin_header: "Bin number",
        bin_placeholder: "Select Bin number",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        lotList: "Lot/Serial Number List",
        lotEntries: "Lot/Serial Number Entries"
      },
      button: {
        view_grn: "View GRN",
        credit_note: "Credit Note",
        receive: "Receive",
        view_rma: "View RMA"
      }
    },
    settings: {
      setting_label: "Setting",
      delivery_setting_label: "Settings",
      quote_percentage_label: "Quote Percentage (%)",
      delivery_multiple_location_label: "Allow Delivery From Multiple Locations",
      advance_invoice_label: "Invoice In Advance",
      termsAndConditions: {
        title: 'Terms & Conditions',
        add_label: 'Add New',
        edit_label: 'ID: :id',
        table: {
          id: 'ID',
          id_placeholder: 'Enter ID',
          name: 'Name',
          name_placeholder: 'Enter Name',
          status: 'Status',
          terms_and_condition_placeholder: 'Write your Terms & Conditions here',
        },
        fields: {
          id: 'ID',
          id_placeholder: 'Enter ID',
          name: 'Name',
          name_placeholder: 'Enter Name',
          status: 'Status',
          terms_and_condition_placeholder: 'Write your Terms & Conditions here',
        },
        msg: {
          create: 'Terms & conditions created successfully',
          update: 'Terms & conditions ID: :id updated successfully',
        },
      },
    },
    salesOrderSummaryReport: {
      title: "Sales Order Summary",
    },
    salesInvoiceSummaryReport: {
      title: "Sales Invoice Summary Report"
    },
    salesOrderDetailReport: {
      title: "Sales Order Detail",
    },
    salesInvoiceDetailReport: {
      title: "Sales Invoice Detail",
    },
    salesBySalespersonPerformance: {
      title: "Sales By Salesperson",
    },
    pendingQuotesApprovals: {
      title: "Pending Quotes",
    },
    salesReturnCreditNoteReport: {
      title: "Sales Return & Credit",
    },
    regionalBranchSalesPerformance: {
      title: "Regional Sales Performance",
    },
    salesDiscountPromotionAnalysis: {
      title: "Sales Discount Analysis",
    },
    salesChannelAnalysis: {
      title: "Sales Channel Analysis",
    },
    orderFulfillmentDeliveryReport: {
      title: "Order Fulfillment",
    },
    salesCommissionIncentiveReport: {
      title: "Sales Commission",
    },
    salesByProductServiceReport: {
      title: "Sales By Product",
    },
    customerChurnRetentionReport: {
      title: "Customer Churn & Retention",
    },
  },
  purchase: {
    name: "Purchase",
    title: "This is Purchase module",

    request: {
      name: "Requests",
      title: "Requests",
      add_label: "Add New Request",
      edit_label: "Edit  Request",
      tax: "Tax",
      sections: {
        generalDetails: "Basic Details",
        items: "Items",
        classification: "Classification",
        upload: "Attachment",
      },
      msg: {
        requestApproved: "Requests has been approved successfully.",
        requestRejected: "Requests has been rejected successfully.",
        requestSubmitted: "Requests has been submitted for approval.",
        req_item_err: "Please fill required field in item:",
        cancel_msg: "Are you sure you want to Cancelled",
        close_msg: "Are you sure you want to Close"
      },
      button: {
        order: "Order",
        rfq: "RFQ",
      },
      fields: {
        id_label: "ID",
        id_placeholder: "ID",
        date_label: "Date",
        date_placeholder: "Select Date",
        company_label: "Company",
        company_placeholder: "Select Company",
        purchase_represntive_label: "Purchase Representative",
        purchase_represntive_placeholder: "Select Purchase Representative",
        vendor_label: "Vendor",
        vendor_placeholder: "Select Vendor",
        currency_label: "Currency",
        currency_placeholder: "Select Currency",
        narration_label: "Narration",
        narration_Placeholder: "Enter Narration",
        location_label: "Location",
        location_placeholder: "Select Location",
        deparatment_label: "Department",
        department_placeholder: "Select Department",
        tax_code_label: "Tax Code",
        tax_rate_label: "Tax Rate",
        add_item_label: "Add Item",
        package_label: "Package",
        packaging_label: "Packaging",
        traceDetails_header: "Trace Details",
        trackDetails_header: "Track Details",
      },
      table: {
        item_header: "Item",
        item_placeholder: "Select Item",
        vendor_header: "Vendor Name",
        vendor_placeholder: "Enter Vendor Name",
        uom_header: "UoM",
        uom_placeholder: "Select UoM",
        description_header: "Description",
        description_placeholder: "Enter Descriptioon",
        delivery_commitment_date_header: "Delivery Commitment Date",
        delivery_commitment_date_placeholder: "Enter Delivery Commitment Date",
        expected_shipping_date_header: "Expected Shipping Date",
        expected_shipping_date_placeholder: "Expected Shipping Date",
        available_header: "Available",
        on_hand_header: "On Hand",
        on_hand_placeholder: "Enter On hand Quantity",
        company_header: "Company",
        status_header: "Status",
        quantity_header: "Quantity",
        reserved_header: "Reserved",
        reserved_placeholder: "Enter Reserved quantity",
        tax_rate_placeholder: "Enter Tax rate",
        rate_header: "Rate",
        gross_amount_header: "Gross Amount",
        gross_amount_placeholder: "Enter Gross Amount",
        discount_header: "Discounted Item",
        discount_placeholder: "Select Discount Item",
        discount_rate_header: "Discount Rate (%)",
        discount_rate_placeholder: "Enter Discounted rate",
        discount_amount_header: "Discount Amount",
        discount_amount_placeholder: "Enter Discount Amount",
        net_amount_header: "Net Amount",
        tax_template_header: "Tax Template",
        tax_template_placeholder: "Select Tax Template",
        tax_rate_header: "Tax Rate",
        tax_amount_header: "Tax Amount",
        tax_amount_placeholder: "Enter Tax Amount",
        promotion_amount: "Promotion Amount",
        total_amount_header: "Total Amount",
        location_header: "Location",
        location_placeholder: "Select Location",
        deparatment_header: "Department",
        department_placeholder: "Select Department",
        narration_header: "Narration",
        narration_placeholder: "Enter Narration",
        supplier_address_header: "Supplier Address",
        supplier_address_placeholder: "Select Supplier Address",
        contact_person_header: "Contact Person",
        contact_person_placeholder: "Select Contact Person",
        shipping_address_header: "Shipping Address",
        shipping_address_placeholder: "Select Shipping Address",
        billing_address_header: "Billing Address",
        billing_address_placeholder: "Select Billing Address",
        place_of_supply_header: "Place of Supply",
        place_of_supply_placeholder: "Select Place of Supply",
        classification_header: "classification",
        amount: "Amount",
        date_label: "Date",
        rate_label: "Rate",
        rate_placeholder: "Enter Rate",
        date_placeholder: "Select Date",
        customer_lable: "Customer",
        customer_placeholder: "Select Customer",
        location_label: "Location",
        sales_order_label: "Sales Order",
        sales_order_placeholder: "Select Sales Order",
        operation_type_label: "Operation Type",
        operation_type_placeholder: "Select Operation Type",
        salesperson_label: "Salesperson",
        salesperson_placeholder: "Select Salesperson",
        company_label: "Company",
        company_placeholder: "Select Company",
        reference_label: "Reference Number",
        reference_placeholder: "Enter Reference Number",
        status_label: "Status",
        status_placeholder: "Select Status",
        narration_label: "Narration",
        grossAmount_header: "Gross Amount",
        discountItem_header: "Discounted Item",
        discountedAmount_header: "Discount Amount",
        netAmount_header: "Net Amount",
        taxTemplate_header: "Tax Template",
        taxAmount_header: "Tax Amount",
        totalAmount_header: "Total Amount",
        department_header: "Department",
      },
    },
    agreement: {
      name: "Purchase Agreements",
      title: "Purchase Agreements",
      subHeading:
        "Efficiently document your expenses and keep your financial records in order.",
      add_label: "New Purchase Agreement",
      edit_label: "Edit Purchase Agreement",
      view_label: "Purchase Agreement Details",
      msg: {
        save: "Purchase agreement saved successfully.",
        delete: "Purchase agreement deleted successfully.",
        error: "An error occurred while processing the purchase agreement.",
        requestApproved: "Purchase Agreement has approved successfully.",
        requestRejected: "Purchase Agreement has rejected successfully.",
        requestSubmitted: "Purchase Agreement has been submitted for approval",
        validated: "Purchase Agreement validated successfully",
        closed: "Purchase Agreement closed successfully",
        req_field_err: "Please fill atleast one field",
        delete_err: "Are you sure you want to delete agreement item ?",
        validate_err: "Are you sure you want to Validate Agreement:"
      },
      sections: {
        basic_details: "Basic Details",
        items: "Items",
        attachments: "Attachments",
        classification: "Classification",
        add_item: "Add Item",
      },
      table: {
        item_header: "Item",
        item_placeholder: "Select Item",
        id_header: "ID",
        date_header: "Date",
        name_header: "Name",
        purchase_representative_header: "Purchase Representative",
        vendor_header: "Vendor",
        company_header: "Company",
        valid_header: "Valid Up To",
        status_header: "Status",
      },
      fields: {
        id_label: "ID",
        id_placeholder: "Purchase Agreement ID",
        date_label: "Date",
        date_placeholder: "Select Date",
        name_label: "Name",
        name_placeholder: "Enter Name",
        type_label: "Agreement Type",
        type_placeholder: "Select Agreement Type",
        vendor_label: "Vendor",
        vendor_placeholder: "Select Vendor",
        purchase_representative_label: "Purchase Representative",
        purchase_representative_placeholder: "Select Purchase Representative",
        valid_up_to_label: "Valid Up To",
        valid_up_to_placeholder: "Select Date",
        company_label: "Company",
        company_placeholder: "Select Company",
        currency_label: "Currency",
        currency_placeholder: "Select Currency",
        payment_terms_label: "Payment Terms",
        payment_terms_placeholder: "Select Payment Terms",
        incoterms_label: "Incomterms",
        incoterms_placeholder: "Select Incoterms",
        instructions_label: "Instructions",
        instructions_placeholder: "Enter Instructions",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        update_vendor_prices_label: "Update Vendor Prices",
        location_label: "Location",
        location_placeholder: "Select Location",
        department_label: "Department",
        department_placeholder: "Select Department",
        view_attachments_label: "View Attached Files",
      },
      item_table: {
        item_name_header: "Item",
        vendor_header: "Vendor Name",
        uom_header: "UoM",
        description_header: "Description",
        specification_header: "Specification",
        rate_header: "Rate",
        min_order_qty_header: "Minimum Order Quantity",
        gross_amount: "Gross Amount",
        fields: {
          item_label: "Item",
          item_placeholder: "Select Item",
          vendor_label: "Vendor Item Name",
          vendor_placeholder: "Vendor Item Name",
          uom_label: "UoM",
          uom_placeholder: "Select UoM",
          description_label: "Description",
          description_placeholder: "Enter Description",
          specification_label: "Specification",
          specification_placeholder: "Enter Specification",
          rate_label: "Rate",
          rate_placeholder: "Enter Rate",
          min_order_qty_label: "Minimum Order Quantity",
          min_order_qty_placeholder: "Enter Quantity",
          gross_amount_label: "Gross Amount",
          gross_amount_placeholder: "Gross Amount",
        },
      },
    },
  },
  hrms: {
    name: "HRMS",
    title: "This is HRMS module",
  },
  office: {
    name: "Office",
    title: "This is OFFICE module",
  },
  rental: {
    name: "Rental",
    title: "This is RENTAL module",
    settings: {
      title: 'Settings',
      termsAndConditions: {
        title: 'Terms & Conditions',
        add_label: 'Add New',
        edit_label: 'ID: :id',
        table: {
          id: 'ID',
          name: 'Name',
          status: 'Status',
        },
        fields: {
          id: 'ID',
          id_placeholder: 'Enter ID',
          name: 'Name',
          name_placeholder: 'Enter Name',
          status: 'Status',
          terms_and_condition_placeholder: 'Write your Terms & Conditions here',
        },
        msg: {
          delete: 'Terms & conditions ID: :id deleted successfully',
          create: 'Terms & conditions created successfully',
          update: 'Terms & conditions ID: :id updated successfully',
        }
      },
      configuration: {
        title: 'Configurations',
        add_label: 'Add New',
        edit_label: 'ID: :id',
        fields: {
          initial_invoicing: 'Enable Initial Invoicing',
          inventory_status: 'Enable Inventory Status',
          no_of_days: 'No. Of Days',
          no_of_days_placeholder: 'Enter Count',
        },
        msg: {
          save: 'Configuration saved successfully'
        }
      },
      billingCycle: {
        title: 'Recurring Billing Plans',
        view_title: 'Billing Cycle',
        add_label: 'Add New',
        edit_label: 'Edit',
        fields: {
          id: 'ID',
          id_placeholder: 'Enter ID',
          name: 'Name',
          name_placeholder: 'Enter Name',
          count: 'Count',
          count_placeholder: 'Enter Count',
          duration: 'Duration',
          duration_placeholder: 'Select Duration',
          company: 'Company',
          company_placeholder: 'Select Company',
        },
        table: {
          id: 'ID',
          name: 'Name',
          duration: 'Duration',
          company: 'Company',
        }
      },
      settings: {
        title: 'Settings',
        quote_percentage_label: 'Quote Percentage (%)',
      }
    },
    opportunity: {
      title: "Opportunities",
      breadScrumbTitle: 'Opportunity ',
      add_label: "Add Opportunity",
      edit_label: "Edit Opportunity",
      view_label: "Opportunity Details",
      view_sales_pipeline: "Sales Pipeline",
      msg: {
        save: "Opportunity saved Successfully.",
        requestApproved: "Opportunity has approved successfully.",
        requestRejected: "Opportunity has rejected successfully.",
        requestSubmitted: "Opportunity has been submitted for approval",
        delete: "Opportunity deleted successfully.",
      },
      tabs: {
        basic_details: "Basic Details",
        address: "Address",
        contact: "Contact",
        promotion: "Promotion",
      },
      sections: {
        generalDetail: "General Detail",
        items: "Items",
        attachment: "Attachment",
        follow_up: "Follow Up",
        ownerDetail: "Opportunity Owner Detail",
        classification: "Classification",
        amount: "Amount",
        tax: "Tax",
        add_follow_up: "Add Follow Up Date And Time",
        attachments: "Attachments",
      },
      button: {
        apply_promotion: "Apply Promotions",
        apply: "Apply",
      },
      fields: {
        id_label: "ID",
        id_placeholder: "Enter ID",
        name_label: "Name",
        name_placeholder: "Enter Name",
        item_label: "Item",
        item_placeholder: "Select Item",
        type_label: "Type",
        type_placeholder: "Select Type",
        versionNumber_label: "Version Number",
        versionNumber_placeholder: "Enter Version Number",
        quantity_label: "Quantity",
        quantity_placeholder: "Enter Quantity",
        uom_label: "UoM",
        uom_placeholder: "Select Units of Measurement",
        attachment_label: "Attach Document",
        company_label: "Company",
        company_placeholder: "Select Company",
        startDate_label: "Start Date",
        startDate_placeholder: "Select Start Date",
        endDate_label: "End Date",
        endDate_placeholder: "Select End Date",
        expiryDate_label: "Expiry Date",
        expiryDate_placeholder: "Select Expiry Date",
        location_label: "Location",
        location_placeholder: "Select Location",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        status_label: "Status",
        limit_label: "Limit",
        limit_placeholder: "Limit",
        usage_limit_label: "Usage Limit",
        limit_usage_label: "Limit Usage",
        account_label: "Account",
        percentage_label: "Percentage",
        fixed_amount_label: "Fixed Amount",
        buy_x_get_y_label: "Buy X Get Y",
        coupon_number_header: "Number Of Coupons",
        coupon_number_placeholder: "Enter Number Of Coupons",
        contact_header: "Contact",
        contact_placeholder: "Select Contact",
        closing_date_header: "Expected Closing Date",
        closing_date_placeholder: "Select Closing Date",
        expected_revenue_header: "Expected Revenue",
        expected_revenue_placeholder: "Enter Expected Revenue",
        stage_header: "Stage",
        stage_placeholder: "Select Stage",
        probability_header: "Probability",
        WinLoss_reason_header: "Win/Loss Reason",
        WinLoss_reason_placeholder: "Select Win/Loss Reason",
        phone_number_header: "Phone Number",
        phone_number_placeholder: "Enter Phone Number",
        email_header: "Email ID",
        email_placeholder: "Enter Email ID",
        website_header: "Website",
        website_placeholder: "Enter Website",
        currency_header: "Currency",
        currency_placeholder: "Select Currency",
        exchance_rate_header: "Exchange Rate",
        reference_no_header: "Reference No.",
        reference_no_placeholder: "Enter Reference No.",
        priority_header: "Priority",
        priority_placeholder: "Select Priority",
        salesperson_header: "Salesperson",
        salesperson_placeholder: "Select Salesperson",
        source_header: "Source",
        source_placeholder: "Select Source",
        industry_header: "Industry",
        industry_placeholder: "Select Industry",
        department_label: "Department",
        department_placeholder: "Select Department",
        status_header: "Status",
        coupon_code_label: "Coupon Code",
        coupon_code_placeholder: "Enter Coupon Code",
        delivery_commitment_date_label: "Deliver Commitment Date",
        delivery_commitment_date_placeholder: "Enter Deliver Commitment Date",
        expected_shipping_date_label: "Expected Shipping Date",
        expected_shipping_date_placeholder: "Enter Expected Shipping Date",
        rate_label: "Rate",
        rate_placeholder: "Enter Rate",
        available_label: "Available",
        onhand_label: "On Hand",
        reserved_label: "Reserved",
        discount_item_label: "Discount Item",
        discount_item_placeholder: "Select Discount Item",
        discount_rate_label: "Discount Rate",
        gross_amount_label: "Gross Amount",
        net_amount_label: "Net Amount",
        tax_amount_label: "Tax Amount",
        discount_amount_label: "Discount Amount",
        total_amount_label: "Total Amount",
        tax_template_label: "Tax Template",
        tax_template_placeholder: "Select Tax Template",
        follow_up_type_label: "Follow Up Type",
        follow_up_type_placeholder: "Select Follow Up Type",
        remind_me_label: "Remind Me",
        remind_me_placeholder: "Select Time",
        date_label: "Date",
        date_placeholder: "Enter Date",
        time_label: "Time",
        time_placeholder: "Enter Time",
        address_type_label: "Address Type",
        address_type_placeholder: "Select Address Type",
        addressee_label: "Addressee",
        addressee_placeholder: "Enter Addressee",
        address_label: "Address",
        address_placeholder: "Enter Address",
        zip_code_label: "Zip Code",
        zip_code_placeholder: "Enter Zip Code",
        city_label: "City",
        city_placeholder: "Select City",
        state_label: "State",
        state_placeholder: "Select State",
        country_label: "Country",
        country_placeholder: "Select Country",
        summary_label: "Summary",
        view_attachment_label: "Attached file",
      },
      table: {
        id_header: "ID",
        company_header: "Company",
        expected_revenue_header: "Expected Revenue",
        stage_header: "Stage",
        closing_date_header: "Closing Date",
        contact_name_header: "Contact Name",
        salesperson_header: "Salesperson",
        item_header: "Items",
        item_placeholder: "Select Item",
        item_category_header: "Item Categories",
        item_category_placeholder: "Enter Item Category",
        description_header: "Description",
        description_placeholder: "Enter Description",
        min_quantity_header: "Minimum Quantity",
        min_quantity_placeholder: "Enter Minimum Quantity",
        location_header: "Location",
        location_placeholder: "Select Location",
        discount_header: "Discount Value",
        discount_placeholder: "Enter Discount Value",
        customer_header: "Customer",
        customer_placeholder: "Select Customer",
        contact_header: "Contact",
        contact_placeholder: "Select Contact",
        customer_segment_header: "Customer Segment",
        customer_segment_placeholder: "Select Customer Segment",
        discount_percentage_header: "Discount Percentage",
        discount_percentage_placeholder: "Enter Discount Percentage",
        max_amount_header: "Maximum Amount",
        narration_header: "Narration",
        order_total_header: "Order Total",
        entries_header: "Entries",
        uom_header: "UoM",
        delivery_commitment_label: "Delivery Commitment Date",
        expected_Shipping_date_label: "Expected Shipping Date",
        quantity_label: "Quantity",
        available_label: "Available",
        onhand_label: "On Hand",
        reserved_label: "Reserved",
        rate_label: "Rate",
        gross_amount_label: "Gross Amount",
        discount_item_label: "Discounted Item",
        discount_rate_label: "Discount Rate",
        discount_amount_label: "Discounted Amount",
        net_amount_label: "Net Amount",
        tax_template_label: "Tax Template",
        tax_rate_label: "Tax Rate",
        tax_amount_label: "Tax Amount",
        total_amount_label: "Total Amount",
        department_label: "Department",
        narration: "Narration",
        promotionAmount_header: "Promotion Amount",

        name_header: "Name",
        email_header: "Email",

        followUpType_header: "Follow Up Type",
        followUpDateTime_header: "Follow Up Date & Time",
        followUpRemindMe_header: "Remind Me",
        followUpDescription_header: "Description",

        addressType_header: "Address Type",
        addressee_header: "Addressee",
        defaultShippingAddress_header: "Default shipping address",
        defaultBillingAddress_header: "Default Billing address",
        countryCode_header: "Country Code",
        contactNumber_header: "Contact Number",
        addrressOne_header: "Address 1",
        addressTwo_header: "Address 2",
        addressThree_header: "Address 3",
        zipCode_header: "Zip Code",
        city_header: "City",
        state_header: "State",
        country_header: "Country",
        summary_header: "Summary",
      },
    },
    leads: {
      title: "Leads",
      add_label: "Add New Lead",
      edit_label: "Edit Lead",
      cancel: "Cancel",
      save: "Save",
      no_log: "No Logs added yet",
      view_more: "View More",
      add_new_log: "Add New Log",
      view_in_calender: "View In Calendar",
      entries: "Entries",
      contacts: "Contacts",
      msg: {
        save: "Lead saved successfully.",
        delete: "Lead deleted successfully.",
        error: "An error occurred while processing the lead.",
        saveDraftErr: 'Please fill atleast one field',
        communicationLogMsg: "Something went wrong on communication log saving.",
        shipping_error: "Another address is already marked as the default shipping address. Please uncheck that before selecting this one",
        another_address: "Another address is already marked as the default billing address. Please uncheck that before selecting this one",
        update_address: "Something went wrong in address",
        contact_error: "Something went wrong in contact save",
        required_error: "Please fill all the required fields.",
        contact_req_error: "Please add atleast one contact",
        delete_description: "Are you sure you want to delete follow up ?",
      },
      tabs: {
        basicDetails: "Basic Details",
        address: "Address",
        contact: "Contact",
      },
      sections: {
        generalDetail: "General Detail",
        address: "Address",
        contact: "Contact",
        followUp: "Follow Up",
        ownerDetails: "Lead Owner Details",
        classification: "Classification",
        attachments: "Attachments",
      },
      button: {
        apply_promotion: "Apply Promotions",
        apply: "Apply",
      },
      fields: {
        type_lable: "Type",
        id_label: "ID",
        id_placeholder: "Enter ID",
        firstName_label: "First Name",
        firstName_placeholder: "Enter First Name",
        middleName_label: "Middle Name",
        middleName_placeholder: "Enter Middle Name",
        lastName_label: "Last Name",
        lastName_placeholder: "Enter Last Name",
        name_label: "Name",
        type_label: 'Type',
        name_placeholder: "Enter Lead Name",
        lead_company_label: "Lead Company",
        company_label: "Company",
        company_placeholder: "Enter Company Name",
        phone_label: "Phone No.",
        phone_placeholder: "Enter Phone Number",
        email_label: "Email ID",
        email_placeholder: "Enter Email ID",
        website_label: "Website",
        website_placeholder: "Enter Website URL",
        status_label: "Status",
        status_placeholder: "Select Status",
        conversion_probability_label: "Conversion Probability",
        reference_number_label: "Reference No.",
        reference_number_placeholder: "Enter Reference No.",
        leadSource_label: "Source",
        leadSource_placeholder: "Select Source",
        salesPerson_label: "Salesperson",
        salesPerson_placeholder: "Select Salesperson",
        phoneNumber_label: "Phone Number",
        phoneNumber_placeholder: "Enter Phone Number",
        industry_label: "Industry",
        industry_placeholder: "Select Industry",
        currency_label: "Currency",
        currency_placeholder: "Select Currency",
        priority_label: "Priority",
        priority_placeholder: "Select Priority",
        narration_label: "Narration",
        narration_placeholder: "Enter Notes or Narration",
        location_label: "Location",
        location_placeholder: "Select Location",
        department_label: "Department",
        department_placeholder: "Select Department",
        annualRevenue_label: "Annual Revenue",
        annualRevenue_placeholder: "Enter Annual Revenue",
        view_attachment_label: "Attached file",
        customer_label: "Customer",
        lead_status_label: "Lead Status",
        followup_calender_view: "Follow Ups Calendar View",
        add_follow_up: "Add Follow Up",
        date: "Date",
        enter_date: "Enter Date",
        time: "Time",
        enter_time: "Enter Time",
        description: "Description",
        enter_description: "Enter Description",
        add_new_log: "Add New Communication Log",
        log_title: "Title",
        communication_type: "Communication Type",
        agenda: "Agenda",
        venue: "Venue",
        enter_log_title: "Enter Title",
        select_communication_type: "Select Communication Type",
        enter_agenda: "Enter Agenda",
        enter_venue: "Enter Venue",
      },
      table: {
        id_header: "ID",
        name_header: "Name",
        company_header: "Company",
        status_header: "Status",
        lead_status_header: "Lead Status",
        owner_header: "Owner",
        source_header: "Source",

        followUpType_header: "Follow Up Type",
        selectFollowUpType_header: "Select Follow Up Type",
        followUpDateTime_header: "Follow Up Date & Time",
        remindMe_header: "Remind Me",
        selectTime_header: "Select Time",
        description_header: "Description",
        addFollowUpDateTime_header: "Add Follow Up Date & Time",
        addressType_header: "Address Type",
        addressee_header: "Addressee",
        defaultShippingAddress_header: "Default shipping address",
        defaultBillingAddress_header: "Default Billing address",
        countryCode_header: "Country Code",
        contactNumber_header: "Contact Number",
        addrressOne_header: "Address 1",
        addressTwo_header: "Address 2",
        addressThree_header: "Address 3",
        zipCode_header: "Zip Code",
        city_header: "City",
        state_header: "State",
        country_header: "Country",
        summary_header: "Summary",

        email_header: "Email",
      },
    },
    demand: {
      title: "Demand Planning",
      fields: {
        type_label: "Type",
        type_placeholder: "Select Type",
        search_type_placeholder: "Search Type",
        subsidiary_label: "Subsidiary",
        subsidiary_placeholder: "Select Subsidiary",
        search_subsidiary_placeholder: "Search Subsidiary",
        location_label: "Location",
        location_placeholder: "Select Location",
        search_location_placeholder: "Search Location",
        item_label: "Item",
        item_placeholder: "Select Item",
        search_item_placeholder: "Search Item",
        asOfDate_label: "As of Date",
        asOfDate_placeholder: "Select Date",
        showBelowReorderPoint_label: "Show Below Reorder Point",
        procurement_label: "Procurement",
        production_label: "Production",
        demand_label: "Demand",
        material_label: "Material",
        purchase_request_label: "Purchase Request"
      },
      table: {
        item_header: "Item",
        description_header: "Description",
        units_header: "Units",
        demand_header: "Demand",
        onHand_header: "On Hand",
        onOrder_header: "On Order",
        available_header: "Available",
        committed_header: "Committed",
        pr_header: "PR",
        required_header: "Required",
        date: "Date",
        transaction: "Transaction",
        location: "Location",
        quantity: "Quantity",
        raw_material: "Raw Material",
        customer: "Customer",
        bill_of_material_header: "Bill of Material",
        material_list_header: "Material List",
        summery_label: "Summery",
      },
      summary: {
        total_label: "Total",
        viewDetails_label: "View Details",
      },
      actions: {
        filter_label: "Filter",
        refresh_label: "Refresh",
        clearAll_label: "Clear All",
        detailed_view_label: "Detail View for All Items"
      },
    },
    orders: {
      quotation: {
        title: 'Quotations',
        replacementTitle: "Replacement Quotations",
        detailsTitle: 'Quotation Details',
        revisions: 'Revisions',
        addLabel: 'Add New Quotation',
        addReplacementLabel: 'Add New Replacement Quotation',
        editLabel: 'ID :id',
        table: {
          id: 'ID',
          date: 'Date',
          customer: 'Customer',
          status: 'Status',
          salesPerson: 'Salesperson',

          item: 'Item',
          uom: 'UOM',
          description: 'Description',
          deliveryCommitmentDate: 'Delivery Commitment Date',
          expectedShippingDate: 'Expected Shipping Date',
          quantity: 'Quantity',
          priceList: 'Price List',
          rate: 'Rate',
          replacementCost: 'Replacement Cost',
          available: 'Available',
          onHand: 'On Hand',
          reserved: 'Reserved',
          discountedItem: 'Discounted Item',
          discountRate: 'Discount Rate',
          grossAmount: 'Gross Amount',
          taxAmount: 'Tax Amount',
          promotionAmount: "Promotion Amount",
          discountAmount: 'Discount Amount',
          netAmount: 'Net Amount',
          totalAmount: 'Total Amount',
          taxTemplate: 'Tax Template',
          taxRate: 'Tax Rate',
          location: 'Location',
          department: 'Department',
          narration: 'Narration',

          couponCode: 'Coupon Code',
          account: 'Account',
          type: 'Type',
          promotionAmountOrPercent: 'Promotion Amount / %',
        },
        fields: {
          id_label: "ID",
          id_placeholder: "Enter ID",
          date_label: "Date",
          date_placeholder: "Select Date",
          customer_label: "Customer",
          customer_placeholder: "Select Customer",
          paymentTerms_label: "Payment Terms",
          paymentTerms_placeholder: "Select Payment Terms",
          company_label: "Company",
          company_placeholder: "Select Company",
          expirationDate_label: "Expiration Date",
          expirationDate_placeholder: "Select Date",
          deliveryCommitment_label: "Delivery Commitment Date",
          deliveryCommitment_placeholder: "Select Date",
          currency_label: "Currency",
          currency_placeholder: "Select Currency",
          exchangeRate_label: "Exchange Rate",
          exchangeRate_placeholder: "Enter Exchange Rate",
          salesPerson_label: "Salesperson",
          salesPerson_placeholder: "Select Salesperson",
          referenceNumber_label: "Reference Number",
          referenceNumber_placeholder: "Enter Reference Number	",
          status_label: "Status",
          status_placeholder: "Select Status",
          version_label: "Version Number",
          version_placeholder: "Version Number",
          termsCondition_label: "Terms & Conditions",
          termsCondition_placeholder: "Select Terms & Conditions",
          narration_label: "Narration",
          narration_placeholder: "Write Narration",

          startDateTime_label: 'Start Date & Time',
          startDateTime_plcaeholder: 'Select Start Date & Time',
          endDateTime_label: 'End Date & Time',
          endDateTime_plcaeholder: 'Select End Date & Time',
          totalPeriod_label: 'Total Period',
          totalPeriod_plcaeholder: '-',

          billingCycle_label: 'Billing Cycle',
          billingCycle_plcaeholder: 'Select Billing Cycle',
          lastInvoiceDate_label: 'Last Invoice Date',
          lastInvoiceDate_plcaeholder: 'Select Date',
          nextInvoiceDate_label: 'Next Invoice Date',
          nextInvoiceDate_plcaeholder: 'Select Date',

          // Address
          shippingAddress_label: 'Shipping Address',
          shippingAddress_placeholder: 'Select Shipping Address',
          contactPerson_label: 'Contact Person',
          contactPerson_placeholder: 'Select Contact Person',
          billingAddress_label: 'Billing Address',
          billingAddress_placeholder: 'Select Billing Address',
          placeOfSupply_label: 'Place of Supply',
          placeOfSupply_placeholder: 'Select Place of Supply',

          // Iterm modal
          item_label: 'Item',
          item_placeholder: 'Select Item',
          uom_label: 'UOM',
          uom_placeholder: 'Select UOM',
          description_label: 'Description',
          description_placeholder: 'Enter Description',
          deliveryCommitmentDate_label: 'Delivery Commitment Date',
          deliveryCommitmentDate_placeholder: 'Enter Delivery Commitment Date',
          expectedShippingDate_label: 'Expected Shipping Date',
          expectedShippingDate_placeholder: 'Enter Expected Shipping Date',
          quantity_label: 'Quantity',
          quantity_placeholder: 'Enter Quantity',
          priceList_label: 'Price List',
          priceList_placeholder: 'Select Price List',
          rate_label: 'Rate',
          available_label: 'Available',
          replacementCost_label: 'Replacement Cost',
          available_placeholder: 'Enter Available Quantity',
          onHand_label: 'On Hand',
          onHand_placeholder: 'Enter On Hand Quantity',
          reserved_label: 'Reserved',
          reserved_placeholder: 'Enter Reserved Quantity',
          discountItem_label: 'Discount Item',
          discountItem_placeholder: 'Select Discount Item',
          discountRate_label: 'Discount Rate',
          discountRate_placeholder: 'Enter Discount Rate',
          grossAmount_label: 'Gross Amount',
          grossAmount_placeholder: 'Enter Gross Amount',
          taxAmount_label: 'Tax Amount',
          taxAmount_placeholder: 'Enter Tax Amount',
          discountAmount_label: 'Discount Amount',
          discountAmount_placeholder: 'Enter Discount Amount',
          netAmount_label: 'Net Amount',
          netAmount_placeholder: 'Enter Net Amount',
          totalAmount_label: 'Total Amount',
          totalAmount_placeholder: 'Enter Total Amount',
          taxTemplate_label: 'Tax Template',
          taxTemplate_placeholder: 'Select Tax Template',
          location_label: 'Location',
          location_placeholder: 'Select Location',
          department_label: 'Department',
          department_placeholder: 'Select Department',

          postingTime_label: "Posting Time",
          postingTime_placeholder: "HH:MM PM",
          opportunity_label: "Opportunity",
          opportunity_placeholder: "Enter Opportunity",
          contact_person_label: "Contact Person",
          recurring_label: "Recurring",
          recurring_placeholder: "Select Recurring",
          until_date_label: "Untill Date",

          upload_label: "Upload",
          additionalDiscountOn_label: "Apply Additional Discount On",
          additionalDiscountOn_placeholder: "Additional Discount",
          additionalDiscountPercent_label: "Additional Discount Percentage",
          additionalDiscountPercent_placeholder: "Enter Additional dicount in %",
          additionalDiscountAmount_label: "Additional Discount Amount",
          additionalDiscountAmount_placeholder: "Enter Additional Discount Amount",
          additionalDiscount_placeholder: "Additional Discount",
          roundOff_label: "Round off",
          roundOff_placeholder: "Select round off",
          roundOff_amount: "Round Off Amount",
          cashOrNonTrade_label: "Is Cash or Non Trade Discount",
          shippingRule_label: "Shipping Rule",
          shippingRule_placeholder: "Select Shipping Rule",
          shippingCost_label: "Shipping Cost",
          shippingCost_placeholder: "Enter Shipping Cost",
          handlingCost_label: "Handling Cost",
          handlingCost_placeholder: "Enter Handling Cost",
          handlingTaxTemplate_label: "Handling Tax Template",
          handlingTaxTemplate_placeholder: "Select Handling Tax Template",
          shippingTaxTemplate_label: "Shipping Tax Template",
          shippingTaxTemplate_placeholder: "Select Shipping Tax Template",
          handlingTaxAmount_label: "Handling Tax Amount",
          handlingTaxAmount_placeholder: "Select Handling Tax Amount",
          shippingTaxAmount_label: "Shipping Tax Amount",
          shippingTaxAmount_placeholder: "Enter Shipping Tax Amount",
          incoterm_label: "Incoterm",
          incoterm_placeholder: "Select Incoterm",
          supplierAddress_label: "Supplier Address",
          attachment_label: "Attached files",
          quote_percentage_label: "Quote Percentage (%)",
          apply_quote_percentage: "Apply Quote Percentage"
        },
        sections: {
          basicDetails: 'Basic Details',
          rentalPeriod: 'Rental Period',
          billing: 'Billing',
          items: 'Items',
          discounts: 'Discounts',
          classification: 'Classification',
          attachment: 'Attachment',
          amount: 'Amount',
          tax: 'Tax',
          shippingAddress: 'Shipping Address',
          billingAddress: 'Billing Address',
        },
        msg: {
          delete: 'Quotation :id has been deleted successfully',
          save: 'Quotation has been saved successfully',
          update: 'Quotation :id has been updated successfully'
        },
        tabs: {
          basicDetails: 'Basic Details',
          addressAndContact: 'Address & Contact',
          shipping: 'Shipping',
          promotions: 'Promotions'
        }
      },
      rentalOrder: {
        title: 'Rental Orders',
        replacementTitle: 'Replacement Orders',
        addLabel: 'Add Rental Order',
        addReplacementLabel: 'Add Replacement Order',
        editLabel: 'ID :id',
        deliveryOrder: {
          title: 'Delivery Orders',
          addLabel: 'Add Delivery Order',
        },
        grn: {
          title: 'GRNs',
          breadCrumbTitle: 'Goods Receipt Note',
          addLabel: 'Add New',
          editLabel: 'Edit Goods Receipt Note',
        },
        invoice: {
          title: 'Invoices',
          table: {
            id: 'ID',
            paymentStatus: 'Payment Status',
            status: 'Status',
            totalAmount: 'Total Amount',
            dueDate: 'Due Date',
          }
        },
        table: {
          id: 'ID',
          date: 'Date',
          deliveryDate: 'Delivery Date',
          customer: 'Customer',
          status: 'Order Status',
          invoiceStatus: 'Invoice Status',
          deliveryStatus: 'Delivery Status',
          salesPerson: 'Salesperson',
          company: 'Compnay',
          item: 'Item',
          uom: 'UOM',
          description: 'Description',
          deliveryCommitmentDate: 'Delivery Commitment Date',
          expectedShippingDate: 'Expected Shipping Date',
          quantity: 'Quantity',
          priceList: 'Price List',
          rate: 'Rate',
          replacementCost: 'Replacement Cost',
          available: 'Available',
          onHand: 'On Hand',
          reserved: 'Reserved',
          discountedItem: 'Discounted Item',
          discountRate: 'Discount Rate',
          grossAmount: 'Gross Amount',
          taxAmount: 'Tax Amount',
          discountAmount: 'Discount Amount',
          netAmount: 'Net Amount',
          totalAmount: 'Total Amount',
          taxTemplate: 'Tax Template',
          taxRate: 'Tax Rate',
          location: 'Location',
          department: 'Department',
          narration: 'Narration',
          rentalOrderLine: 'Rental Order Line',
          remaining: 'Remaining',
          couponCode: 'Coupon Code',
          account: 'Account',
          type: 'Type',
          promotionAmountOrPercent: 'Promotion Amount / %',
          packageName: 'Packaging Name',
          dimentions: 'Dimensions',
          weight: 'Weight',
          packageDetails: 'Package Details',
          recieptDate: 'Reciept Date',
          refNo: 'Ref. No'
        },
        fields: {
          id_label: "ID",
          id_placeholder: "Enter ID",
          date_label: "Date",
          date_placeholder: "Select Date",
          rentalOrder_label: "Rental Order",
          rentalOrder_placeholder: "Rental Order",
          customer_label: "Customer",
          customer_placeholder: "Select Customer",
          paymentTerms_label: "Payment Terms",
          paymentTerms_placeholder: "Select Payment Terms",
          company_label: "Company",
          company_placeholder: "Select Company",
          expirationDate_label: "Expiration Date",
          expirationDate_placeholder: "Select Date",
          deliveryCommitment_label: "Delivery Commitment Date",
          deliveryCommitment_placeholder: "Select Date",
          currency_label: "Currency",
          currency_placeholder: "Select Currency",
          exchangeRate_label: "Exchange Rate",
          exchangeRate_placeholder: "Enter Exchange Rate",
          salesPerson_label: "Salesperson",
          salesPerson_placeholder: "Select Salesperson",
          referenceNumber_label: "PO Number",
          referenceNumber_placeholder: "Enter PO Number",
          status_label: "Status",
          status_placeholder: "Select Status",
          version_label: "Version Number",
          version_placeholder: "Version Number",
          termsCondition_label: "Terms & Conditions",
          termsCondition_placeholder: "Select Terms & Conditions",
          narration_label: "Narration",
          narration_placeholder: "Write Narration",
          poDate_label: "PO Date",
          poDate_placeholder: "Select Date",
          project_label: "Project",
          project_placeholder: "Enter Project Name",
          receivedBy_label: "Received By",
          receivedBy_placeholder: "Enter Name",
          receipt_date_label: 'Receipt Date',
          transportedBy_label: "Trasported By",
          transportedBy_placeholder: "Enter Transportation Company Name",
          driver_label: "Driver",
          driver_placeholder: "Enter Driver Name",
          transportationId_label: "ID",
          transportationId_placeholder: "Enter ID Number",
          vehicleNumber_label: "Vehicle Number",
          vehicleNumber_placeholder: "Enter Vehicle Number",

          startDateTime_label: 'Start Date & Time',
          startDateTime_plcaeholder: 'Select Start Date & Time',
          endDateTime_label: 'End Date & Time',
          endDateTime_plcaeholder: 'Select End Date & Time',
          totalPeriod_label: 'Total Period',
          totalPeriod_plcaeholder: '-',
          billing_type_label: 'Billing Type',
          billingCycle_label: 'Billing Cycle',
          billingCycle_plcaeholder: 'Select Billing Cycle',
          lastInvoiceDate_label: 'Last Invoice Date',
          lastInvoiceDate_plcaeholder: 'Select Date',
          nextInvoiceDate_label: 'Next Invoice Date',
          nextInvoiceDate_plcaeholder: 'Select Date',
          goodReceiptNote_label: 'Goods Receipt No.',
          delivery_note_label: 'Delivery Note',
          // Address
          shippingAddress_label: 'Shipping Address',
          shippingAddress_placeholder: 'Select Shipping Address',
          contactPerson_label: 'Contact Person',
          contactPerson_placeholder: 'Select Contact Person',
          billingAddress_label: 'Billing Address',
          billingAddress_placeholder: 'Select Billing Address',
          placeOfSupply_label: 'Place of Supply',
          placeOfSupply_placeholder: 'Select Place of Supply',

          // Iterm modal
          item_label: 'Item',
          item_placeholder: 'Select Item',
          rentalOrderLine: "Rental Order Line",
          enter_line: "Enter Rental Order Line",
          quantity: 'Quantity',
          enter_quantity: 'Enter Quantity',
          uom_label: 'UOM',
          uom_placeholder: 'Select UOM',
          description_label: 'Description',
          remaining: 'Remaining',
          enter_remaining: 'Enter Remaining',
          totalAmount: 'Total Amount',
          description_placeholder: 'Enter Description',
          deliveryDate_label: 'Delivery Date',
          deliveryDate_placeholder: 'Enter Delivery Date',
          deliveryCommitmentDate_label: 'Delivery Commitment Date',
          deliveryCommitmentDate_placeholder: 'Enter Delivery Commitment Date',
          expectedShippingDate_label: 'Expected Shipping Date',
          expectedShippingDate_placeholder: 'Enter Expected Shipping Date',
          quantity_label: 'Quantity',
          quantity_placeholder: 'Enter Quantity',
          priceList_label: 'Price List',
          priceList_placeholder: 'Select Price List',
          available_label: 'Available',
          rate_label: 'Rate',
          available_placeholder: 'Enter Available Quantity',
          onHand_label: 'On Hand',
          onHand_placeholder: 'Enter On Hand Quantity',
          reserved_label: 'Reserved',
          reserved_placeholder: 'Enter Reserved Quantity',
          discountItem_label: 'Discount Item',
          discountItem_placeholder: 'Select Discount Item',
          discountRate_label: 'Discount Rate',
          discountRate_placeholder: 'Enter Discount Rate',
          grossAmount_label: 'Gross Amount',
          grossAmount_placeholder: 'Enter Gross Amount',
          taxAmount_label: 'Tax Amount',
          taxAmount_placeholder: 'Enter Tax Amount',
          discountAmount_label: 'Discount Amount',
          discountAmount_placeholder: 'Enter Discount Amount',
          netAmount_label: 'Net Amount',
          netAmount_placeholder: 'Enter Net Amount',
          totalAmount_label: 'Total Amount',
          totalAmount_placeholder: 'Enter Total Amount',
          taxTemplate_label: 'Tax Template',
          taxTemplate_placeholder: 'Select Tax Template',
          location_label: 'Location',
          location_placeholder: 'Select Location',
          department_label: 'Department',
          department_placeholder: 'Select Department',

          postingTime_label: "Posting Time",
          postingTime_placeholder: "HH:MM PM",
          opportunity_label: "Opportunity",
          opportunity_placeholder: "Enter Opportunity",
          contact_person_label: "Contact Person",
          recurring_label: "Recurring",
          recurring_placeholder: "Select Recurring",
          until_date_label: "Untill Date",

          upload_label: "Upload",
          additionalDiscountOn_label: "Apply Additional Discount On",
          additionalDiscountOn_placeholder: "Additional Discount",
          additionalDiscountPercent_label: "Additional Discount Percentage",
          additionalDiscountPercent_placeholder: "Enter Additional dicount in %",
          additionalDiscountAmount_label: "Additional Discount Amount",
          additionalDiscountAmount_placeholder: "Enter Additional Discount Amount",
          additionalDiscount_placeholder: "Additional Discount",
          roundOff_label: "Round off",
          roundOff_placeholder: "Select round off",
          roundOff_amount: "Round Off Amount",
          cashOrNonTrade_label: "Is Cash or Non Trade Discount",
          shippingDate_label: "Expected Shipping Date",
          shippingDate_placeholder: "Select Date",
          shippingRule_label: "Shipping Rule",
          shippingRule_placeholder: "Select Shipping Rule",
          shippingCost_label: "Shipping Cost",
          shippingCost_placeholder: "Enter Shipping Cost",
          handlingCost_label: "Handling Cost",
          handlingCost_placeholder: "Enter Handling Cost",
          handlingTaxTemplate_label: "Handling Tax Template",
          handlingTaxTemplate_placeholder: "Select Handling Tax Template",
          shippingTaxTemplate_label: "Shipping Tax Template",
          shippingTaxTemplate_placeholder: "Select Shipping Tax Template",
          handlingTaxAmount_label: "Handling Tax Amount",
          handlingTaxAmount_placeholder: "Select Handling Tax Amount",
          shippingTaxAmount_label: "Shipping Tax Amount",
          shippingTaxAmount_placeholder: "Enter Shipping Tax Amount",
          incoterm_label: "Incoterm",
          incoterm_placeholder: "Select Incoterm",
          supplierAddress_label: "Supplier Address",
          attachment_label: "Attached files",
        },
        sections: {
          basicDetails: 'Basic Details',
          rentalPeriod: 'Rental Period',
          billing: 'Billing',
          items: 'Items',
          discounts: 'Discounts',
          delivery: 'Delivery',
          classification: 'Classification',
          attachment: 'Attachment',
          amount: 'Amount',
          tax: 'Tax',
          shippingAddress: 'Shipping Address',
          billingAddress: 'Billing Address',
          transportation: 'Transportation',
          rentalDetails: 'Rental Order Details'
        },
        msg: {
          delete: 'Order :id has been deleted successfully',
          grnDelete: 'GRN :id has been deleted successfully',
          save: 'Rental Order has been saved successfully',
          update: 'Rental Order :id has been updated successfully',
          requestApproved: 'Request has been approved',
          requestRejected: 'Request has been rejected',
          requestSubmitted: 'Request has been submitted',
          deliveryOrderSaved: 'Delivery Order has been saved successfully',
        },
        tabs: {
          basicDetails: 'Basic Details',
          addressAndContact: 'Address & Contact',
          shipping: 'Shipping',
          promotions: 'Promotions',
          packages: 'Packages'
        }
      }
    },
    invoice: {
      title: "Invoice Rental Orders",
      jobTitle: 'Jobs',
      routes: {
        job: 'Job'
      },
      filters: {
        date: 'Date',
        date_placeholder: 'Select Date',
        invoice_date: 'Invoice Date',
        invoice_date_placeholder: 'Select Invoice Date',
        customer_label: "Customers",
        customer_placeholder: 'Search Customer',
        subsidiary_label: "Subsidiary",
        subsidiary_placeholder: 'Search Subsidiary',
        next_invoice_date_label: "Next Invoice Date"
      },
      fields: {
        type_label: "Type",
        type_placeholder: "Select Type",
        subsidiary_label: "Subsidiary",
        subsidiary_placeholder: "Select Subsidiary",
        location_label: "Location",
        location_placeholder: "Select Location",
        asOfDate_label: "As of Date",
        asOfDate_placeholder: "Select Date",
        showBelowReorderPoint_label: "Show Below Reorder Point",
        allCustomers_label: "All Customers"
      },
      invoiceDialog: {
        title: 'Select Invoice Date',
        date_label: 'Invoice Date',
        date_placeholder: 'Enter Invoice Date',
        success: 'Invoice Created Successfully',
        invoice_date_msg: "Please select invoice date"
      },
      table: {
        item_header: "Item",
        description_header: "Description",
        units_header: "Units",
        demand_header: "Demand",
        onHand_header: "On Hand",
        onOrder_header: "On Order",
        available_header: "Available",
        committed_header: "Committed",
        pr_header: "PR",
        required_header: "Required",
        date: "Date",
        transaction: "Transaction",
        location: "Location",
        quantity: "Quantity",
        raw_material: "Raw Material",
      },
      summary: {
        total_label: "Total",
        viewDetails_label: "View Details",
      },
      actions: {
        filter_label: "Filter",
        refresh_label: "Refresh",
        clearAll_label: "Clear All",
      },
    },
    crossHire: {
      title: 'Cross Hire',
      request: {
        title: 'Cross Hire Requests',
        addLabel: 'Add New',
        editLabel: 'ID: :id',
        table: {
          id: 'ID',
          date: 'Date',
          rentalOrderId: 'Rental Order ID',
          status: 'Status',

          item: 'Item',
          vendorName: 'Vendor Name',
          uom: 'UOM',
          description: 'Description',
          description_placeholder: 'Enter Description',
          quantity: 'Quantity',
          quantity_placeholder: 'Enter Quantity',
          rate: 'Rate',
          replacementCost: 'Replacement Cost',
          available: 'Available',
          onHand: 'On Hand',
          rentalDurationType: 'Rental Duration Type',
          rentalDurationType_placeholder: 'Select Rental Duration Type',
          discountItem: 'Discount Item',
          discountItem_placeholder: 'Select Discount Item',
          discountRate: 'Discount Rate',

          grossAmount: 'Gross Amount',
          taxAmount: 'Tax Amount',
          discountAmount: 'Discount Amount',
          netAmount: 'Net Amount',
          totalAmount: 'Total Amount',
          taxTemplate: 'Tax Template',
          taxTemplate_placeholder: 'Select Tax Template',
          amount: 'Amount',
          taxRate: 'Tax Rate',
          tax: "Tax",
          location: 'Location',
          department: 'Department',
          narration: 'Narration',
          tax_code: "Tax Code",
          tax_rate: "Tax Rate",
          actual_amount: "Actual Amount",
          add_item_label: "Add Item",
          package_label: "Package",
          item_placeholder: "Select Item",
          uom_placeholder: "Select UOM",
          on_hand: "On Hand",
          replacement_cost: "Replacement Cost",
          discount_item: "Discount Item",
          discount_item_placeholder: "Select Discount Item",
          discount_rate: "Discount Rate (%)",
          gross_amount: "Gross Amount",
          tax_amount: "Tax Amount",
          discount_amount: "Discount Amount",
          net_amount: "Net Amount",
          total_amount: "Total Amount",
          vendor_name_header: "Vendor Name",
          vendor_name_placeholder: 'Add Vendor Name',
          classification: 'Classification',
        },
        msg: {
          add: 'Request added successfully',
          update: 'Request updated successfully',
          delete: 'Request deleted successfully',
          requestSubmitted: 'Request has been submitted for approval',
          requestApproved: 'Request has been approved',
          requestRejected: 'Request has been rejected',
          requiredError: "Please fill atleast one field",
          allRequiredError: "Please fill all the required fields",
        },
        sections: {
          basicDetails: 'Basic Details',
          items: 'Items',
          classification: 'Classification',
          attachment: 'Attachment'
        },
        fields: {
          id_label: 'ID',
          id_placeholder: 'Enter ID',
          date_label: 'Date',
          date_placeholder: 'Select Date',
          rentalOrderId_label: 'Rental Order ID',
          rentalOrderId_placeholder: 'Enter Rental Order ID',
          company_label: 'Company',
          company_placeholder: 'Select Company',
          purchaseRepresentative_label: 'Purchase Representative',
          purchaseRepresentative_placeholder: 'Select Purchase Representative',
          vendor_label: 'Vendor',
          vendor_placeholder: 'Select Vendor',
          currency_label: 'Currency',
          currency_placeholder: 'Select Currency',
          narration_label: 'Narration',
          narration_placeholder: 'Enter Narration',
          items_label: 'Items',
          item_label: 'Item',
          vendorItemName_label: 'Vendor Item Name',
          uom_label: 'UoM',
          classification_label: 'Classification',
          location_label: 'Location',
          location_placeholder: 'Select Location',
          department_label: 'Department',
          attachment_label: 'Attachment',
          upload_label: 'Upload'
        }
      },
      process: {
        title: "Process Cross Hire",
        fields: {
          type_label: "Type",
          type_placeholder: "Select Type",
          subsidiary_label: "Subsidiary",
          subsidiary_placeholder: "Select Subsidiary",
          search_subsidiary_placeholder: "Search Subsidiary",
          location_label: "Location",
          location_placeholder: "Select Location",
          search_location_placeholder: "Search Location",
          item_label: "Item",
          item_placeholder: "Select Item",
          asOfDate_label: "As of Date",
          asOfDate_placeholder: "Select Date",
          showBelowReorderPoint_label: "Show Below Reorder Point",
        },
        table: {
          item_header: "Item",
          rental_order_id_header: "Rental Order ID",
          request_quantity_header: "Request Quantity",
          onHand_header: "On Hand",
          available_header: "Available",
          order_quantity_header: "Order Quantity",
          committed_header: "Committed",
          pr_header: "PR",
          required_header: "Required",
          date: "Date",
          transaction: "Transaction",
          location: "Location",
          quantity: "Quantity",
          raw_material: "Raw Material",
          cross_hire_qty: 'Cross Hire Quantity',
          vendor: 'Vendor',
          cross_hire_type: 'Cross Hire Type',
          currency: 'Currency',
          unit_rate: 'Unit Rate',
          purchase_uom: 'Purchase UOM',
          amount: 'Amount',
          narration: 'Narration',
        },
        summary: {
          total_label: "Total",
          viewDetails_label: "View Details",
        },
        msg: {
          success: 'Cross Hire key created successfully',
          allRequiredError: "Please fill all the required fields",
        },
        actions: {
          filter_label: "Filter",
          refresh_label: "Refresh",
          clearAll_label: "Clear All",
        },
      },
      orders: {
        title: 'Orders',
        detailsTitle: 'Orders Details',
        revisions: 'Revisions',
        addLabel: 'Add New Order',
        editLabel: 'ID :id',
        grnLabel: 'GRN',
        billLabel: 'Bill',
        receiveLabel: 'Receive',
        returnLabel: 'Returns',
        deliveriesLabel: 'Deliveries',
        printGRN: 'Print GRN',
        printLabel: 'Print Label',
        markShippedLabel: 'Mark Shipped',
        packagingLabel: 'Packaging',
        packagingDetails: "Packaging Details",
        table: {
          id: 'ID',
          hire_order_number: 'Hire Order No.',
          date: 'Date',
          reference_number: 'Reference No.',
          confirmation_date: 'Confirmation Date',
          vendor: 'Vendor',
          purchaseRepresentative_header: "Purchase Representative",
          company_header: "Company",
          expectedReceipt_header: "Expected Receipt Date",
          totalValue_header: "Total Value",
          status_header: "Status",
          billingStatus_header: "Billing Status",
          receivingStatus_header: "Receiving Status",
          recieptDate: 'Reciept Date',
          refNo: 'Ref. No',
          company: 'Compnay',
          location: 'Location',
        },
        itemsTabs: {
          itemEntries: "Item Entries",
          expensed: "Expenses",
        },
        fields: {
          hire_order_number_label: "Hire Order No.",
          hire_order_number_placeholder: "Enter Hire Order No.",
          date_label: "Date",
          date_placeholder: "Select Date",
          rental_order_id_label: "Rental Order ID",
          rental_order_id_placeholder: "Enter Rental Order ID",
          supplier_label: "Supplier",
          supplier_placeholder: "Select Supplier",
          cross_hire_type_label: "Cross Hire Type",
          cross_hire_type_placeholder: "Select Cross Hire Type",
          company_label: "Company",
          company_placeholder: "Select Company",
          location_label: 'Location',
          location_placeholder: 'Select Location',
          confirmation_date_label: "Confirmation Date",
          confirmation_date_placeholder: "Select Confirmation Date",
          expected_receipt_date_label: "Expected Receipt Date",
          expected_receipt_date_placeholder: "Select Expected Receipt Date",
          terms_and_conditions_label: "Terms & Conditions",
          terms_and_conditions_placeholder: "Select Terms & Conditions",
          agreement_label: "Agreement",
          agreement_placeholder: "Select Agreement",
          currency_label: "Currency",
          currency_placeholder: "Select Currency",
          exchange_rate_label: "Exchange Rate",
          exchange_rate_placeholder: "Enter Exchange Rate",
          payment_terms_label: "Payment Terms",
          payment_terms_placeholder: "Select Payment Terms",
          purchase_representive_label: "Purchase Representative",
          purchase_representive_placeholder: "Select Purchase Representative",
          referenceNumber_label: "Reference Number",
          referenceNumber_placeholder: "Enter Reference Number",
          incoterm_label: "Incoterm",
          incoterm_placeholder: "Select Incoterm",
          narration_label: "Narration",
          narration_placeholder: "Enter Narration",
          startDateTime_label: "Select Start Date & Time",
          startDateTime_placeholder: "Enter Date & Time",
          endDateTime_label: "Select End Date & Time",
          endDateTime_placeholder: "Enter Date & Time",
          totalPeriod_label: "Total Period",
          totalPeriod_placeholder: '-',
          // Address
          shippingAddress_label: 'Shipping Address',
          shippingAddress_placeholder: 'Select Shipping Address',
          contactPerson_label: 'Contact Person',
          contactPerson_placeholder: 'Select Contact Person',
          billingAddress_label: 'Billing Address',
          billingAddress_placeholder: 'Select Billing Address',
          placeOfSupply_label: 'Place of Supply',
          placeOfSupply_placeholder: 'Select Place of Supply',
          supplier_address_label: 'Supplier Address',
          supplier_address_placeholder: 'Select Supplier Address',

          // Iterm modal
          item_label: 'Item',
          item_placeholder: 'Select Item',
          uom_label: 'UOM',
          uom_placeholder: 'Select UOM',
          description_label: 'Description',
          description_placeholder: 'Enter Description',
          deliveryCommitmentDate_label: 'Delivery Commitment Date',
          deliveryCommitmentDate_placeholder: 'Enter Delivery Commitment Date',
          expectedShippingDate_label: 'Expected Shipping Date',
          expectedShippingDate_placeholder: 'Enter Expected Shipping Date',
          quantity_label: 'Quantity',
          quantity_placeholder: 'Enter Quantity',
          priceList_label: 'Price List',
          priceList_placeholder: 'Select Price List',
          available_label: 'Available',
          available_placeholder: 'Enter Available Quantity',
          onHand_label: 'On Hand',
          onHand_placeholder: 'Enter On Hand Quantity',
          reserved_label: 'Reserved',
          reserved_placeholder: 'Enter Reserved Quantity',
          discountItem_label: 'Discount Item',
          discountItem_placeholder: 'Select Discount Item',
          discountRate_label: 'Discount Rate',
          discountRate_placeholder: 'Enter Discount Rate',
          grossAmount_label: 'Gross Amount',
          grossAmount_placeholder: 'Enter Gross Amount',
          taxAmount_label: 'Tax Amount',
          taxAmount_placeholder: 'Enter Tax Amount',
          discountAmount_label: 'Discount Amount',
          discountAmount_placeholder: 'Enter Discount Amount',
          netAmount_label: 'Net Amount',
          netAmount_placeholder: 'Enter Net Amount',
          totalAmount_label: 'Total Amount',
          totalAmount_placeholder: 'Enter Total Amount',
          taxTemplate_label: 'Tax Template',
          taxTemplate_placeholder: 'Select Tax Template',
          department_label: 'Department',
          department_placeholder: 'Select Department',

          postingTime_label: "Posting Time",
          postingTime_placeholder: "HH:MM PM",
          opportunity_label: "Opportunity",
          opportunity_placeholder: "Enter Opportunity",
          contact_person_label: "Contact Person",
          recurring_label: "Recurring",
          recurring_placeholder: "Select Recurring",
          until_date_label: "Untill Date",

          upload_label: "Upload",
          additionalDiscountOn_label: "Apply Additional Discount On",
          additionalDiscountOn_placeholder: "Additional Discount",
          additionalDiscountPercent_label: "Additional Discount Percentage",
          additionalDiscountPercent_placeholder: "Enter Additional dicount in %",
          additionalDiscountAmount_label: "Additional Discount Amount",
          additionalDiscountAmount_placeholder: "Enter Additional Discount Amount",
          additionalDiscount_placeholder: "Additional Discount",
          roundOff_label: "Round off",
          roundOff_placeholder: "Select round off",
          roundOff_amount: "Round Off Amount",
          cashOrNonTrade_label: "Is Cash or Non Trade Discount",
          shippingRule_label: "Shipping Rule",
          shippingRule_placeholder: "Select Shipping Rule",
          shippingCost_label: "Shipping Cost",
          shippingCost_placeholder: "Enter Shipping Cost",
          handlingCost_label: "Handling Cost",
          handlingCost_placeholder: "Enter Handling Cost",
          handlingTaxTemplate_label: "Handling Tax Template",
          handlingTaxTemplate_placeholder: "Select Handling Tax Template",
          shippingTaxTemplate_label: "Shipping Tax Template",
          shippingTaxTemplate_placeholder: "Select Shipping Tax Template",
          handlingTaxAmount_label: "Handling Tax Amount",
          handlingTaxAmount_placeholder: "Select Handling Tax Amount",
          shippingTaxAmount_label: "Shipping Tax Amount",
          shippingTaxAmount_placeholder: "Enter Shipping Tax Amount",
          supplierAddress_label: "Supplier Address",
          attachment_label: "Attached files",

          // grn fields
          id_label: "ID",
          id_placeholder: "Enter ID",
          vendor_label: "Vendor",
          vendor_placeholder: "Select Vendor",
          transportedBy_label: "Trasported By",
          transportedBy_placeholder: "Enter Transportation Company Name",
          driver_label: "Driver",
          driver_placeholder: "Enter Driver Name",
          transportationId_label: "ID",
          transportationId_placeholder: "Enter ID Number",
          vehicleNumber_label: "Vehicle Number",
          vehicleNumber_placeholder: "Enter Vehicle Number",
          receipt_date_label: "Receipt Date",
          receipt_date_placeholder: "Select Receipt Date",
          receivedBy_label: "Received By",
          receivedBy_placeholder: "Enter Name",
          grnNo_label: "Goods Receipt No.",
          grnNo_placeholder: "Goods Receipt No."
        },
        item_table: {
          item_header: "Item",
          item_placeholder: "Select Item",
          landedCost_header: "Is Landed Cost",
          vendor_header: "Vendor Item Name",
          vendor_placeholder: "Enter Vendor Item Name",
          uom_header: "UoM",
          uom_placeholder: "Select UoM",
          quantity_header: "Quantity",
          quantity_placeholder: "Enter Quantity",
          description_header: "Description",
          description_placeholder: "Enter Description",
          rate_header: "Rental Rate",
          rate_placeholder: "Enter Rate",
          rental_duration_type_header: "Rental Duration Type",
          rental_duration_type_placeholder: "Select Rental Duration Type",
          discountItem_header: "Discount Item",
          discountItem_placeholder: "Select Discount Item",
          discountRate_header: "Discount Rate (%)",
          discountRate_placeholder: "Discount Rate",
          grossAmount_header: "Gross Amount",
          grossAmount_placeholder: "Gross Amount",
          taxRate_header: "Tax Rate",
          taxRate_placeholder: "Tax Rate",
          taxAmount_header: "Tax Amount",
          taxAmount_placeholder: "Tax Amount",
          discountAmount_header: "Discount Amount",
          discountAmount_placeholder: "Discount Amount",
          netAmount_header: "Net Amount",
          netAmount_placeholder: "Net Amount",
          totalAmount_header: "Total Amount",
          totalAmount_placeholder: "Total Amount",
          taxTemplate_header: "Tax Template",
          taxTemplate_placeholder: "Select Tax Template",
          location_header: "Location",
          location_placeholder: "Select Location",
          department_header: "Department",
          department_placeholder: "Select Department",
          classification_header: "Classification",
          classification_placeholder: "Select Classification",
          narration_header: "Narration",
          narration_placeholder: "Enter Narration",
          poLine_header: "Purchase Order Line",
          onHand_header: "On Hand",
          remaining_header: "Remaining",
          available_header: "Available",
          traceDetails_header: "Trace Details",
          orderLine_header: "Order Line",
        },
        expense_table: {
          account_header: "Account",
          account_placeholder: "Select Account",
          rate_header: "Rate",
          rate_placeholder: "Enter Rate",
          discountItem_header: "Discount Item",
          discountItem_placeholder: "Select Discount Item",
          discountRate_header: "Discount Rate (%)",
          discountRate_placeholder: "Discount Rate",
          grossAmount_header: "Gross Amount",
          grossAmount_placeholder: "Gross Amount",
          taxRate_header: "Tax Rate",
          taxRate_placeholder: "Tax Rate",
          taxAmount_header: "Tax Amount",
          taxAmount_placeholder: "Tax Amount",
          discountAmount_header: "Discount Amount",
          discountAmount_placeholder: "Discount Amount",
          netAmount_header: "Net Amount",
          netAmount_placeholder: "Net Amount",
          totalAmount_header: "Total Amount",
          totalAmount_placeholder: "Total Amount",
          taxTemplate_header: "Tax Template",
          taxTemplate_placeholder: "Select Tax Template",
          taxCode_header: "Tax Code",
          taxCode_placeholder: "Select Tax Code",
          location_header: "Location",
          location_placeholder: "Select Location",
          department_header: "Department",
          department_placeholder: "Select Department",
          narration_header: "Narration",
          narration_placeholder: "Enter Narration",
        },
        sections: {
          basicDetails: 'Basic Details',
          rentalPeriod: 'Rental Period',
          billing: 'Billing',
          items: 'Items',
          discounts: 'Discounts',
          classification: 'Classification',
          attachment: 'Attachment',
          amount: 'Amount',
          tax: 'Tax',
          shippingAddress: 'Company Shipping Address',
          billingAddress: 'Company Billing Address',
          transportation: 'Transportation'
        },
        msg: {
          delete: 'Order :id has been deleted successfully',
          save: 'Order has been saved successfully',
          update: 'Order :id has been updated successfully',
          requestApproved: "Order has been approved successfully.",
          requestRejected: "Order has been rejected successfully.",
          requestSubmitted: "Order has been submitted for approval",
        },
        tabs: {
          basicDetails: 'Basic Details',
          addressAndContact: 'Address & Contact',
        },
        grn: {
          title: "Goods Receipt",
          add_label: "Goods Receipt Note",
          edit_label: "Edit Goods Receipt Note",
          table: {
            id_header: "ID",
            date_header: "Date",
            vendor_header: "Vendor",
            company_header: "Company",
            currency_header: "Currency",
            referenceNo_header: "Ref. No",
            status_header: "Status",
          },
          msg: {
            save: "Goods Receipt Note saved successfully.",
            delete: "Goods Receipt Note deleted successfully.",
            error: "An error occurred while processing the Goods Receipt Note.",
            itemSave: "Item saved successfully.",
            itemSaveError: "Something went wrong in an item save",
            itemDelete: "Item deleted successfully",
            itemDeleteError: "Something went wrong in an item save",
          },
        },
        traceFields: {
          item_label: "Item",
          location_label: "Location",
          destinationLocation_header: "Destination Location",
          availableQty_header: "Available",
          Qty_header: "Quantity",
          request_header: "Request",
          reserve_header: "Reserve",
          lot_header: "Lot/Serial number",
          lot_placeholder: "Select Lot/Serial number",
          bin_header: "Bin number",
          bin_placeholder: "Select Bin number",
          quantity_header: "Quantity",
          quantity_placeholder: "Enter Quantity",
        },
        deliveryOrder: {
          title: "Delivery Order",
          add_label: "Add Delivery Order",
          edit_label: "Edit Delivery Order",
          tabs: {
            basicDetails: 'Basic Details',
            addressAndContact: 'Address & Contact',
            shipping: "Shipping",
            package: "Packages"
          },
          table: {
            id_header: "ID",
            date_header: "Date",
            vendor_header: "Vendor",
            status_header: "Status",
            location_header: "Location",
            company_header: "Company",
          },
          msg: {
            save: "Delivery Order saved successfully.",
            delete: "Delivery Order deleted successfully.",
            error: "An error occurred while processing the Delivery Order.",
            itemSave: "Item saved successfully.",
            itemSaveError: "Something went wrong in an item save",
            itemDelete: "Item deleted successfully",
            itemDeleteError: "Something went wrong in an item save",
          },
          fields: {
            id_label: "ID",
            id_placeholder: "Enter ID",
            date_label: "Date",
            date_placeholder: "Select Date",
            hireOrderLine_label: "Hire Order Line",
            hireOrderLine_placeholder: "Hire Order Line",
            rentalOrder_label: "Rental Order",
            rentalOrder_placeholder: "Rental Order",
            hireOrder_label: "Hire Order",
            hireOrder_placeholder: "Hire Order",
            customer_label: "Customer",
            customer_placeholder: "Select Customer",
            vendor_label: "Vendor",
            vendor_placeholder: "Select Vendor",
            receipt_label: "Receipt Number",
            receipt_placeholder: "Enter Receipt Number",
            paymentTerms_label: "Payment Terms",
            paymentTerms_placeholder: "Select Payment Terms",
            company_label: "Company",
            company_placeholder: "Select Company",
            expirationDate_label: "Expiration Date",
            expirationDate_placeholder: "Select Date",
            deliveryCommitment_label: "Delivery Commitment Date",
            deliveryCommitment_placeholder: "Select Date",
            currency_label: "Currency",
            currency_placeholder: "Select Currency",
            exchangeRate_label: "Exchange Rate",
            exchangeRate_placeholder: "Enter Exchange Rate",
            salesPerson_label: "Salesperson",
            salesPerson_placeholder: "Select Salesperson",
            referenceNumber_label: "PO Number",
            referenceNumber_placeholder: "Enter PO Number",
            status_label: "Status",
            status_placeholder: "Select Status",
            version_label: "Version Number",
            version_placeholder: "Version Number",
            termsCondition_label: "Terms & Conditions",
            termsCondition_placeholder: "Select Terms & Conditions",
            narration_label: "Narration",
            narration_placeholder: "Write Narration",
            poDate_label: "PO Date",
            poDate_placeholder: "Select Date",
            project_label: "Project",
            project_placeholder: "Enter Project Name",
            receivedBy_label: "Received By",
            receivedBy_placeholder: "Enter Name",

            transportedBy_label: "Trasported By",
            transportedBy_placeholder: "Enter Transportation Company Name",
            driver_label: "Driver",
            driver_placeholder: "Enter Driver Name",
            transportationId_label: "ID",
            transportationId_placeholder: "Enter ID Number",
            vehicleNumber_label: "Vehicle Number",
            vehicleNumber_placeholder: "Enter Vehicle Number",

            startDateTime_label: 'Start Date & Time',
            startDateTime_plcaeholder: 'Select Start Date & Time',
            endDateTime_label: 'End Date & Time',
            endDateTime_plcaeholder: 'Select End Date & Time',
            totalPeriod_label: 'Total Period',
            totalPeriod_plcaeholder: '-',

            billingCycle_label: 'Billing Cycle',
            billingCycle_plcaeholder: 'Select Billing Cycle',
            lastInvoiceDate_label: 'Last Invoice Date',
            lastInvoiceDate_plcaeholder: 'Select Date',
            nextInvoiceDate_label: 'Next Invoice Date',
            nextInvoiceDate_plcaeholder: 'Select Date',

            // Address
            shippingAddress_label: 'Shipping Address',
            shippingAddress_placeholder: 'Select Shipping Address',
            contactPerson_label: 'Contact Person',
            contactPerson_placeholder: 'Select Contact Person',
            billingAddress_label: 'Billing Address',
            billingAddress_placeholder: 'Select Billing Address',
            placeOfSupply_label: 'Place of Supply',
            placeOfSupply_placeholder: 'Select Place of Supply',
            supplier_address_label: 'Supplier Address',
            supplier_address_placeholder: 'Select Supplier Address',

            // Iterm modal
            item_label: 'Item',
            item_placeholder: 'Select Item',
            uom_label: 'UOM',
            uom_placeholder: 'Select UOM',
            description_label: 'Description',
            description_placeholder: 'Enter Description',
            deliveryDate_label: 'Delivery Date',
            deliveryDate_placeholder: 'Enter Delivery Date',
            deliveryCommitmentDate_label: 'Delivery Commitment Date',
            deliveryCommitmentDate_placeholder: 'Enter Delivery Commitment Date',
            expectedShippingDate_label: 'Expected Shipping Date',
            expectedShippingDate_placeholder: 'Enter Expected Shipping Date',
            quantity_label: 'Quantity',
            quantity_placeholder: 'Enter Quantity',
            priceList_label: 'Price List',
            priceList_placeholder: 'Select Price List',
            available_label: 'Available',
            available_placeholder: 'Enter Available Quantity',
            onHand_label: 'On Hand',
            onHand_placeholder: 'Enter On Hand Quantity',
            reserved_label: 'Reserved',
            reserved_placeholder: 'Enter Reserved Quantity',
            remaining_label: 'Remaining',
            remaining_placeholder: 'Enter Remaining Quantity',
            discountItem_label: 'Discount Item',
            discountItem_placeholder: 'Select Discount Item',
            discountRate_label: 'Discount Rate',
            discountRate_placeholder: 'Enter Discount Rate',
            grossAmount_label: 'Gross Amount',
            grossAmount_placeholder: 'Enter Gross Amount',
            taxAmount_label: 'Tax Amount',
            taxAmount_placeholder: 'Enter Tax Amount',
            discountAmount_label: 'Discount Amount',
            discountAmount_placeholder: 'Enter Discount Amount',
            netAmount_label: 'Net Amount',
            netAmount_placeholder: 'Enter Net Amount',
            totalAmount_label: 'Total Amount',
            totalAmount_placeholder: 'Enter Total Amount',
            taxTemplate_label: 'Tax Template',
            taxTemplate_placeholder: 'Select Tax Template',
            location_label: 'Location',
            location_placeholder: 'Select Location',
            department_label: 'Department',
            department_placeholder: 'Select Department',

            postingTime_label: "Posting Time",
            postingTime_placeholder: "HH:MM PM",
            opportunity_label: "Opportunity",
            opportunity_placeholder: "Enter Opportunity",
            contact_person_label: "Contact Person",
            recurring_label: "Recurring",
            recurring_placeholder: "Select Recurring",
            until_date_label: "Untill Date",

            upload_label: "Upload",
            additionalDiscountOn_label: "Apply Additional Discount On",
            additionalDiscountOn_placeholder: "Additional Discount",
            additionalDiscountPercent_label: "Additional Discount Percentage",
            additionalDiscountPercent_placeholder: "Enter Additional dicount in %",
            additionalDiscountAmount_label: "Additional Discount Amount",
            additionalDiscountAmount_placeholder: "Enter Additional Discount Amount",
            additionalDiscount_placeholder: "Additional Discount",
            roundOff_label: "Round off",
            roundOff_placeholder: "Select round off",
            roundOff_amount: "Round Off Amount",
            cashOrNonTrade_label: "Is Cash or Non Trade Discount",
            shippingDate_label: "Expected Shipping Date",
            shippingDate_placeholder: "Select Date",
            shippingRule_label: "Shipping Rule",
            shippingRule_placeholder: "Select Shipping Rule",
            shippingCost_label: "Shipping Cost",
            shippingCost_placeholder: "Enter Shipping Cost",
            handlingCost_label: "Handling Cost",
            handlingCost_placeholder: "Enter Handling Cost",
            handlingTaxTemplate_label: "Handling Tax Template",
            handlingTaxTemplate_placeholder: "Select Handling Tax Template",
            shippingTaxTemplate_label: "Shipping Tax Template",
            shippingTaxTemplate_placeholder: "Select Shipping Tax Template",
            handlingTaxAmount_label: "Handling Tax Amount",
            handlingTaxAmount_placeholder: "Select Handling Tax Amount",
            shippingTaxAmount_label: "Shipping Tax Amount",
            shippingTaxAmount_placeholder: "Enter Shipping Tax Amount",
            incoterm_label: "Incoterm",
            incoterm_placeholder: "Select Incoterm",
            supplierAddress_label: "Supplier Address",
            attachment_label: "Attached files",
          },
          sections: {
            basicDetails: 'Basic Details',
            rentalPeriod: 'Rental Period',
            billing: 'Billing',
            items: 'Items',
            discounts: 'Discounts',
            delivery: 'Delivery',
            classification: 'Classification',
            attachment: 'Attachment',
            amount: 'Amount',
            tax: 'Tax',
            shippingAddress: 'Shipping Address',
            billingAddress: 'Billing Address',
            transportation: 'Transportation',
          },
          item_table: {
            status: 'Order Status',
            salesPerson: 'Salesperson',
            company: 'Company',
            item: 'Item',
            uom: 'UOM',
            description: 'Description',
            quantity: 'Quantity',
            rate: 'Rate',
            available: 'Available',
            onHand: 'On Hand',
            reserved: 'Reserved',
            location: 'Location',
            department: 'Department',
            narration: 'Narration',
            hireOrderLine: 'Hire Order Line',
            remaining: 'Remaining',
            recieptDate: 'Reciept Date',
            refNo: 'Ref. No',
            package: 'Package',
            traceDetails: 'Trace Details'
          },
          package_table: {
            packageName: 'Packaging Name',
            dimentions: 'Dimensions',
            weight: 'Weight',
            packageDetails: 'Package Details',
          },
          packageFields: {
            item_label: "Item",
            sourceLocation_label: "Location",
            available_header: "Available",
            package_header: "Package",
            package_placeholder: "Select Package",
            quantity_header: "Quantity",
            quantity_placeholder: "Enter Quantity",
          },
        }
      },
    },
    agreement: {
      name: " Agreements",
      title: "Agreements",
      subHeading:
        "Efficiently document your expenses and keep your financial records in order.",
      add_label: "Add New Agreement",
      edit_label: "Edit New Agreement",
      view_label: " Agreement Details",
      msg: {
        save: " Agreement saved successfully.",
        delete: " Agreement deleted successfully.",
        error: "An error occurred while processing the  agreement.",
        requestApproved: "Agreement has approved successfully.",
        requestRejected: "Agreement has rejected successfully.",
        requestSubmitted: "Agreement has been submitted for approval",
        validated: "Agreement validated successfully",
        closed: "Agreement closed successfully",
        draft: 'Agreement saved as draft successfully',
        update: 'Agreement :id updated successfully',
      },
      sections: {
        basic_details: "Basic Details",
        items: "Items",
        attachments: "Attachments",
        classification: "Classification",
        rental_period: "Rental Period",
        add_item: "Add Item",
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        name_header: "Name",
        purchase_representative_header: "Purchase Representative",
        vendor_header: "Vendor",
        company_header: "Company",
        valid_header: "Valid Up To",
        status_header: "Status",
      },
      fields: {
        id_label: "ID",
        id_placeholder: "Agreement ID",
        date_label: "Date",
        startDate_label: 'Select Start Date & Time',
        endDate_label: 'Select End Date & Time',
        startDate_placeholder: 'Enter  Date & Time',
        endDate_placeholder: 'Enter  Date & Time',
        date_placeholder: "Select Date",
        total_period_label: "Total Period",
        total_period_placeholder: "Enter Total Period",
        name_label: "Name",
        name_placeholder: "Enter Name",
        type_label: "Agreement Type",
        type_placeholder: "Select Agreement Type",
        vendor_label: "Vendor",
        vendor_placeholder: "Select Vendor",
        purchase_representative_label: "Purchase Representative",
        purchase_representative_placeholder: "Select Purchase Representative",
        valid_up_to_label: "Valid Up To",
        valid_up_to_placeholder: "Select Date",
        company_label: "Company",
        company_placeholder: "Select Company",
        currency_label: "Currency",
        currency_placeholder: "Select Currency",
        payment_terms_label: "Payment Terms",
        payment_terms_placeholder: "Select Payment Terms",
        incoterms_label: "Incomterms",
        incoterms_placeholder: "Select Incoterms",
        instructions_label: "Instructions",
        instructions_placeholder: "Enter Instructions",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        update_vendor_prices_label: "Update Vendor Prices",
        location_label: "Location",
        location_placeholder: "Select Location",
        department_label: "Department",
        department_placeholder: "Select Department",
        view_attachments_label: "View Attached Files",
      },
      item_table: {
        item_name_header: "Item",
        vendor_header: "Vendor Name",
        uom_header: "UoM",
        description_header: "Description",
        specification_header: "Specification",
        rate_header: "Rate",
        min_order_qty_header: "Minimum Order Quantity",
        gross_amount: "Gross Amount",
        duration_label: "Rental Duration Type",
        fields: {
          item_label: "Item",
          item_placeholder: "Select Item",
          vendor_label: "Vendor  Name",
          vendor_placeholder: "Vendor Name",
          uom_label: "UoM",
          uom_placeholder: "Select UoM",
          duration_label: "Rental Duration Type",
          duration_placeholder: "Select Rental Duration Type",
          description_label: "Description",
          description_placeholder: "Enter Description",
          specification_label: "Specification",
          specification_placeholder: "Enter Specification",
          rate_label: "Rate",
          rate_placeholder: "Enter Rate",
          min_order_qty_label: "Minimum Order Quantity",
          min_order_qty_placeholder: "Enter Quantity",
          gross_amount_label: "Gross Amount",
          gross_amount_placeholder: "Gross Amount",
        },
      },
    },
    crossHireRfq: {
      title: "Request for Quote",
      add_label: "Add New Request for Quote",
      add_response_label: "Add New Request for Quote Response",
      edit_label: "Edit Request for Quote",
      edit_response_label: "Edit Request for Quote Response",
      detail_label: "Request for Quote Details",
      previouse_price_msg: "See Previous Prices",
      response_title: "Responses",
      analyze_compare_label: 'Compare',
      analyze_item_label: 'Items List',
      response_received_label: 'Response Received',
      subsidiary_label: "Subsidiary",
      subsidiary_placeholder: "Select Subsidiary",
      search_subsidiary_placeholder: "Search Subsidiary",
      location_label: "Location",
      location_placeholder: "Select Location",
      search_location_placeholder: "Search Location",
      search_item: "Search Item",
      select_item: "Select Item",
      as_of_date: "As of Date",
      alredy_awarded:
        "You have already selected the vendor for this item. Do you want to update the vendor details?",
      warn_awarded:
        "You have already selected other vendor for this item",
      msg: {
        save: "Request for quote saved successfully.",
        delete: "Request for quote deleted successfully.",
        cancel: "Are you sure you want to Cancel",
        error: "An error occurred while processing the Request for quote.",
        tendor: "Call For Tender",
        repsoneSave: "Response for quote saved successfully."
      },
      button: {
        response: "Response",
        order: "Order",
        agreement: "Agreement",
        rfq: "RFQ",
        orders: "Orders",
      },
      tabs: {
        basicDetails: "Basic Details",
        addressAndContact: "Address & Contact",
      },
      sections: {
        generalDetail: "Basic Detail",
        upload: "Attachment",
        classification: "Classification",
        items: "Items",
        discounts: "Discounts",
        call_for_tender: "Call For Tender",
        companyShippibngAddress: "Company Shipping Address",
        companyBillingAddress: "Company Billing Address",
        rental_period: 'Rental Period'
      },
      dropdown: {
        print: "Print RFQ",
        sendEmail: "Send Email",
      },
      fields: {
        id_label: "ID",
        id_placeholder: "ID",
        date_label: "Date",
        date_placeholder: "Select Date",
        copy_product: "Copy Product",
        rfq_id_label: "RFQ ID",
        department_label: "Department",
        department_placeholder: "Select Department",
        orderDeadline_label: "Order Deadline",
        orderDeadline_placeholder: "Select Date",
        expectedRequiredDate_label: "Expected Required Date",
        expectedRequiredDate_placeholder: "Select Date",
        purchaseRepresentavive_label: "Purchase Representative",
        purchaseRepresentavive_placeholder: "Select Purchase Representative",
        paymentTerm_label: "Payment Terms",
        startDate_label: 'Select Start Date & Time',
        startDate_placeholder: 'Enter Date & Time',
        endDate_label: 'Select End Date & Time',
        endDate_placeholder: 'Enter Date & Time',
        total_period_label: 'Total Period',
        total_period_placeholder: 'Enter Total Period',
        paymentTerm_placeholder: "Select Payment Terms",
        referenceNo_label: "Reference No.",
        lead_label: "Lead Time",
        lead_placeholder: "Enter Lead Time",
        referenceNo_placeholder: "Enter Reference No.",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        attachment_label: "Attach your file here",
        supplierAddress_label: "Supplier Address",
        supplierAddress_placeholder: "Select Supplier Address",
        contactPerson_label: "Contact Person",
        contactPerson_placeholder: "Select Contact Person",
        vendor_header: "Vendor",
        purchaseRepresentative_header: "Purchase Representative",
        company_label: "Company",
        company_placeholder: "Select Company",
        location_label: "Location",
        order_deadline_label: "Order Deadline",
        expected_required_date_label: "Expected Required Date",
        currency_label: "Currency",
        currency_placeholder: "Select Currency",
        exchangeRate_label: "Exchange Rate",
        view_attachment_label: "Attached file",
        vendor_label: "Vendor",
        vendor_placeholder: "Select Vendor",
        location_placeholder: "Select Location",
        exchangeRate_placeholder: "Enter Exchange Rate",
        incoterms_label: "Incoterms",
        incoterms_placeholder: "Select Incoterms",
        condition_header: "Condition",
        rate_header: "Rate",
        shippingAddress_label: "Shipping Address",
        shippingAddress_placeholder: "Select Shipping Address",
        billingAddress_label: "Billing Address",
        billingAddress_placeholder: "Select Billing Address",
        placeOfSupply_label: "Place of Supply",
        placeOfSupply_placeholder: "Select Place of Supply",
      },
      table: {
        account_header: "Account",
        available_header: "Available",
        awarded_header: "Awarded",
        backOrdered_header: "Back Ordered",
        classification_header: "Classification",
        company_header: "Company",
        condition_header: "Condition",
        couponCode_header: "Coupon Code",
        currency_label: "Currency",
        customer_header: "Customer",
        date_header: "Date",
        duration_label: "Rental Duration Type",
        requested_duration_label: "Requested Rental Duration Type",
        vendor_duration_label: "Vendor Rental Duration Type",
        delivered_header: "Delivered",
        deliveryStatus_header: "Delivery Status",
        department_header: "Department",
        description_header: "Description",
        description_header_placeholder: "Enter Description",
        discountAmount_header: "Discount Amount",
        discountedAmount_header: "Discount Amount",
        discountItem_header: "Discounted Item",
        discountRate_header: "Discount Rate",
        estimated_quantity_header: "Estimated Order Quantity Per Year",
        estimated_quantity_Placeholder: "Enter Order Quantity",
        expected_required_date_header: "Expected Required Date",
        expectedRequiredDate_label: "Expected Required Date",
        expectedShippingDate_header_placeholder: "Select Expected Required Date",
        grossAmount_header: "Gross Amount",
        gross_amount_header: "Gross Amount",
        id_header: "ID",
        invoiceStatus_header: "Invoice Status",
        invoiced_header: "Invoiced",
        item_header: "Item",
        item_header_placeholder: "Select Item",
        lead_time_header: "Lead Time",
        location_header: "Location",
        minimum_order_quantity: "Minimum Order Quantity",
        narration_header: "Narration",
        narration_header_placeholder: "Enter Narration",
        netAmount_header: "Net Amount",
        notes_header: "Notes",
        onHand_header: "On Hand",
        orderDeadline_label: "Order Deadline",
        promotionAmount_header: "Promotion Amount / %",
        promotion_amount_header: "Promotion Amount",
        purchase_order_header: "Cross Hire Order",
        purchaseRepresentavive_label: "Purchase Representative",
        quantity_header: "Quantity",
        quantity_header_placeholder: "Enter Quantity",
        rate_header: "Rate",
        rate_header_placeholder: "Enter Rate",
        rate_in_base_currency: "Rate In Base Currency",
        rate_in_foreign_currency: "Rate In Foreign Currency",
        referenceNo_header: "Reference No.",
        rental_duration_type: "Requested Rental Duration",
        rental_duration: "Requested Rental Duration Type",
        requested_quanity_header: "Requested Quantity",
        requested_quanity_placeholder: 'Enter Requested Quantity',
        requested_uom_header: "Requested UoM",
        reserved_header: "Reserved",
        response_date_header: "Response Date",
        response_id_header: "Response ID",
        response_message_header: "Response Message",
        rfq_header: "RFQ ID",
        salesperson_header: "Salesperson",
        salesOrderStatus_header: "Sales Order Status",
        specification_header: "Specification",
        status_header: "Status",
        taxAmount_header: "Tax Amount",
        taxTemplate_header: "Tax Template",
        totalAmount_header: "Total Amount",
        type_header: "Type",
        uom_header: "UoM",
        uom_header_placeholder: "Select UOM",
        vendor_header: "Vendor",
        vendor_id_header: "Vendor ID",
        vendor_name_header: "Vendor Name",
        vendor_uom_header: "Vendor UoM",
        add_item: "Add Item",
        add_comment: "Add Comment",
        comment: "Comment",
        comment_placeholder: "Enter Comment",

      }
    },
    purchaseOrder: {
      title: "Purchase Order",
      add_label: "Add New Purchase Order",
      edit_label: "Edit Purchase Order",
      msg: {
        save: "Purchase order saved successfully.",
        delete: "Purchase order deleted successfully.",
        error: "An error occurred while processing the Purchase order.",
        itemSave: "Item saved successfully.",
        itemSaveError: "Something went wrong in an item save",
        itemDelete: "Item deleted successfully",
        itemDeleteError: "Something went wrong in an item save",
        requestApproved: "Purchase Order has been approved successfully.",
        requestRejected: "Purchase Order has been rejected successfully.",
        requestSubmitted: "Purchase Order has been submitted for approval",
        requiredItemsError: "Please fill required field in items",
        requiredError: "Please fill atleast one field",
        allRequiredError: "Please fill all the required fields",
        requiredItemExpenseError: "Please add at least one item or expense",
        confirmDeleteItem: "Are you sure you want to delete item?",
        confirmDeleteExpense: "Are you sure you want to delete expense?",
        confirmDeleteEntry: "Are you sure you want to delete entry?",
        confirmUpdate: "Are you sure you want to update status?"
      },
      sections: {
        items: "Items",
        attachment: "Attachment",
        companyShippibngAddress: "Company Shipping Address",
        companyBillingAddress: "Company Billing Address",
        classification: "Classification",
        discounts: "Discounts",
        subtotal: "Subtotal",
        taxesAndCharges: "Taxes and Charges",
        total: "Totals",
      },
      fields: {
        id_label: "ID",
        id_placeholder: "Purchase Order ID",
        poId_label: "Purchase Order",
        grnId_label: "ID",
        grnId_placeholder: "ID",
        date_label: "Date",
        date_placeholder: "Select Date",
        supplier_label: "Supplier",
        supplier_placeholder: "Select Supplier",
        vendor_label: "Vendor",
        vendor_placeholder: "Select Vendor",
        company_label: "Company",
        company_placeholder: "Select Company",
        location_label: "Location",
        location_placeholder: "Select Location",
        confirmation_label: "Confirmation Date",
        confirmation_placehodler: "Select Date",
        expectedReceipt_label: "Expected Receipt Date",
        expectedReceipt_placehodler: "Select Date",
        agreement_label: "Agreement",
        agreement_placeholder: "Select Agreement",
        currency_label: "Currency",
        currency_placeholder: "Select Currency",
        exchangeRate_label: "Exchange Rate",
        exchangeRate_placeholder: "0.00",
        paymentTerm_label: "Payment Terms",
        paymentTerm_placeholder: "Select Payment Terms",
        purchaseRepresentavive_label: "Purchase Representative",
        purchaseRepresentavive_placeholder: "Select Purchase Representative",
        referenceNo_label: "Reference No.",
        referenceNo_placeholder: "Enter Reference No.",
        incoTerm_label: "Incoterm",
        incoTerm_placeholder: "Select Incoterm",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        department_label: "Department",
        department_placeholder: "Select Department",
        attachment_label: "Attach your file here",
        attachedFile_label: "Attached File",

        supplierAddress_label: "Supplier Address",
        supplierAddress_placeholder: "Select Supplier Address",

        contactPerson_label: "Contact Person",
        contactPerson_placeholder: "Select Contact Person",

        shippingAddress_label: "Shipping Address",
        shippingAddress_placeholder: "Select Shipping Address",
        billingAddress_label: "Billing Address",
        billingAddress_placeholder: "Select Billing Address",
        placeOfSupply_label: "Place of Supply",
        placeOfSupply_placeholder: "Select Place of Supply",

        totalQty_label: "Total Quantity",
        total_label: "Total (INR)",
        itemDiscount_label: "Item Discount",
        additionalDiscount_label: "Additional Discount",
        totalDiscount_label: "Total Discount",
        subtotalExcludingTaxes_label: "Subtotal Excluding Taxes",
        subtotalExcludingDiscount_label: "Subtotal Excluding Discount",
        taxesAndChargesAdded_label: "Taxes & Charges Added",
        taxesAndChargesDeducted_label: "Taxes & Charges Deducted",
        totalTaxesAndChargesAdded_label: "Total Taxes and Charges Added",
        grandTotal_label: "Grand Total",
        roundOffDifference_label: "Round Off Difference",

        tax_code_label: "Tax Code",
        tax_rate_label: "Tax Rate",
        amount_label: "Amount",
        tax_label: "Tax",
        classification: "Classification",

        add_item_label: "Add Item",
        update_status_label: "Update Status"

      },
      table: {
        id_header: "ID",
        date_header: "Date",
        referenceNo_header: "Reference No.",
        confirmationDate_header: "Confirmation Date",
        vendor_header: "Vendor",
        purchaseRepresentative_header: "Purchase Representative",
        company_header: "Company",
        expectedReceipt_header: "Expected Receipt Date",
        totalValue_header: "Total Value",
        status_header: "Status",
        billingStatus_header: "Billing Status",
        receivingStatus_header: "Receiving Status",
      },
      item_table: {
        item_header: "Item",
        item_placeholder: "Select Item",
        landedCost_header: "Is Landed Cost",
        vendor_header: "Vendor Item Name",
        vendor_placeholder: "Enter Vendor Item Name",
        uom_header: "UoM",
        uom_placeholder: "Select UoM",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        description_header: "Description",
        description_placeholder: "Enter Description",
        rate_header: "Rate",
        rate_placeholder: "Enter Rate",
        discountItem_header: "Discount Item",
        discountItem_placeholder: "Select Discount Item",
        discountRate_header: "Discount Rate (%)",
        discountRate_placeholder: "Discount Rate",
        grossAmount_header: "Gross Amount",
        grossAmount_placeholder: "Gross Amount",
        taxRate_header: "Tax Rate",
        taxRate_placeholder: "Tax Rate",
        taxAmount_header: "Tax Amount",
        taxAmount_placeholder: "Tax Amount",
        discountAmount_header: "Discount Amount",
        discountAmount_placeholder: "Discount Amount",
        netAmount_header: "Net Amount",
        netAmount_placeholder: "Net Amount",
        totalAmount_header: "Total Amount",
        totalAmount_placeholder: "Total Amount",
        taxTemplate_header: "Tax Template",
        taxTemplate_placeholder: "Select Tax Template",
        location_header: "Location",
        location_placeholder: "Select Location",
        department_header: "Department",
        department_placeholder: "Select Department",
        classification_header: "Classification",
        classification_placeholder: "Select Classification",
        narration_header: "Narration",
        narration_placeholder: "Enter Narration",
        poLine_header: "Purchase Order Line",
        onHand_header: "On Hand",
        remaining_header: "Remaining",
        available_header: "Available",
        traceDetails_header: "Trace Details",
      },
      expense_table: {
        title: "Expense Detail",
        account_header: "Account",
        amount: "Amount",
        account_placeholder: "Select Account",
        rate_header: "Rate",
        rate_placeholder: "Enter Rate",
        discountItem_header: "Discount Item",
        discountItem_placeholder: "Select Discount Item",
        discountRate_header: "Discount Rate (%)",
        discountRate_placeholder: "Discount Rate",
        grossAmount_header: "Gross Amount",
        grossAmount_placeholder: "Gross Amount",
        taxRate_header: "Tax Rate",
        taxRate_placeholder: "Tax Rate",
        taxAmount_header: "Tax Amount",
        taxAmount_placeholder: "Tax Amount",
        discountAmount_header: "Discount Amount",
        discountAmount_placeholder: "Discount Amount",
        netAmount_header: "Net Amount",
        netAmount_placeholder: "Net Amount",
        totalAmount_header: "Total Amount",
        totalAmount_placeholder: "Total Amount",
        taxTemplate_header: "Tax Template",
        taxTemplate_placeholder: "Select Tax Template",
        taxCode_header: "Tax Code",
        taxCode_placeholder: "Select Tax Code",
        location_header: "Location",
        location_placeholder: "Select Location",
        department_header: "Department",
        department_placeholder: "Select Department",
        narration_header: "Narration",
        narration_placeholder: "Enter Narration",
      },
      bills_table: {
        id_header: "ID",
        date_header: "Date",
        totalValue_header: "Total Value",
        status_header: "Status",
        paymentStatus_header: "Payment Status",
      },
      tabs: {
        basicDetails: "Basic Details",
        addressAndContact: "Address & Contact",
      },
      itemsTabs: {
        itemEntries: "Item Entries",
        expensed: "Expenses",
      },
      grn: {
        title: "Goods Receipt",
        add_label: "Goods Receipt Note",
        edit_label: "Edit Goods Receipt Note",
        table: {
          id_header: "ID",
          date_header: "Date",
          vendor_header: "Vendor",
          company_header: "Company",
          currency_header: "Currency",
          referenceNo_header: "Ref. No",
          status_header: "Status",
        },
        msg: {
          save: "Goods Receipt Note saved successfully.",
          delete: "Goods Receipt Note deleted successfully.",
          error: "An error occurred while processing the Goods Receipt Note.",
          itemSave: "Item saved successfully.",
          itemSaveError: "Something went wrong in an item save",
          itemDelete: "Item deleted successfully",
          itemDeleteError: "Something went wrong in an item save",
          quantityError: "Quantity must be less than the remaining quantity",
          updateItemError: "Something went wrong while updating item",
          tracibility_message: "Changing the quantity or item will remove traceability data. Do you want to proceed?",
          traceability_success: "Traceability is Completed.",
          serialError: "This serial Number is already available",
          lotError: "This lot Number is already available",
          trackingDetailsError: "Please add the tracking details",
          trackingDetailsUpdateError: "Something went wrong in tracking updates",
          validateTrackingError: "Please add the tracking details to validate",
          grnScrapError: "Something went wrong in GRN Scrap"
        },
      },
      bills: {
        title: "Bills",
      },
      traceFields: {
        traceability: "Traceability",
        traceDetails_header: "Trace Details",
        item_label: "Item",
        location_label: "Location",
        destinationLocation_header: "Destination Location",
        availableQty_header: "Available",
        Qty_header: "Quantity",
        request_header: "Request",
        reserve_header: "Reserve",
        lot_header: "Lot/Serial number",
        lot_placeholder: "Select Lot/Serial number",
        bin_header: "Bin number",
        bin_placeholder: "Select Bin number",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        add_lot_label: "Add Lot Number",
        type_label: "Type",
        type_placeholder: "Select Lot Number",
        lot_label: "Lot Number",
        lot_enter_placeholder: "Enter Lot Number",
        bin_label: "Bin",
        bin_add_placeholder: "Select Bin"
      },
      buttons: {
        receive: "Receive",
        grn: "GRN",
        return: "Return",
        bill: "Bill",
        printGRN: 'Print GRN',
        printLabel: 'Print Label',
        grns: "GRNs",
        bills: "Bills",
        returns: "Returns"
      }
    },
    requestForQuote: {
      title: "Request for Quote",
      add_label: "Add New Request for Quote",
      add_response_label: "Add New Request for Quote Response",
      edit_label: "Edit Request for Quote",
      edit_response_label: "Edit Request for Quote Response",
      detail_label: "Request for Quote Details",
      previouse_price_msg: "See Previous Prices",
      response_title: "Responses",
      call_for_tender: "Call For Tender",
      select_company: "Select Company",
      select_assembly: "Select Assembly Item",
      select_warehouse: "Select warehouse",
      select_bom: "Select BoM",
      filter: "Filter",
      date_range: " Date Range:",
      date: "Date:",
      company: "Company:",
      assembly: "Assembly Items",
      location: "Location:",
      item: "Item:",
      bom: "BOM:",
      filter_by: "Filter By",
      clear_filter: "Clear Filter",
      sort: "Sort",
      add_item: "Add Item",
      edit_item: "Edit Item",
      add_commnent: "Add Comment",
      comment: "Comment",
      filterByResponseDate: "Filter By Response Date",
      alredy_awarded:
        "You have already selected the vendor for this item. Do you want to update the vendor details?",
      warn_awarded:
        "You have already selected other vendor for this item",
      msg: {
        save: "Request for quote saved successfully.",
        delete: "Request for quote deleted successfully.",
        cancel: "Are you sure you want to Cancel",
        error: "An error occurred while processing the Request for quote.",
        tendor: "Call For Tender",
        repsoneSave: "Response for quote saved successfully.",
        req_field_err: "Please fill atleast one field",
        delete_item: "Are you sure you want to delete item ?",
        delete_tender: "Are you sure you want to delete tender ?",
        all_field_err: "Please fill all the required fields.",
        update_status: "Update Status",
        update_status_msg: "Are you sure you want to update status?",
        enter_comment: 'Please enter a comment',
      },
      button: {
        response: "Response",
        order: "Order",
        agreement: "Agreement",
        rfq: "RFQ",
        orders: "Orders",
      },
      tabs: {
        basicDetails: "Basic Details",
        addressAndContact: "Address & Contact",
      },
      sections: {
        generalDetail: "Basic Detail",
        upload: "Attachment",
        classification: "Classification",
        items: "Items",
        discounts: "Discounts",
        call_for_tender: "Call For Tender",
        companyShippibngAddress: "Company Shipping Address",
        companyBillingAddress: "Company Billing Address",
      },
      dropdown: {
        print: "Print RFQ",
        sendEmail: "Send Email",
      },
      fields: {
        id_label: "ID",
        id_placeholder: "ID",
        date_label: "Date",
        date_placeholder: "Select Date",
        copy_product: "Copy Product",
        rfq_id_label: "RFQ ID",
        department_label: "Department",
        department_placeholder: "Select Department",
        orderDeadline_label: "Order Deadline",
        orderDeadline_placeholder: "Select Date",
        expectedRequiredDate_label: "Expected Required Date",
        expectedRequiredDate_placeholder: "Select Date",
        purchaseRepresentavive_label: "Purchase Representative",
        purchaseRepresentavive_placeholder: "Select Purchase Representative",
        paymentTerm_label: "Payment Terms",
        paymentTerm_placeholder: "Select Payment Terms",
        referenceNo_label: "Reference No.",
        lead_label: "Lead Time",
        lead_placeholder: "Enter Lead Time",
        referenceNo_placeholder: "Enter Reference No.",
        narration_label: "Narration",
        narration_placeholder: "Enter Narration",
        attachment_label: "Attach your file here",
        supplierAddress_label: "Supplier Address",
        supplierAddress_placeholder: "Select Supplier Address",
        contactPerson_label: "Contact Person",
        contactPerson_placeholder: "Select Contact Person",
        vendor_header: "Vendor",
        purchaseRepresentative_header: "Purchase Representative",
        company_label: "Company",
        company_placeholder: "Select Company",
        location_label: "Location",
        order_deadline_label: "Order Deadline",
        expected_required_date_label: "Expected Required Date",
        currency_label: "Currency",
        currency_placeholder: "Select Currency",
        exchangeRate_label: "Exchange Rate",
        view_attachment_label: "Attached file",
        vendor_label: "Vendor",
        vendor_placeholder: "Select Vendor",
        location_placeholder: "Select Location",
        exchangeRate_placeholder: "Enter Exchange Rate",
        incoterms_label: "Incoterms",
        incoterms_placeholder: "Select Incoterms",
        condition_header: "Condition",
        rate_header: "Rate",
        shippingAddress_label: "Shipping Address",
        shippingAddress_placeholder: "Select Shipping Address",
        billingAddress_label: "Billing Address",
        billingAddress_placeholder: "Select Billing Address",
        placeOfSupply_label: "Place of Supply",
        placeOfSupply_placeholder: "Select Place of Supply",
        search_company: 'Search Company',
        filter_by_company: 'Filter by Company',
        search_vendor: 'Search Vendor',
        filter_by_vendor: 'Filter by Vendor',
        search_items: 'Search Items',
        filter_by_items: 'Filter by Items',
        search_vendor_uom: 'Search Vendor UoM',
        filter_by_vendor_uom: 'Filter by Vendor UoM',
        search_currency: 'Search Currency',
        filter_by_currency: 'Filter by Currency',
        search_rfq: 'Search RFQ',
        filter_by_rfq: 'Filter by RFQ',
      },
      table: {
        id_header: "ID",
        date_header: "Date",
        awarded_header: "Awarded",
        purchaseRepresentavive_label: "Purchase Representative",
        customer_header: "Customer",
        salesOrderStatus_header: "Sales Order Status",
        invoiceStatus_header: "Invoice Status",
        deliveryStatus_header: "Delivery Status",
        salesperson_header: "Salesperson",
        company_header: "Company",
        item_header: "Item",
        item_header_placeholder: "Select Item",
        orderDeadline_label: "Order Deadline",
        expectedRequiredDate_label: "Expected Required Date",
        uom_header: "UoM",
        requested_uom_header: "Requested UoM",
        vendor_uom_header: "Vendor UoM ",
        notes_header: "Notes",
        currency_label: "Currency",
        minimum_order_quantity: "Minimum Order Quantity",
        uom_header_placeholder: "Select UOM",
        description_header: "Description",
        description_header_placeholder: "Enter Description",
        expected_required_date_header: "Expected Required Date",
        expectedShippingDate_header_placeholder:
          "Select Expected Required Date",
        quantity_header: "Quantity",
        quantity_header_placeholder: "Enter Quantity",
        rate_header: "Rate",
        rate_header_placeholder: "Enter Rate",
        available_header: "Available",
        onHand_header: "On Hand",
        reserved_header: "Reserved",
        backOrdered_header: "Back Ordered",
        invoiced_header: "Invoiced",
        delivered_header: "Delivered",
        grossAmount_header: "Gross Amount",
        discountItem_header: "Discounted Item",
        discountedAmount_header: "Discount Amount",
        discountRate_header: "Discount Rate",
        netAmount_header: "Net Amount",
        taxTemplate_header: "Tax Template",
        taxAmount_header: "Tax Amount",
        totalAmount_header: "Total Amount",
        location_header: "Location",
        department_header: "Department",
        narration_header: "Narration",
        gross_amount_header: "Gross Amount",
        couponCode_header: "Coupon Code",
        account_header: "Account",
        type_header: "Type",
        promotionAmount_header: "Promotion Amount / %",
        promotion_amount_header: "Promotion Amount",
        discountAmount_header: "Discount Amount",
        referenceNo_header: "Reference No.",
        vendor_header: "Vendor",
        status_header: "Status",
        purchase_order_header: "Cross Hire Order",
        specification_header: "Specification",
        requested_quanity_header: "Requested Quantity",
        estimated_quantity_header: "Estimated Order Quantity Per Year",
        classification_header: "Classification",
        rfq_header: "RFQ ID",
        condition_header: "Condition",
        response_id_header: "Response ID",
        response_date_header: "Response Date",
        lead_time_header: "Lead Time",
        response_message_header: "Response Message",
        vendor_id_header: "Vendor ID",
        vendor_name_header: "Vendor Name",
        rate_in_base_currency: "Rate In Base Currency",
        rate_in_foreign_currency: "Rate In Foreign Currency",
      },
      item_table: {
        item_header: "Item",
        item_placeholder: "Select Item",
        landedCost_header: "Is Landed Cost",
        purchase_order: "Cross Hire Order",
        vendor_header: "Vendor Item Name",
        vendor_placeholder: "Enter Vendor Item Name",
        uom_header: "UoM",
        requested_uom: "Requested UoM",
        requested_uom_placeholder: "Select Requested UoM",
        vendor_uom: "Vendor UoM",
        vendor_uom_placeholder: "Select Vendor UoM",
        specification: "Specification",
        specification_placeholder: "Enter Specification",
        uom_placeholder: "Select UoM",
        quantity_header: "Quantity",
        quantity_placeholder: "Enter Quantity",
        description_header: "Description",
        description_placeholder: "Enter Description",
        requested_quantity_header: "Requested Quantity",
        requested_quantity_placeholder: "Enter Requested Quantity",
        estimated_quantity_per_year_header: "Estimated Quantity Per Year",
        estimated_quantity_per_year_placeholder: "Enter Estimated Quantity Per Year",
        rate_header: "Rate",
        rate_placeholder: "Enter Rate",
        min_order_quantity_header: "Minimum Order Quantity",
        min_order_quantity_placeholder: "Enter Minimum Order Quantity",
        discountItem_header: "Discount Item",
        discountItem_placeholder: "Select Discount Item",
        discountRate_header: "Discount Rate (%)",
        discountRate_placeholder: "Discount Rate",
        grossAmount_header: "Gross Amount",
        grossAmount_placeholder: "Gross Amount",
        taxRate_header: "Tax Rate",
        taxRate_placeholder: "Tax Rate",
        taxAmount_header: "Tax Amount",
        taxAmount_placeholder: "Tax Amount",
        discountAmount_header: "Discount Amount",
        discountAmount_placeholder: "Discount Amount",
        netAmount_header: "Net Amount",
        netAmount_placeholder: "Net Amount",
        totalAmount_header: "Total Amount",
        totalAmount_placeholder: "Total Amount",
        taxTemplate_header: "Tax Template",
        taxTemplate_placeholder: "Select Tax Template",
        location_header: "Location",
        location_placeholder: "Select Location",
        department_header: "Department",
        department_placeholder: "Select Department",
        classification_header: "Classification",
        classification_placeholder: "Select Classification",
        narration_header: "Narration",
        narration_placeholder: "Enter Narration",
        poLine_header: "Purchase Order Line",
        onHand_header: "On Hand",
        remaining_header: "Remaining",
        available_header: "Available",
        traceDetails_header: "Trace Details",
        condition_header: "Conditions",
      },
    },



  },
  common: {
    added_successfully: "added successfully",
    party: {
      sections: {
        basic_details: "Basic Details",
        address: 'Address',
        contact: 'Contact',
      },
      fields: {
        firstName_label: "First Name",
        firstName_placeholder: "Enter First Name",
        lastName_label: "Last Name",
        lastName_placeholder: "Enter Last Name",
        company_label: "Company",
        company_placeholder: "Enter Company Name",
        currency_label: "Currency",
        currency_placeholder: "Select Currency",
      },
      msg: {
        success: 'has been saved successfully',
        error: 'Something went wrong.'
      },
      table: {
        addressType_header: "Address Type",
        addressee_header: "Addressee",
        defaultShippingAddress_header: "Default shipping address",
        defaultBillingAddress_header: "Default Billing address",
        countryCode_header: "Country Code",
        contactNumber_header: "Contact Number",
        addrressOne_header: "Address 1",
        addressTwo_header: "Address 2",
        addressThree_header: "Address 3",
        zipCode_header: "Zip Code",
        city_header: "City",
        state_header: "State",
        country_header: "Country",
        summary_header: "Summary",
        name_header: "Name",
        email_header: "Email",
      }
    },
    dateRange: 'Date Range',
    startDate: 'Start Date',
    endDate: 'End Date',
    summary: "Summary",
    total: "Total",
    include_year: "Include Year",
    include_zeros: "Include Zeros",
    activity: "Activity",
    add: "Add",
    edit: "Edit",
    save: "Save",
    remove: "Remove",
    delete: "Delete",
    proceed: "Proceed",
    noData: "No Data",
    company: "Company",
    error: 'Error',
    msg: {
      created: "created",
      updated: "updated",
      deleted: "deleted",
      error: 'Something went wrong.'
    },
    item: 'Item',
    send_email: "Send Email",
    allAttributes_label: "All Attributes",
    addCustomField_label: "Add Custom Field",
    addColumn_label: "Add Column",
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    open: "Open",
    closed: "Closed",
    start_time: "Start Time",
    end_time: "End Time",
    active: "Active",
    apply: "Apply",
    inActive: "Inactive",
    deleteMsg: "Are you sure you want to delete",
    confirmMsg: "Are you sure you want to",
    new: "New",
    submitForApproval: "Submit for Approval",
    quickApproval: "Quick Approval",
    duplicate: "Duplicate",
    actions: "Actions",
    summary_view: 'Summery View',
    // reports: 'Reports',
    edit_report: ' Edit Report',
    detail_view: 'Detail View',
    submit: "Submit",
    reSubmit: "Re-Submit",
    accept: "Accept",
    select: "Select",
    reject: "Reject",
    release: "Release",
    scrap: "Scrap",
    cancel: "Cancel",
    close: "Close",
    create: "Create",
    view: "View",
    next: "Next",
    logs: "Logs",
    addLog: "Add New Log",
    validate: "Validate",
    order: "Order",
    rfq: "RFQ",
    upload: "Upload",
    print: "Print",
    email: "Email",
    sendEmail: "Send Email",
    sendRequest: "Send Request",
    quick_approval: "Quick Approval",
    send_request: "Send Request",
    convert: "Convert",
    emailSuccess: 'Email sent successfully',
    emailFailed: "We are not able to send the email",
    sendByEmail: "Send By Email",
    downloadReportFailed: "We are not able to download the report",
    delete_msg: "Are you sure you want to delete item ?",
    createInvoice: "Create Invoice",
    generatePickingList: 'Generate Picking List',
    classification: "Classification",
    description: "Description",
    description_placeholder: "Enter Description",
    source_type: {
      title: "Source Types",
      create_new_source_type: "Create New Source Type",
      source_type_name: "Source Type Name",
      enter_source_type_name: "Enter source type name",
      enter_description_optional: "Enter description (optional)",
      create_source_type: "Create Source Type",
      source_type_name_required: "Source type name is required",
      source_type_name_max: "Source type name must be at most 255 characters",
      description_max: "Description must be at most 1000 characters",
      error_creating_source_type: "Error creating source type",
      source_type_header: "Source Type",
      description: "Description",
      description_placeholder: "Enter description",
      edit_source_type: "Edit Source Type",
      view_source_type: "View Source Type",
      delete_source_type: "Delete Source Type",
      source_type_not_found: "Source type not found",
      source_type_deleted_successfully: "Source type deleted successfully",
      source_type_updated_successfully: "Source type updated successfully",
      source_type_created_successfully: "Source type created successfully",
      status: "Status",
      active: "Active",
      inactive: "Inactive",
    },
    location: "Location",
    export: "Export",
    import: "Import",
    refresh: "Refresh",
    department: "Department",
    name: "Name",
    name_placeholder: "Enter Name",
    email_placeholder: "Enter Email",
    contact_no: "Contact Number",
    date: "Date",
    date_placeholder: "Select Date",
    time: "Time",
    time_placeholder: "Select Time",
    packed: "Packed",
    picked: "Picked",
    dispatched: "Dispatched",
    delivered: "Delivered",
    activities_label: "Activities",
    viewed_text: "viewed",
    deleted_text: "deleted",
    updated_text: "updated",
    created_text: "created",
    enabled: "Enabled",
    disabled: "Disabled",
    discard: "Discard",
    update: "Update",
    search: "Search",
    download_report: "Download Report",
    view_more: "View More",
    add_new_log: "Add New Log",
    view_quotation: "View Quotation",
    make_quotation: "Make Quotation",
    view_sales_pipeline: "View Sales Pipeline",
    buttons: {
      saveAsDraft_label: "Save To Draft",
      discard_label: "Discard",
      save_label: "Save",
      next_label: "Next",
      yes: "Yes",
      update_label: "Update",
      back_label: "Back",
      edit_label: "Edit",
    },
    field: {
      narration: "Narration",
      narration_placeholder: "Enter Narration",
    },
    filter: "Filter",
    filters: "Filters",
    saveFilter: "Save Filter",
    clearFilter: "Clear Filter",
    select_filter: "Select Filter",
    search_filter: "Search Filter",
    value: 'Enter Value',
    status: 'Status',
    show: 'Show',
    hide: 'Hide',
    subtasks: 'Subtasks',
    request: 'Request',
    billOfMaterial: 'Bill Of Material',
    view_payment_entry: 'View Payment Entry',
    setting: 'Setting',
    id: 'ID',
    draft: 'Draft',
    modify: "Modify",
    date_range: " Date Range:",
    assembly: "Assembly Items",
    bom: "BOM:",
    sort: "Sort",
    filterByResponseDate: "Filter by response date",
    confirmation: "Confirmation",
    conditions: "Conditions",
    all_field_err: "Please fill all the required fields.",
    package: "Package",
    lot_header: "Lot/Serial number",
    tax_code: "Tax Code",
    tax_rate: "Tax Rate",
    expense_detail: "Expense Detail",
    amount: "Amount",
    tax: "Tax",
    traceability: "Traceability",
    traceability_message: "Changing the quantity or item will remove traceability data. Do you want to proceed?",
    add_lot_label: "Add Lot Number",
    type_label: "Type",
    type_placeholder: "Select Lot Number",
    lot_label: "Lot Number",
    lot_enter_placeholder: "Enter Lot Number",
    bin_label: "Bin",
    bin_add_placeholder: "Select Bin",
    add_item: "Add Item",
    apply_promotion: "Apply Promotions",
    rental_order: "Rental Order",
    replacement_order: "Replacement Order",
    replacement_quotation: "Replacement Quotation",
    logout: "Logout",
    submit_for_approval: "Submit For Approval",
    dashboard: "Dashboard",
    sales_forecast: "Sales Forecast",
    orders: "Orders",
    lead: "Lead",
    opportunity: "Opportunity",
    quotation: "Quotation",
    sales_orders: "Sales Orders",
    delivery_orders: "Delivery Orders",
    customer_returns: "Customer Returns",
    settings: "Settings",
    shipping_rule: "Shipping Rule",
    promotions: "Promotions",
    customer_segments: "Customer Segments",
    delivery_settings: "Delivery Settings",
    forms: "Forms",
    user: "User",
    roles: "Roles",
    work_flow_automation: "WorkFlow Automation",
    localization: "Localization",
    journal_entry: "Journal Entry",
    payment_entry: "Payment Entry",
    payment: "Payment",
    collection: "Collection",
    payment_request: "Payment Request",
    invoice: "Invoice",
    bills: "Bills",
    invoices: "Invoices",
    cash_expense: "Cash Expense",
    credits: "Credits",
    debit_notes: "Debit Notes",
    credit_notes: "Credit Notes",
    expense: "Expense",
    expense_reimbursement: "Expense Reimbursement",
    expense_report: "Expense Report",
    commissions: "Commissions",
    commission_setup: "Commission Setup",
    commission_plan: "Commission Plan",
    commission_target: "Target",
    commission_assignment: "Commission Assignment",
    commission: "Commission",
    authorize_commission: "Authorize Commission",
    month_wise_commission: "Month Wise Commission",
    fixed_asset_management: "Fixed Asset Management",
    assets_management: "Assets Management",
    asset_transfer: "Asset Transfer",
    budget: "Budget",
    audits: "Audits",
    master_data: "Master Data",
    customer_management: "Customer Management",
    vendor_management: "Vendor Management",
    // reports: "Reports",
    balance_sheet: "Balance Sheet",
    general_ledger: "General Ledger",
    cashflow: "Cashflow",
    profit_and_loss: "Profit And Loss",
    tax_report: "Tax Report",
    trial_balance: "Trial Balance",
    aged_payable: "Aged Payable",
    vat_report: "VAT Report",
    aged_receivable: "Aged Receivable",
    depreciation_schedule: "Depreciation Schedule",
    journal_report: "Journal Report",
    shareholder_report: "Shareholder Report",
    schedule_report: "Schedule Report",
    chart_of_accounts: "Chart Of Accounts",
    currency: "Currency",
    journal_types:"Journal Types",
    currency_exchange: "Currency Exchange",
    tax_category: "Tax Category",
    // tax_code: "Tax Code",
    tax_template: "Tax Template",
    bank: "Bank",
    bank_account: "Bank Account",
    reconciliation: "Reconciliation",
    fiscal_year: "Fiscal Year",
    payment_terms: "Payment Terms",
    tax_group: "Tax group",
    product_management: "Product Management",
    itme: "Item",
    item_category: "Item Category",
    discounted_itme: "Discounted Item",
    configuration: "Configuration",
    attributes: "Attributes",
    // location: "Location",
    bins: "Bins",
    uom: "UOM",
    operations: "Operations",
    stock_transfer: "Stock Transfer",
    bin_transfer: "Bin Transfer",
    // scrap: "Scrap",
    inventory_adjustment: "Inventory Adjustment",
    sales: "Sales",
    purchase: "Purchase",
    // reports: "Reports",
    inventory_valuation: "Inventory Valuation",
    stock_status: "Stock Status",
    reorder: "Reorder",
    stock_movement: "Stock Movement",
    expiry_date: "Expiry Date",
    requests: "Requests",
    purchase_agreements: "Purchase Agreements",
    // orders: "Orders",
    request_for_quote: "Request For Quote",
    purchase_orders: "Purchase Orders",
    vendor_return_authorization: "Vendor Return Authorization",
    // delivery_orders: "Delivery Orders",
    landed_cost: "Landed Cost",
    reports: "Reports",
    gate_register: "Gate Register",
    bill_of_material: "Bill Of Material",
    demand_planning: "Demand Planning",
    job_cards: "Job Cards",
    plans: "Plans",
    production_plans: "Production Plans",
    slit_plans: "Slit Plans",
    scaffolding_plans: "Scaffolding Plans",
    // orders: "Orders",
    work_order: "Work Order",
    to_build: "To Build",
    unbuild_order: "Unbuild Order",
    manage_operations: "Manage Operations",
    items: "Items",
    operation_blocks: "Operation Blocks",
    equipment_failure: "Equipment Failure",
    completion_report: "Completion Report",
    component_where_used: "Component Where Used",
    bom_inquiry: "BOM Inquiry",
    factory_daily_consumption: "Factory Daily Consumption",
    cost_rollup: "Cost Rollup",
    scrap_report: "Scrap Report",
    // operations: "Operations",
    work_centres: "Work Centres",
    equipments: "Equipments",
    work_centre_categories: "Work Centre Categories",
    routing: "Routing",
    wip_settings: "WIP Settings",
    itmes: "Items",
    category: "Category",
    invoicing: "Invoicing",
    invoicing_rental_order: "Invoicing Rental Order",
    previous_jobs: "Previous Jobs",
    rental: "Rental",
    leads: "Leads",
    quotations: "Quotations",
    agreements: "Agreements",
    cross_hire: "Cross Hire",
    cross_hire_requests: "Cross Hire Requests",
    process_cross_hire: "Process Cross Hire",
    billing_cycle: "Billing Cycle",
    terms_and_conditions: "Terms & Conditions",
    cross_hire_overview: "Cross Hire Overview",
    rental_payment_aging_report: "Payment Aging Report",
    rental_asset_return_report: "Asset Return Report",
    rental_agreement_detail_report: "Order Detail Report",
    asset_category_performance_report: "Asset Category Performance Report",
    rental_cancellations_amendments_report: "Cancellations Report",
    active_rentals_report: "Active Rentals Report",
    rental_agreement_report: "Agreement Report",
    upcoming_expiry_report: "Upcoming Expiry Report",
    rental_revenue_report: "Revenue Report",
    asset_availability_report: "Asset Availability Report",
    asset_utilization_report: "Asset Utilization Report",
    customer_rental_report: "Customer Rental Report",
    template: "Template",
    reset_type: "Reset Type",
    sales_settings: "Sales Settings",
    module_label_filter: "Module",
    all: "All",
    voucher_settings_configuration: "Voucher Settings Configuration",
    print_sales_quotation:"Print Sales Quotation",
    print_rental_quotation:"Print Rental Quotation",
    print_proforma_invoice:"Print Proforma Invoice",
  },
  template_editor: {
    name: "Template Editor",
    title: "Email Template Editor",
    canvas: {
      drop_here_label: "Drop here",
      drag_sections_label: "Drag Sections from side panel to start building the",
      header_label: "Header",
      content_label: "Content",
      footer_label: "Footer",
    },
    html_editor: {
      title: "HTML Source Editor",
      subtitle: "changes will replace current sections",
      apply_button: "Apply",
      cancel_button: "Cancel",
    },
    header: {
      cancel_editing_button: "Cancel Editing",
      save_button: "Save",
      preview_button: "Preview",
      edit_html_button: "Edit HTML",
    },
    section: {
      save_button: "Save",
      cancel_button: "Cancel",
      delete_button: "Delete",
      split_button: "Split",
    },
    modal: {
      company_selection: {
        title: "Select Company",
        cancel_button: "Cancel",
        continue_button: "Continue",
      },
      template_name: {
        title: "Template Name",
        name_label: "Name",
        name_placeholder: "Enter template name",
        cancel_button: "Cancel",
        save_button: "Save",
      },
      edit_section: {
        title: "Edit Section",
        cancel_button: "Cancel",
        save_button: "Save",
      },
    },
    msg: {
      template_saved: "Template saved successfully",
      template_deleted: "Template deleted successfully",
      template_error: "Something went wrong while saving template",
      unsaved_changes: "You have unsaved changes. Do you want to save before leaving?",
    },
  }
};

export default en_resource;
